/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: XTAvGJPchvtf

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { DataProvider } from "@plasmicpkgs/plasmic-basic-components";
import Logo from "../../Logo"; // plasmic-import: 2Sac1UHK8925/component
import { AntdTabs } from "@plasmicpkgs/antd5/skinny/registerTabs";
import { AntdTabItem } from "@plasmicpkgs/antd5/skinny/registerTabs";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicHomeProductsSection.module.css"; // plasmic-import: XTAvGJPchvtf/css

import G782Icon from "./icons/PlasmicIcon__G782"; // plasmic-import: MMRz7C213ZtM/icon
import Path842Icon from "./icons/PlasmicIcon__Path842"; // plasmic-import: if2ZBI6-mCRt/icon
import G942Icon from "./icons/PlasmicIcon__G942"; // plasmic-import: qQqra4akk1UG/icon
import G902Icon from "./icons/PlasmicIcon__G902"; // plasmic-import: NIASMtAHey5J/icon
import Xmlid6613Icon from "./icons/PlasmicIcon__Xmlid6613"; // plasmic-import: KfBLqrnqkh7K/icon
import Xmlid7308Icon from "./icons/PlasmicIcon__Xmlid7308"; // plasmic-import: Rc8q4cS6TRtw/icon
import Xmlid6615Icon from "./icons/PlasmicIcon__Xmlid6615"; // plasmic-import: 0tD2p8PYECMq/icon
import Xmlid7443Icon from "./icons/PlasmicIcon__Xmlid7443"; // plasmic-import: iF8_3kA9Wb9q/icon
import Xmlid6614Icon from "./icons/PlasmicIcon__Xmlid6614"; // plasmic-import: NrjMSUE48Q7-/icon
import Xmlid7347Icon from "./icons/PlasmicIcon__Xmlid7347"; // plasmic-import: H5UzqZGnQ6c9/icon
import Xmlid7207Icon from "./icons/PlasmicIcon__Xmlid7207"; // plasmic-import: DpRijowJYOcb/icon
import Icon91Icon from "./icons/PlasmicIcon__Icon91"; // plasmic-import: Eto7rfXCGRus/icon
import Icon84Icon from "./icons/PlasmicIcon__Icon84"; // plasmic-import: FiW4QWmFBSGC/icon
import Group15Icon from "./icons/PlasmicIcon__Group15"; // plasmic-import: sngXPatVLZFN/icon
import VectorIcon from "./icons/PlasmicIcon__Vector"; // plasmic-import: p59FhsiOKrqv/icon
import Group17Icon from "./icons/PlasmicIcon__Group17"; // plasmic-import: it9muy_gitMY/icon
import Icon87Icon from "./icons/PlasmicIcon__Icon87"; // plasmic-import: kRk_Xh2G2HnQ/icon
import Wave1Icon from "./icons/PlasmicIcon__Wave1"; // plasmic-import: 3mJHowbx7rSQ/icon
import Wave41Icon from "./icons/PlasmicIcon__Wave41"; // plasmic-import: DIg8uO9h9sg6/icon
import Icon83Icon from "./icons/PlasmicIcon__Icon83"; // plasmic-import: xO0x_ObqZEpK/icon

createPlasmicElementProxy;

export type PlasmicHomeProductsSection__VariantMembers = {};
export type PlasmicHomeProductsSection__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomeProductsSection__VariantsArgs;
export const PlasmicHomeProductsSection__VariantProps =
  new Array<VariantPropType>();

export type PlasmicHomeProductsSection__ArgsType = {};
type ArgPropType = keyof PlasmicHomeProductsSection__ArgsType;
export const PlasmicHomeProductsSection__ArgProps = new Array<ArgPropType>();

export type PlasmicHomeProductsSection__OverridesType = {
  productsSection?: Flex__<"section">;
  productsProvider?: Flex__<typeof DataProvider>;
  desktopWrapper?: Flex__<"div">;
  intro2?: Flex__<"div">;
  header9?: Flex__<"div">;
  top3?: Flex__<"div">;
  subtitle?: Flex__<"div">;
  title?: Flex__<"div">;
  body6?: Flex__<"div">;
  col4?: Flex__<"div">;
  nav?: Flex__<"div">;
  img2?: Flex__<"div">;
  logoIcon?: Flex__<"div">;
  logo7?: Flex__<typeof Logo>;
  logo2?: Flex__<typeof Logo>;
  logo3?: Flex__<typeof Logo>;
  productTabs?: Flex__<typeof AntdTabs>;
  content?: Flex__<"div">;
  placeholder?: Flex__<"div">;
  intro?: Flex__<"div">;
  col?: Flex__<"div">;
  logo?: Flex__<typeof Logo>;
  text53?: Flex__<"div">;
  title23?: Flex__<"div">;
  desc?: Flex__<"div">;
  img?: Flex__<"div">;
  img6?: Flex__<"div">;
  areas?: Flex__<"div">;
  header10?: Flex__<"div">;
  title11?: Flex__<"div">;
  body7?: Flex__<"div">;
  frame22?: Flex__<"div">;
  item17?: Flex__<"div">;
  title12?: Flex__<"div">;
  desc7?: Flex__<"div">;
  item18?: Flex__<"div">;
  title13?: Flex__<"div">;
  desc2?: Flex__<"div">;
  item19?: Flex__<"div">;
  title14?: Flex__<"div">;
  desc3?: Flex__<"div">;
  item20?: Flex__<"div">;
  title15?: Flex__<"div">;
  desc4?: Flex__<"div">;
  item21?: Flex__<"div">;
  title16?: Flex__<"div">;
  desc5?: Flex__<"div">;
  item22?: Flex__<"div">;
  title17?: Flex__<"div">;
  desc6?: Flex__<"div">;
  footnote?: Flex__<"div">;
  bodyWrapper6?: Flex__<"div">;
  intro4?: Flex__<"div">;
  col7?: Flex__<"div">;
  logo9?: Flex__<typeof Logo>;
  text44?: Flex__<"div">;
  title27?: Flex__<"div">;
  desc9?: Flex__<"div">;
  img4?: Flex__<"div">;
  bg3?: Flex__<"div">;
  xmlid7457?: Flex__<"div">;
  xmlid6776?: Flex__<"div">;
  xmlid7433?: Flex__<"div">;
  xmlid7339?: Flex__<"div">;
  alert3?: Flex__<"div">;
  icon20?: Flex__<"div">;
  content3?: Flex__<"div">;
  text45?: Flex__<"div">;
  icon21?: Flex__<"div">;
  credits?: Flex__<"div">;
  header20?: Flex__<"div">;
  subtitle5?: Flex__<"div">;
  title28?: Flex__<"div">;
  main6?: Flex__<"div">;
  mockupCmeCredits?: Flex__<"div">;
  table?: Flex__<"div">;
  col8?: Flex__<"div">;
  mockupTableCellText?: Flex__<"div">;
  text46?: Flex__<"div">;
  mockupTableCellAvatar?: Flex__<"div">;
  mockupTableCellAvatar2?: Flex__<"div">;
  mockupTableCellAvatar3?: Flex__<"div">;
  col9?: Flex__<"div">;
  mockupTableCellText2?: Flex__<"div">;
  text47?: Flex__<"div">;
  mockupTableCellText3?: Flex__<"div">;
  text48?: Flex__<"div">;
  mockupTableCellText4?: Flex__<"div">;
  text49?: Flex__<"div">;
  mockupTableCellText5?: Flex__<"div">;
  text50?: Flex__<"div">;
  col10?: Flex__<"div">;
  mockupTableCellText6?: Flex__<"div">;
  text51?: Flex__<"div">;
  mockupTableCellText7?: Flex__<"div">;
  text52?: Flex__<"div">;
  mockupTableCellText8?: Flex__<"div">;
  text57?: Flex__<"div">;
  mockupTableCellText9?: Flex__<"div">;
  text58?: Flex__<"div">;
  col11?: Flex__<"div">;
  mockupTableCellText10?: Flex__<"div">;
  text59?: Flex__<"div">;
  mockupTableCellText11?: Flex__<"div">;
  text60?: Flex__<"div">;
  mockupTableCellText12?: Flex__<"div">;
  text70?: Flex__<"div">;
  mockupTableCellText13?: Flex__<"div">;
  text71?: Flex__<"div">;
  mockupButton7?: Flex__<"div">;
  link10?: Flex__<"div">;
  certificate?: Flex__<"div">;
  top5?: Flex__<"div">;
  mockupCertificateIcon?: Flex__<"div">;
  bg4?: Flex__<"div">;
  group1?: Flex__<"div">;
  paper1?: Flex__<"div">;
  paper2?: Flex__<"div">;
  cert?: Flex__<"div">;
  award491?: Flex__<"div">;
  overlay?: Flex__<"div">;
  title29?: Flex__<"div">;
  mockupTextPlaceholder?: Flex__<"div">;
  mockupTextPlaceholderParagraph?: Flex__<"div">;
  mockupTextPlaceholderLine?: Flex__<"div">;
  mockupTextPlaceholderContent37?: Flex__<"div">;
  placeholder38?: Flex__<"div">;
  mockupTextPlaceholderLine2?: Flex__<"div">;
  mockupTextPlaceholderContent38?: Flex__<"div">;
  placeholder39?: Flex__<"div">;
  mockupTextPlaceholderLine3?: Flex__<"div">;
  mockupTextPlaceholderContent39?: Flex__<"div">;
  placeholder40?: Flex__<"div">;
  mockupTextPlaceholderLine4?: Flex__<"div">;
  mockupTextPlaceholderContent40?: Flex__<"div">;
  placeholder41?: Flex__<"div">;
  mockupTextPlaceholderLine5?: Flex__<"div">;
  mockupTextPlaceholderContent41?: Flex__<"div">;
  placeholder42?: Flex__<"div">;
  mockupTextPlaceholderParagraph2?: Flex__<"div">;
  mockupTextPlaceholderLine6?: Flex__<"div">;
  mockupTextPlaceholderContent42?: Flex__<"div">;
  placeholder43?: Flex__<"div">;
  mockupTextPlaceholderLine7?: Flex__<"div">;
  mockupTextPlaceholderContent43?: Flex__<"div">;
  placeholder44?: Flex__<"div">;
  mockupTextPlaceholderLine8?: Flex__<"div">;
  mockupTextPlaceholderContent44?: Flex__<"div">;
  placeholder45?: Flex__<"div">;
  mockupTextPlaceholderLine9?: Flex__<"div">;
  mockupTextPlaceholderContent45?: Flex__<"div">;
  placeholder46?: Flex__<"div">;
  mockupTextPlaceholderLine10?: Flex__<"div">;
  mockupTextPlaceholderContent46?: Flex__<"div">;
  placeholder47?: Flex__<"div">;
  mockupTextPlaceholderLine11?: Flex__<"div">;
  mockupTextPlaceholderContent47?: Flex__<"div">;
  placeholder48?: Flex__<"div">;
  mockupTextPlaceholderLine12?: Flex__<"div">;
  mockupTextPlaceholderContent48?: Flex__<"div">;
  placeholder49?: Flex__<"div">;
  mockupTextPlaceholderLine13?: Flex__<"div">;
  mockupTextPlaceholderContent49?: Flex__<"div">;
  placeholder50?: Flex__<"div">;
  mockupTextPlaceholderParagraph3?: Flex__<"div">;
  mockupTextPlaceholderLine14?: Flex__<"div">;
  mockupTextPlaceholderContent50?: Flex__<"div">;
  placeholder51?: Flex__<"div">;
  mockupTextPlaceholderLine15?: Flex__<"div">;
  mockupTextPlaceholderContent15?: Flex__<"div">;
  placeholder52?: Flex__<"div">;
  mockupTextPlaceholderLine16?: Flex__<"div">;
  mockupTextPlaceholderContent16?: Flex__<"div">;
  placeholder53?: Flex__<"div">;
  mockupTextPlaceholderLine17?: Flex__<"div">;
  mockupTextPlaceholderContent17?: Flex__<"div">;
  placeholder54?: Flex__<"div">;
  mockupTextPlaceholderLine18?: Flex__<"div">;
  mockupTextPlaceholderContent18?: Flex__<"div">;
  placeholder55?: Flex__<"div">;
  mockupTextPlaceholderParagraph4?: Flex__<"div">;
  mockupTextPlaceholderLine19?: Flex__<"div">;
  mockupTextPlaceholderContent19?: Flex__<"div">;
  placeholder19?: Flex__<"div">;
  mockupTextPlaceholderLine20?: Flex__<"div">;
  mockupTextPlaceholderContent20?: Flex__<"div">;
  placeholder20?: Flex__<"div">;
  mockupTextPlaceholderLine21?: Flex__<"div">;
  mockupTextPlaceholderContent21?: Flex__<"div">;
  placeholder21?: Flex__<"div">;
  mockupTextPlaceholderLine22?: Flex__<"div">;
  mockupTextPlaceholderContent22?: Flex__<"div">;
  placeholder22?: Flex__<"div">;
  mockupTextPlaceholderLine23?: Flex__<"div">;
  mockupTextPlaceholderContent23?: Flex__<"div">;
  placeholder23?: Flex__<"div">;
  mockupTextPlaceholderLine24?: Flex__<"div">;
  mockupTextPlaceholderContent24?: Flex__<"div">;
  placeholder24?: Flex__<"div">;
  mockupTextPlaceholderLine25?: Flex__<"div">;
  mockupTextPlaceholderContent25?: Flex__<"div">;
  placeholder25?: Flex__<"div">;
  mockupTextPlaceholderLine26?: Flex__<"div">;
  mockupTextPlaceholderContent26?: Flex__<"div">;
  placeholder26?: Flex__<"div">;
  mockupButton8?: Flex__<"div">;
  link11?: Flex__<"div">;
  alert2?: Flex__<"div">;
  icon22?: Flex__<"div">;
  check2?: Flex__<"div">;
  content4?: Flex__<"div">;
  report?: Flex__<"div">;
  bill?: Flex__<"div">;
  header21?: Flex__<"div">;
  subtitle9?: Flex__<"div">;
  title30?: Flex__<"div">;
  main7?: Flex__<"div">;
  placeholder27?: Flex__<"div">;
  header22?: Flex__<"div">;
  title31?: Flex__<"div">;
  date?: Flex__<"div">;
  section?: Flex__<"div">;
  head?: Flex__<"div">;
  mockupTextPlaceholderParagraph5?: Flex__<"div">;
  mockupTextPlaceholderLine27?: Flex__<"div">;
  mockupTextPlaceholderContent27?: Flex__<"div">;
  placeholder28?: Flex__<"div">;
  mockupTextPlaceholderLine28?: Flex__<"div">;
  mockupTextPlaceholderContent28?: Flex__<"div">;
  placeholder29?: Flex__<"div">;
  mockupTextPlaceholderLine29?: Flex__<"div">;
  mockupTextPlaceholderContent29?: Flex__<"div">;
  placeholder30?: Flex__<"div">;
  mockupTextPlaceholderLine30?: Flex__<"div">;
  mockupTextPlaceholderContent30?: Flex__<"div">;
  placeholder31?: Flex__<"div">;
  mockupTextPlaceholderLine31?: Flex__<"div">;
  mockupTextPlaceholderContent31?: Flex__<"div">;
  placeholder32?: Flex__<"div">;
  total?: Flex__<"div">;
  title32?: Flex__<"div">;
  val6?: Flex__<"div">;
  section2?: Flex__<"div">;
  head2?: Flex__<"div">;
  mockupTextPlaceholderParagraph6?: Flex__<"div">;
  mockupTextPlaceholderLine32?: Flex__<"div">;
  mockupTextPlaceholderContent32?: Flex__<"div">;
  placeholder33?: Flex__<"div">;
  mockupTextPlaceholderLine33?: Flex__<"div">;
  mockupTextPlaceholderContent33?: Flex__<"div">;
  placeholder34?: Flex__<"div">;
  mockupTextPlaceholderLine34?: Flex__<"div">;
  mockupTextPlaceholderContent34?: Flex__<"div">;
  placeholder35?: Flex__<"div">;
  mockupTextPlaceholderLine35?: Flex__<"div">;
  mockupTextPlaceholderContent35?: Flex__<"div">;
  placeholder36?: Flex__<"div">;
  mockupTextPlaceholderLine36?: Flex__<"div">;
  mockupTextPlaceholderContent36?: Flex__<"div">;
  placeholder37?: Flex__<"div">;
  total2?: Flex__<"div">;
  title34?: Flex__<"div">;
  val7?: Flex__<"div">;
  edge?: Flex__<"div">;
  tri?: Flex__<"div">;
  rect?: Flex__<"div">;
  tri2?: Flex__<"div">;
  rect2?: Flex__<"div">;
  tri3?: Flex__<"div">;
  rect3?: Flex__<"div">;
  tri4?: Flex__<"div">;
  rect4?: Flex__<"div">;
  tri5?: Flex__<"div">;
  rect5?: Flex__<"div">;
  tri6?: Flex__<"div">;
  rect6?: Flex__<"div">;
  tri7?: Flex__<"div">;
  rect7?: Flex__<"div">;
  tri8?: Flex__<"div">;
  rect8?: Flex__<"div">;
  tri9?: Flex__<"div">;
  rect9?: Flex__<"div">;
  tri10?: Flex__<"div">;
  rect10?: Flex__<"div">;
  tri11?: Flex__<"div">;
  rect11?: Flex__<"div">;
  tri12?: Flex__<"div">;
  rect12?: Flex__<"div">;
  tri13?: Flex__<"div">;
  rect13?: Flex__<"div">;
  tri14?: Flex__<"div">;
  rect14?: Flex__<"div">;
  tri15?: Flex__<"div">;
  rect15?: Flex__<"div">;
  tri16?: Flex__<"div">;
  rect16?: Flex__<"div">;
  tri17?: Flex__<"div">;
  rect17?: Flex__<"div">;
  tri18?: Flex__<"div">;
  rect18?: Flex__<"div">;
  tri19?: Flex__<"div">;
  rect19?: Flex__<"div">;
  tri20?: Flex__<"div">;
  rect20?: Flex__<"div">;
  tri21?: Flex__<"div">;
  rect21?: Flex__<"div">;
  tri22?: Flex__<"div">;
  rect22?: Flex__<"div">;
  tri23?: Flex__<"div">;
  rect23?: Flex__<"div">;
  tri24?: Flex__<"div">;
  rect24?: Flex__<"div">;
  tri25?: Flex__<"div">;
  rect25?: Flex__<"div">;
  tri26?: Flex__<"div">;
  rect26?: Flex__<"div">;
  tri27?: Flex__<"div">;
  rect27?: Flex__<"div">;
  tri28?: Flex__<"div">;
  rect28?: Flex__<"div">;
  tri29?: Flex__<"div">;
  rect29?: Flex__<"div">;
  tri30?: Flex__<"div">;
  rect30?: Flex__<"div">;
  tri31?: Flex__<"div">;
  rect31?: Flex__<"div">;
  tri32?: Flex__<"div">;
  rect32?: Flex__<"div">;
  shade3?: Flex__<"div">;
  features3?: Flex__<"div">;
  title33?: Flex__<"div">;
  figmaPaste2?: Flex__<"div">;
  contentsItem10?: Flex__<"div">;
  icon23?: Flex__<"div">;
  text61?: Flex__<"div">;
  contentsItem11?: Flex__<"div">;
  icon24?: Flex__<"div">;
  text62?: Flex__<"div">;
  contentsItem12?: Flex__<"div">;
  icon25?: Flex__<"div">;
  text63?: Flex__<"div">;
  contentsItem13?: Flex__<"div">;
  icon26?: Flex__<"div">;
  text64?: Flex__<"div">;
  contentsItem14?: Flex__<"div">;
  icon27?: Flex__<"div">;
  text65?: Flex__<"div">;
  contentsItem15?: Flex__<"div">;
  icon28?: Flex__<"div">;
  text66?: Flex__<"div">;
  contentsItem16?: Flex__<"div">;
  icon29?: Flex__<"div">;
  text67?: Flex__<"div">;
  contentsItem17?: Flex__<"div">;
  icon30?: Flex__<"div">;
  text68?: Flex__<"div">;
  bodyWrapper5?: Flex__<"div">;
  intro3?: Flex__<"div">;
  col5?: Flex__<"div">;
  logo8?: Flex__<typeof Logo>;
  text?: Flex__<"div">;
  title18?: Flex__<"div">;
  desc8?: Flex__<"div">;
  img3?: Flex__<"div">;
  bg2?: Flex__<"div">;
  reimbursement?: Flex__<"div">;
  header11?: Flex__<"div">;
  subtitle4?: Flex__<"div">;
  title19?: Flex__<"div">;
  main4?: Flex__<"div">;
  placeholder16?: Flex__<"div">;
  row?: Flex__<"div">;
  prop?: Flex__<"div">;
  label10?: Flex__<"div">;
  val?: Flex__<"div">;
  prop2?: Flex__<"div">;
  label11?: Flex__<"div">;
  val2?: Flex__<"div">;
  mockupProgressBarWithTitle?: Flex__<"div">;
  header12?: Flex__<"div">;
  title20?: Flex__<"div">;
  val3?: Flex__<"div">;
  bar?: Flex__<"div">;
  value?: Flex__<"div">;
  demographics?: Flex__<"div">;
  demographics2?: Flex__<"div">;
  header13?: Flex__<"div">;
  subtitle7?: Flex__<"div">;
  title4?: Flex__<"div">;
  main5?: Flex__<"div">;
  placeholder17?: Flex__<"div">;
  row2?: Flex__<"div">;
  header14?: Flex__<"div">;
  name6?: Flex__<"div">;
  error?: Flex__<"div">;
  tip?: Flex__<"div">;
  label3?: Flex__<"div">;
  link6?: Flex__<"div">;
  row6?: Flex__<"div">;
  header15?: Flex__<"div">;
  name7?: Flex__<"div">;
  error2?: Flex__<"div">;
  tip2?: Flex__<"div">;
  label4?: Flex__<"div">;
  link7?: Flex__<"div">;
  row7?: Flex__<"div">;
  header16?: Flex__<"div">;
  name8?: Flex__<"div">;
  error3?: Flex__<"div">;
  tip3?: Flex__<"div">;
  label5?: Flex__<"div">;
  link8?: Flex__<"div">;
  shade2?: Flex__<"div">;
  cap?: Flex__<"div">;
  header17?: Flex__<"div">;
  subtitle8?: Flex__<"div">;
  title21?: Flex__<"div">;
  main3?: Flex__<"div">;
  placeholder18?: Flex__<"div">;
  field?: Flex__<"div">;
  label6?: Flex__<"div">;
  select?: Flex__<"div">;
  input?: Flex__<"div">;
  leftIcon?: Flex__<"div">;
  text25?: Flex__<"div">;
  rightIcon?: Flex__<"div">;
  row5?: Flex__<"div">;
  prop3?: Flex__<"div">;
  label7?: Flex__<"div">;
  val4?: Flex__<"div">;
  prop4?: Flex__<"div">;
  label8?: Flex__<"div">;
  val5?: Flex__<"div">;
  profile3?: Flex__<"div">;
  av3?: Flex__<"div">;
  col6?: Flex__<"div">;
  top4?: Flex__<"div">;
  header18?: Flex__<"div">;
  name9?: Flex__<"div">;
  status3?: Flex__<"div">;
  label9?: Flex__<"div">;
  body8?: Flex__<"div">;
  year3?: Flex__<"div">;
  name5?: Flex__<"div">;
  actions3?: Flex__<"div">;
  mockupButton5?: Flex__<"div">;
  link9?: Flex__<"div">;
  mockupButton6?: Flex__<"div">;
  link5?: Flex__<"div">;
  menu2?: Flex__<"div">;
  header19?: Flex__<"div">;
  title22?: Flex__<"div">;
  icon8?: Flex__<"div">;
  list?: Flex__<"div">;
  item23?: Flex__<"div">;
  text26?: Flex__<"div">;
  item24?: Flex__<"div">;
  text4?: Flex__<"div">;
  item25?: Flex__<"div">;
  text27?: Flex__<"div">;
  item26?: Flex__<"div">;
  text28?: Flex__<"div">;
  item27?: Flex__<"div">;
  text29?: Flex__<"div">;
  item28?: Flex__<"div">;
  text30?: Flex__<"div">;
  item29?: Flex__<"div">;
  text31?: Flex__<"div">;
  item30?: Flex__<"div">;
  text32?: Flex__<"div">;
  item31?: Flex__<"div">;
  text33?: Flex__<"div">;
  item32?: Flex__<"div">;
  text34?: Flex__<"div">;
  alert?: Flex__<"div">;
  icon9?: Flex__<"div">;
  content2?: Flex__<"div">;
  text35?: Flex__<"div">;
  icon10?: Flex__<"div">;
  features?: Flex__<"div">;
  title5?: Flex__<"div">;
  figmaPaste?: Flex__<"div">;
  contentsItem?: Flex__<"div">;
  icon11?: Flex__<"div">;
  text36?: Flex__<"div">;
  contentsItem2?: Flex__<"div">;
  icon12?: Flex__<"div">;
  text37?: Flex__<"div">;
  contentsItem3?: Flex__<"div">;
  icon13?: Flex__<"div">;
  text38?: Flex__<"div">;
  contentsItem4?: Flex__<"div">;
  icon14?: Flex__<"div">;
  text39?: Flex__<"div">;
  contentsItem5?: Flex__<"div">;
  icon15?: Flex__<"div">;
  text5?: Flex__<"div">;
  contentsItem6?: Flex__<"div">;
  icon16?: Flex__<"div">;
  text40?: Flex__<"div">;
  contentsItem7?: Flex__<"div">;
  icon17?: Flex__<"div">;
  text41?: Flex__<"div">;
  contentsItem8?: Flex__<"div">;
  icon18?: Flex__<"div">;
  text42?: Flex__<"div">;
  contentsItem9?: Flex__<"div">;
  icon19?: Flex__<"div">;
  text43?: Flex__<"div">;
  mobileWrapper?: Flex__<"div">;
  header?: Flex__<"div">;
  top?: Flex__<"div">;
  subtitle2?: Flex__<"div">;
  title2?: Flex__<"div">;
  body?: Flex__<"div">;
};

export interface DefaultHomeProductsSectionProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomeProductsSection__RenderFunc(props: {
  variants: PlasmicHomeProductsSection__VariantsArgs;
  args: PlasmicHomeProductsSection__ArgsType;
  overrides: PlasmicHomeProductsSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "accordion",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0
      },
      {
        path: "productTabs.activeKey",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "1"
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"productsSection"}
      data-plasmic-override={overrides.productsSection}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.productsSection
      )}
    >
      <DataProvider
        data-plasmic-name={"productsProvider"}
        data-plasmic-override={overrides.productsProvider}
        className={classNames("__wab_instance", sty.productsProvider)}
        data={[
          {
            product: "myEvaluations",
            header:
              "System integrating evaluations, milestones, EPAs, quizzes, schedules and more.",
            title: "Experience the Future of Medical Education Management",
            subtitle:
              "MyEvaluations revolutionizes medical training management with streamlined scheduling, patient logs, clinical hour compliance, and custom evaluations. Its efficient workflow and secure, accessible platform save time, resources, and paper, while enabling comprehensive reports and early intervention alerts for improved training outcomes.",
            bulletPoints: {
              bulletpointsLeft: [
                "Evaluations, Milestones & EPAs",
                "Performance Improvement Plans & Clinical Learning Contracts",
                "Scheduling and Compliance",
                "Educational Compliance",
                "ACGME Compliance Tracking"
              ],
              bulletpointsRight: [
                "Curriculum Management",
                "MyQuiz & Learning Assignments",
                "Procedure & Patient Logging",
                "Return Demonstrations",
                "Administrative Tools"
              ]
            }
          },
          {
            product: "myCme",
            header:
              "CME management from credit tracking to critical report generation.",
            title: "Unified Solution To Manage, Track, and Report CME Credits",
            subtitle:
              "MyCME facilitates the fulfilment of CME requirements. Organizations can automate PARS reports and maintain cross-departmental financial records. In turn, faculty members gain a unified system for tracking evaluations and reporting MOC to various boards supported by the ACCME.",
            bulletPoints: {
              bulletpointsLeft: [
                "Live & Durable Event Scheduling",
                "CME Certificate Management"
              ],
              bulletpointsRight: [
                "ACCME Connectivity to PARS",
                "Event Financial Management"
              ]
            }
          },
          {
            product: "myGme",
            header:
              "Fiscal management including submitting work-hour data to Medicare",
            title: "Step Into a World of Simplified GME Financial Management",
            subtitle:
              "My GME Fiscal utilizes data from MyEvaluations for precise fiscal management, particularly in Medicare reimbursements. With features like Master Rotation Schedules, Gap and Overlap Analysis, and detailed reports, it provides comprehensive oversight. Use it to ensure accurate submissions and gain unhindered access to critical information.",
            bulletPoints: {
              bulletpointsLeft: [
                "Reimbursement & Cost Reporting",
                "IRIS/STAR Export",
                "Billing & Invoicing",
                "FTE Reports & CAP Analysis"
              ],
              bulletpointsRight: [
                "Audit Management",
                "Errors & Omissions Analysis",
                "MyQuickPass Integration"
              ]
            }
          }
        ]}
        name={"products"}
      >
        <DataCtxReader__>
          {$ctx => (
            <React.Fragment>
              {(
                hasVariant(globalVariants, "mobile", "mobile")
                  ? false
                  : hasVariant(globalVariants, "mobile", "tabletPortrait")
                    ? false
                    : true
              ) ? (
                <div
                  data-plasmic-name={"desktopWrapper"}
                  data-plasmic-override={overrides.desktopWrapper}
                  className={classNames("all", sty.desktopWrapper)}
                >
                  <div
                    data-plasmic-name={"intro2"}
                    data-plasmic-override={overrides.intro2}
                    className={classNames("all", sty.intro2)}
                  >
                    <div
                      data-plasmic-name={"header9"}
                      data-plasmic-override={overrides.header9}
                      className={classNames("all", sty.header9)}
                    >
                      <div
                        data-plasmic-name={"top3"}
                        data-plasmic-override={overrides.top3}
                        className={classNames("all", sty.top3)}
                      >
                        <div
                          data-plasmic-name={"subtitle"}
                          data-plasmic-override={overrides.subtitle}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.subtitle
                          )}
                        >
                          {"One Integrated Platform"}
                        </div>
                        <div
                          data-plasmic-name={"title"}
                          data-plasmic-override={overrides.title}
                          className={classNames("all", "__wab_text", sty.title)}
                        >
                          {
                            "Technology That Strengthens Educational Conversations"
                          }
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"body6"}
                        data-plasmic-override={overrides.body6}
                        className={classNames("all", "__wab_text", sty.body6)}
                      >
                        {
                          "MyEvaluations unifies every aspect of medical education within a single platform, connecting assessments, competency management, curriculum, scheduling, institutional reporting, and compliance. By eliminating fragmented systems and disconnected information, institutions gain actionable insight to support Continuous Educational Improvement."
                        }
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"col4"}
                      data-plasmic-override={overrides.col4}
                      className={classNames("all", sty.col4)}
                    >
                      <div
                        data-plasmic-name={"nav"}
                        data-plasmic-override={overrides.nav}
                        className={classNames("all", sty.nav)}
                      >
                        <div
                          data-plasmic-name={"img2"}
                          data-plasmic-override={overrides.img2}
                          className={classNames("all", sty.img2)}
                        >
                          <div
                            data-plasmic-name={"logoIcon"}
                            data-plasmic-override={overrides.logoIcon}
                            className={classNames("all", sty.logoIcon)}
                          >
                            <G782Icon
                              className={classNames("all", sty.svg___2Yksr)}
                              role={"img"}
                            />

                            <Path842Icon
                              className={classNames("all", sty.svg___5T1BX)}
                              role={"img"}
                            />

                            <G942Icon
                              className={classNames("all", sty.svg___7Mr1Q)}
                              role={"img"}
                            />

                            <G902Icon
                              className={classNames("all", sty.svg__pPbKl)}
                              role={"img"}
                            />

                            <G902Icon
                              className={classNames("all", sty.svg__c1Cx)}
                              role={"img"}
                            />
                          </div>
                          <PlasmicImg__
                            alt={""}
                            className={classNames(sty.img__yxvJk)}
                            displayHeight={"164px"}
                            displayMaxHeight={"none"}
                            displayMaxWidth={"100%"}
                            displayMinHeight={"0"}
                            displayMinWidth={"0"}
                            displayWidth={"178px"}
                            loader={"plasmic"}
                            loading={"lazy"}
                            src={{
                              src: "https://site-assets.plasmic.app/69bb81e6d432a0ddf00880c2ec36acbd.svg",
                              fullWidth: 178,
                              fullHeight: 164
                            }}
                          />

                          <PlasmicImg__
                            alt={""}
                            className={classNames(sty.img__oHyDs)}
                            displayHeight={"268px"}
                            displayMaxHeight={"none"}
                            displayMaxWidth={"100%"}
                            displayMinHeight={"0"}
                            displayMinWidth={"0"}
                            displayWidth={"171px"}
                            loader={"plasmic"}
                            loading={"lazy"}
                            src={{
                              src: "https://site-assets.plasmic.app/2fbb4b6cad4ae972112b5473c0b9c726.svg",
                              fullWidth: 171,
                              fullHeight: 268
                            }}
                          />

                          <PlasmicImg__
                            alt={""}
                            className={classNames(sty.img__pm2UC)}
                            displayHeight={"200px"}
                            displayMaxHeight={"none"}
                            displayMaxWidth={"100%"}
                            displayMinHeight={"0"}
                            displayMinWidth={"0"}
                            displayWidth={"357px"}
                            loader={"plasmic"}
                            loading={"lazy"}
                            src={{
                              src: "https://site-assets.plasmic.app/ad8e22b75eb3a2d158898613b820dce9.svg",
                              fullWidth: 357,
                              fullHeight: 200
                            }}
                          />

                          <Logo
                            data-plasmic-name={"logo7"}
                            data-plasmic-override={overrides.logo7}
                            className={classNames("__wab_instance", sty.logo7)}
                          />

                          <Logo
                            data-plasmic-name={"logo2"}
                            data-plasmic-override={overrides.logo2}
                            className={classNames("__wab_instance", sty.logo2)}
                            product={"myGme"}
                          />

                          <Logo
                            data-plasmic-name={"logo3"}
                            data-plasmic-override={overrides.logo3}
                            className={classNames("__wab_instance", sty.logo3)}
                            product={"myCme"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <AntdTabs
                    data-plasmic-name={"productTabs"}
                    data-plasmic-override={overrides.productTabs}
                    activeKey={generateStateValueProp($state, [
                      "productTabs",
                      "activeKey"
                    ])}
                    animateTabBar={true}
                    animateTabContent={false}
                    animated={true}
                    centered={false}
                    className={classNames("__wab_instance", sty.productTabs)}
                    defaultActiveKey={"1"}
                    destroyInactiveTabPane={true}
                    items={
                      <React.Fragment>
                        <AntdTabItem
                          className={classNames(
                            "__wab_instance",
                            sty.tabItem__l82Na
                          )}
                          key={"1"}
                          label={
                            <div
                              className={classNames("all", sty.freeBox___2GaH)}
                            >
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img__bpfxl)}
                                displayHeight={"40px"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"100%"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"236px"}
                                loader={"plasmic"}
                                loading={"lazy"}
                                src={{
                                  src: "https://site-assets.plasmic.app/e0d717efc79e1714572b0ff755fc9dba.svg",
                                  fullWidth: 113.777,
                                  fullHeight: 19.887,
                                  aspectRatio: 5.7
                                }}
                              />
                            </div>
                          }
                        >
                          <div
                            data-plasmic-name={"content"}
                            data-plasmic-override={overrides.content}
                            className={classNames("all", sty.content)}
                          >
                            <div
                              data-plasmic-name={"placeholder"}
                              data-plasmic-override={overrides.placeholder}
                              className={classNames("all", sty.placeholder)}
                            >
                              <div
                                data-plasmic-name={"intro"}
                                data-plasmic-override={overrides.intro}
                                className={classNames("all", sty.intro)}
                              >
                                <div
                                  data-plasmic-name={"col"}
                                  data-plasmic-override={overrides.col}
                                  className={classNames("all", sty.col)}
                                >
                                  <Logo
                                    data-plasmic-name={"logo"}
                                    data-plasmic-override={overrides.logo}
                                    className={classNames(
                                      "__wab_instance",
                                      sty.logo
                                    )}
                                  />

                                  <div
                                    data-plasmic-name={"text53"}
                                    data-plasmic-override={overrides.text53}
                                    className={classNames("all", sty.text53)}
                                  >
                                    <div
                                      data-plasmic-name={"title23"}
                                      data-plasmic-override={overrides.title23}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title23
                                      )}
                                    >
                                      {
                                        "Experience the Future \nof Medical Education Management"
                                      }
                                    </div>
                                    <div
                                      data-plasmic-name={"desc"}
                                      data-plasmic-override={overrides.desc}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc
                                      )}
                                    >
                                      {
                                        "MyEvaluations revolutionizes medical training management with streamlined scheduling, patient logs, clinical hour compliance, and custom evaluations. Its efficient workflow and secure, accessible platform save time, resources, and paper, while enabling comprehensive reports and early intervention alerts for improved training outcomes."
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-plasmic-name={"img"}
                                  data-plasmic-override={overrides.img}
                                  className={classNames("all", sty.img)}
                                >
                                  <PlasmicImg__
                                    alt={""}
                                    className={classNames(sty.img__xU7YT)}
                                    displayHeight={"auto"}
                                    displayMaxHeight={"none"}
                                    displayMaxWidth={"100%"}
                                    displayMinHeight={"0"}
                                    displayMinWidth={"0"}
                                    displayWidth={"auto"}
                                    loader={"plasmic"}
                                    loading={"lazy"}
                                    src={{
                                      src: "https://img.plasmic.app/img-optimizer/v1/img/cada1878bf9849f9c3027454c9cb64e1.png",
                                      fullWidth: 715,
                                      fullHeight: 402
                                    }}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"img6"}
                                data-plasmic-override={overrides.img6}
                                className={classNames("all", sty.img6)}
                              >
                                <PlasmicImg__
                                  alt={""}
                                  className={classNames(sty.img__sokqB)}
                                  displayHeight={"auto"}
                                  displayMaxHeight={"none"}
                                  displayMaxWidth={"100%"}
                                  displayMinHeight={"0"}
                                  displayMinWidth={"0"}
                                  displayWidth={"auto"}
                                  loader={"plasmic"}
                                  loading={"lazy"}
                                  src={{
                                    src: "https://img.plasmic.app/img-optimizer/v1/img/13cfe351b26012b284356c2d3db14fdf.png",
                                    fullWidth: 1120,
                                    fullHeight: 620
                                  }}
                                />
                              </div>
                              <div
                                data-plasmic-name={"areas"}
                                data-plasmic-override={overrides.areas}
                                className={classNames("all", sty.areas)}
                              >
                                <div
                                  data-plasmic-name={"header10"}
                                  data-plasmic-override={overrides.header10}
                                  className={classNames("all", sty.header10)}
                                >
                                  <div
                                    data-plasmic-name={"title11"}
                                    data-plasmic-override={overrides.title11}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.title11
                                    )}
                                  >
                                    {
                                      "A Comprehensive Medical Education Platform"
                                    }
                                  </div>
                                  <div
                                    data-plasmic-name={"body7"}
                                    data-plasmic-override={overrides.body7}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.body7
                                    )}
                                  >
                                    {
                                      "Built on a single integrated platform, MyEvaluations provides:"
                                    }
                                  </div>
                                </div>
                                <div
                                  data-plasmic-name={"frame22"}
                                  data-plasmic-override={overrides.frame22}
                                  className={classNames("all", sty.frame22)}
                                >
                                  <div
                                    data-plasmic-name={"item17"}
                                    data-plasmic-override={overrides.item17}
                                    className={classNames("all", sty.item17)}
                                  >
                                    <div
                                      data-plasmic-name={"title12"}
                                      data-plasmic-override={overrides.title12}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title12
                                      )}
                                    >
                                      {"Assessment & Competency Management"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc7"}
                                      data-plasmic-override={overrides.desc7}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc7
                                      )}
                                    >
                                      {
                                        "Evaluations, Milestones, EPAs, SAGE\u2122, and Performance Improvement Plans."
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"item18"}
                                    data-plasmic-override={overrides.item18}
                                    className={classNames("all", sty.item18)}
                                  >
                                    <div
                                      data-plasmic-name={"title13"}
                                      data-plasmic-override={overrides.title13}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title13
                                      )}
                                    >
                                      {"Educational Operations"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc2"}
                                      data-plasmic-override={overrides.desc2}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc2
                                      )}
                                    >
                                      {
                                        "Scheduling, Clinical Hours, Curriculum Management, Procedure & Patient Logs, and Return Demonstrations."
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"item19"}
                                    data-plasmic-override={overrides.item19}
                                    className={classNames("all", sty.item19)}
                                  >
                                    <div
                                      data-plasmic-name={"title14"}
                                      data-plasmic-override={overrides.title14}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title14
                                      )}
                                    >
                                      {"Learning & Development"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc3"}
                                      data-plasmic-override={overrides.desc3}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc3
                                      )}
                                    >
                                      {
                                        "MyQuiz\u2122, Learning Assignments, and Clinical Learning Contracts."
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"item20"}
                                    data-plasmic-override={overrides.item20}
                                    className={classNames("all", sty.item20)}
                                  >
                                    <div
                                      data-plasmic-name={"title15"}
                                      data-plasmic-override={overrides.title15}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title15
                                      )}
                                    >
                                      {"Leadership & Analytics"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc4"}
                                      data-plasmic-override={overrides.desc4}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc4
                                      )}
                                    >
                                      {
                                        "MyInsights\u00ae, accreditation support, administrative reporting, and Continuous Educational Improvement tools."
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"item21"}
                                    data-plasmic-override={overrides.item21}
                                    className={classNames("all", sty.item21)}
                                  >
                                    <div
                                      data-plasmic-name={"title16"}
                                      data-plasmic-override={overrides.title16}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title16
                                      )}
                                    >
                                      {"Continuing Education"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc5"}
                                      data-plasmic-override={overrides.desc5}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc5
                                      )}
                                    >
                                      {
                                        "MyCME\u2122 for continuing medical education management, event planning, accreditation, and learner tracking."
                                      }
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"item22"}
                                    data-plasmic-override={overrides.item22}
                                    className={classNames("all", sty.item22)}
                                  >
                                    <div
                                      data-plasmic-name={"title17"}
                                      data-plasmic-override={overrides.title17}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.title17
                                      )}
                                    >
                                      {"Fiscal Management"}
                                    </div>
                                    <div
                                      data-plasmic-name={"desc6"}
                                      data-plasmic-override={overrides.desc6}
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.desc6
                                      )}
                                    >
                                      {
                                        "MyGME Fiscal\u2122 for IRIS reporting, invoicing, and cost reporting."
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-plasmic-name={"footnote"}
                                  data-plasmic-override={overrides.footnote}
                                  className={classNames(
                                    "all",
                                    "__wab_text",
                                    sty.footnote
                                  )}
                                >
                                  {
                                    "By connecting educational information across the learner journey, MyEvaluations strengthens educator judgment, reduces fragmented workflows, and provides the actionable insight needed to support better decisions at the program and institutional levels."
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </AntdTabItem>
                        <AntdTabItem
                          className={classNames(
                            "__wab_instance",
                            sty.tabItem__sfq8R
                          )}
                          key={"2"}
                          label={
                            <div
                              className={classNames("all", sty.freeBox__lVod3)}
                            >
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img__qq7Dz)}
                                displayHeight={"45px"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"100%"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"126px"}
                                loader={"plasmic"}
                                loading={"lazy"}
                                src={{
                                  src: "https://site-assets.plasmic.app/78d6d60c4e6cb4ef6edce275a40282b3.svg",
                                  fullWidth: 300,
                                  fullHeight: 116,
                                  aspectRatio: 2.595745
                                }}
                              />
                            </div>
                          }
                        >
                          {(_par =>
                            !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                            (() => {
                              try {
                                return $ctx.products[1].product;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return [];
                                }
                                throw e;
                              }
                            })()
                          ).map((__plasmic_item_0, __plasmic_idx_0) => {
                            const currentItem = __plasmic_item_0;
                            const currentIndex = __plasmic_idx_0;
                            return (
                              <div
                                data-plasmic-name={"bodyWrapper6"}
                                data-plasmic-override={overrides.bodyWrapper6}
                                className={classNames("all", sty.bodyWrapper6)}
                                key={currentIndex}
                              >
                                <div
                                  data-plasmic-name={"intro4"}
                                  data-plasmic-override={overrides.intro4}
                                  className={classNames("all", sty.intro4)}
                                >
                                  <div
                                    data-plasmic-name={"col7"}
                                    data-plasmic-override={overrides.col7}
                                    className={classNames("all", sty.col7)}
                                  >
                                    <Logo
                                      data-plasmic-name={"logo9"}
                                      data-plasmic-override={overrides.logo9}
                                      className={classNames(
                                        "__wab_instance",
                                        sty.logo9
                                      )}
                                      product={"myCme"}
                                    />

                                    <div
                                      data-plasmic-name={"text44"}
                                      data-plasmic-override={overrides.text44}
                                      className={classNames("all", sty.text44)}
                                    >
                                      <div
                                        data-plasmic-name={"title27"}
                                        data-plasmic-override={
                                          overrides.title27
                                        }
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.title27
                                        )}
                                      >
                                        {
                                          "One Platform for Continuing Medical Education"
                                        }
                                      </div>
                                      <div
                                        data-plasmic-name={"desc9"}
                                        data-plasmic-override={overrides.desc9}
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.desc9
                                        )}
                                      >
                                        {
                                          "MyCME\u2122 centralizes continuing medical education activities, participation, credit management, reporting, and financial oversight. Organizations can manage live and enduring activities, issue certificates, track CME and Maintenance of Certification credits, maintain event financial records, and support ACCME reporting through PARS."
                                        }
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"img4"}
                                    data-plasmic-override={overrides.img4}
                                    className={classNames("all", sty.img4)}
                                  >
                                    <div
                                      data-plasmic-name={"bg3"}
                                      data-plasmic-override={overrides.bg3}
                                      className={classNames("all", sty.bg3)}
                                    >
                                      <div
                                        data-plasmic-name={"xmlid7457"}
                                        data-plasmic-override={
                                          overrides.xmlid7457
                                        }
                                        className={classNames(
                                          "all",
                                          sty.xmlid7457
                                        )}
                                      >
                                        <Xmlid6613Icon
                                          className={classNames(
                                            "all",
                                            sty.svg___7Gff4
                                          )}
                                          role={"img"}
                                        />

                                        <div
                                          data-plasmic-name={"xmlid6776"}
                                          data-plasmic-override={
                                            overrides.xmlid6776
                                          }
                                          className={classNames(
                                            "all",
                                            sty.xmlid6776
                                          )}
                                        >
                                          {false ? (
                                            <Xmlid7308Icon
                                              className={classNames(
                                                "all",
                                                sty.svg__jV5LO
                                              )}
                                              role={"img"}
                                            />
                                          ) : null}
                                        </div>
                                        <Xmlid6615Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__t5Zyf
                                          )}
                                          role={"img"}
                                        />

                                        <div
                                          data-plasmic-name={"xmlid7433"}
                                          data-plasmic-override={
                                            overrides.xmlid7433
                                          }
                                          className={classNames(
                                            "all",
                                            sty.xmlid7433
                                          )}
                                        >
                                          {false ? (
                                            <Xmlid7443Icon
                                              className={classNames(
                                                "all",
                                                sty.svg___4XlQf
                                              )}
                                              role={"img"}
                                            />
                                          ) : null}
                                        </div>
                                        <Xmlid6614Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__vyA8E
                                          )}
                                          role={"img"}
                                        />

                                        <div
                                          data-plasmic-name={"xmlid7339"}
                                          data-plasmic-override={
                                            overrides.xmlid7339
                                          }
                                          className={classNames(
                                            "all",
                                            sty.xmlid7339
                                          )}
                                        >
                                          {false ? (
                                            <Xmlid7347Icon
                                              className={classNames(
                                                "all",
                                                sty.svg__geSxH
                                              )}
                                              role={"img"}
                                            />
                                          ) : null}
                                        </div>
                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__zxJda
                                          )}
                                          role={"img"}
                                        />

                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__oAdR
                                          )}
                                          role={"img"}
                                        />

                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__dTfag
                                          )}
                                          role={"img"}
                                        />

                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__bVTui
                                          )}
                                          role={"img"}
                                        />

                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__tE8Ng
                                          )}
                                          role={"img"}
                                        />

                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__mesqw
                                          )}
                                          role={"img"}
                                        />

                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__oozDb
                                          )}
                                          role={"img"}
                                        />

                                        <Xmlid7207Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__zfqua
                                          )}
                                          role={"img"}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      data-plasmic-name={"alert3"}
                                      data-plasmic-override={overrides.alert3}
                                      className={classNames("all", sty.alert3)}
                                    >
                                      <div
                                        data-plasmic-name={"icon20"}
                                        data-plasmic-override={overrides.icon20}
                                        className={classNames(
                                          "all",
                                          sty.icon20
                                        )}
                                      >
                                        <Icon91Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__tviJf
                                          )}
                                          role={"img"}
                                        />
                                      </div>
                                      <div
                                        data-plasmic-name={"content3"}
                                        data-plasmic-override={
                                          overrides.content3
                                        }
                                        className={classNames(
                                          "all",
                                          sty.content3
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"text45"}
                                          data-plasmic-override={
                                            overrides.text45
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text45
                                          )}
                                        >
                                          {"Event Created"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"icon21"}
                                        data-plasmic-override={overrides.icon21}
                                        className={classNames(
                                          "all",
                                          sty.icon21
                                        )}
                                      >
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__fB9Ud
                                          )}
                                          role={"img"}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      data-plasmic-name={"credits"}
                                      data-plasmic-override={overrides.credits}
                                      className={classNames("all", sty.credits)}
                                    >
                                      <div
                                        data-plasmic-name={"header20"}
                                        data-plasmic-override={
                                          overrides.header20
                                        }
                                        className={classNames(
                                          "all",
                                          sty.header20
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"subtitle5"}
                                          data-plasmic-override={
                                            overrides.subtitle5
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.subtitle5
                                          )}
                                        >
                                          {"Subtitle"}
                                        </div>
                                        <div
                                          data-plasmic-name={"title28"}
                                          data-plasmic-override={
                                            overrides.title28
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.title28
                                          )}
                                        >
                                          {"User Credits"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"main6"}
                                        data-plasmic-override={overrides.main6}
                                        className={classNames("all", sty.main6)}
                                      >
                                        <div
                                          data-plasmic-name={"mockupCmeCredits"}
                                          data-plasmic-override={
                                            overrides.mockupCmeCredits
                                          }
                                          className={classNames(
                                            "all",
                                            sty.mockupCmeCredits
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"table"}
                                            data-plasmic-override={
                                              overrides.table
                                            }
                                            className={classNames(
                                              "all",
                                              sty.table
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"col8"}
                                              data-plasmic-override={
                                                overrides.col8
                                              }
                                              className={classNames(
                                                "all",
                                                sty.col8
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text46"}
                                                  data-plasmic-override={
                                                    overrides.text46
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text46
                                                  )}
                                                >
                                                  {""}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellAvatar"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellAvatar
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellAvatar
                                                )}
                                              >
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img__pGbCz
                                                  )}
                                                  displayHeight={"24px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"24px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/48cb2e30f5edb1f1e7499f4413ed6ee0.svg",
                                                    fullWidth: 24,
                                                    fullHeight: 24
                                                  }}
                                                />
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellAvatar2"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellAvatar2
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellAvatar2
                                                )}
                                              >
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img__z65So
                                                  )}
                                                  displayHeight={"24px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"24px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/ac4af14f25084692502ede5e82771843.svg",
                                                    fullWidth: 24,
                                                    fullHeight: 24
                                                  }}
                                                />
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellAvatar3"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellAvatar3
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellAvatar3
                                                )}
                                              >
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img___7TN
                                                  )}
                                                  displayHeight={"24px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"24px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/5e2ccb72a7aa58df912292af94e54ab7.svg",
                                                    fullWidth: 24,
                                                    fullHeight: 24
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"col9"}
                                              data-plasmic-override={
                                                overrides.col9
                                              }
                                              className={classNames(
                                                "all",
                                                sty.col9
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText2"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText2
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText2
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text47"}
                                                  data-plasmic-override={
                                                    overrides.text47
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text47
                                                  )}
                                                >
                                                  {"Name"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText3"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText3
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText3
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text48"}
                                                  data-plasmic-override={
                                                    overrides.text48
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text48
                                                  )}
                                                >
                                                  {"Janet Kertzmann"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText4"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText4
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText4
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text49"}
                                                  data-plasmic-override={
                                                    overrides.text49
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text49
                                                  )}
                                                >
                                                  {"Robin Gerhold"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText5"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText5
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText5
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text50"}
                                                  data-plasmic-override={
                                                    overrides.text50
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text50
                                                  )}
                                                >
                                                  {"Isabel Heaney"}
                                                </div>
                                              </div>
                                            </div>
                                            {false ? (
                                              <div
                                                data-plasmic-name={"col10"}
                                                data-plasmic-override={
                                                  overrides.col10
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.col10
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTableCellText6"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTableCellText6
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTableCellText6
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"text51"}
                                                    data-plasmic-override={
                                                      overrides.text51
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.text51
                                                    )}
                                                  >
                                                    {"Claimed"}
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTableCellText7"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTableCellText7
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTableCellText7
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"text52"}
                                                    data-plasmic-override={
                                                      overrides.text52
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.text52
                                                    )}
                                                  >
                                                    {"2.00"}
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTableCellText8"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTableCellText8
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTableCellText8
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"text57"}
                                                    data-plasmic-override={
                                                      overrides.text57
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.text57
                                                    )}
                                                  >
                                                    {"2.50"}
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTableCellText9"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTableCellText9
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTableCellText9
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"text58"}
                                                    data-plasmic-override={
                                                      overrides.text58
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      "__wab_text",
                                                      sty.text58
                                                    )}
                                                  >
                                                    {"2.00"}
                                                  </div>
                                                </div>
                                              </div>
                                            ) : null}
                                            <div
                                              data-plasmic-name={"col11"}
                                              data-plasmic-override={
                                                overrides.col11
                                              }
                                              className={classNames(
                                                "all",
                                                sty.col11
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText10"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText10
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText10
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text59"}
                                                  data-plasmic-override={
                                                    overrides.text59
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text59
                                                  )}
                                                >
                                                  {"Available"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText11"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText11
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText11
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text60"}
                                                  data-plasmic-override={
                                                    overrides.text60
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text60
                                                  )}
                                                >
                                                  {"12.50"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText12"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText12
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText12
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text70"}
                                                  data-plasmic-override={
                                                    overrides.text70
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text70
                                                  )}
                                                >
                                                  {"16.00"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTableCellText13"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTableCellText13
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTableCellText13
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"text71"}
                                                  data-plasmic-override={
                                                    overrides.text71
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text71
                                                  )}
                                                >
                                                  {"27.50"}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            data-plasmic-name={"mockupButton7"}
                                            data-plasmic-override={
                                              overrides.mockupButton7
                                            }
                                            className={classNames(
                                              "all",
                                              sty.mockupButton7
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"link10"}
                                              data-plasmic-override={
                                                overrides.link10
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.link10
                                              )}
                                            >
                                              {"Add Event"}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      data-plasmic-name={"certificate"}
                                      data-plasmic-override={
                                        overrides.certificate
                                      }
                                      className={classNames(
                                        "all",
                                        sty.certificate
                                      )}
                                    >
                                      <div
                                        data-plasmic-name={"top5"}
                                        data-plasmic-override={overrides.top5}
                                        className={classNames("all", sty.top5)}
                                      >
                                        <div
                                          data-plasmic-name={
                                            "mockupCertificateIcon"
                                          }
                                          data-plasmic-override={
                                            overrides.mockupCertificateIcon
                                          }
                                          className={classNames(
                                            "all",
                                            sty.mockupCertificateIcon
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"bg4"}
                                            data-plasmic-override={
                                              overrides.bg4
                                            }
                                            className={classNames(
                                              "all",
                                              sty.bg4
                                            )}
                                          />

                                          <div
                                            data-plasmic-name={"group1"}
                                            data-plasmic-override={
                                              overrides.group1
                                            }
                                            className={classNames(
                                              "all",
                                              sty.group1
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"paper1"}
                                              data-plasmic-override={
                                                overrides.paper1
                                              }
                                              className={classNames(
                                                "all",
                                                sty.paper1
                                              )}
                                            >
                                              <Group15Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__uxwxX
                                                )}
                                                role={"img"}
                                              />
                                            </div>
                                            <div
                                              data-plasmic-name={"paper2"}
                                              data-plasmic-override={
                                                overrides.paper2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.paper2
                                              )}
                                            >
                                              <Group15Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__awuil
                                                )}
                                                role={"img"}
                                              />
                                            </div>
                                            <div
                                              data-plasmic-name={"cert"}
                                              data-plasmic-override={
                                                overrides.cert
                                              }
                                              className={classNames(
                                                "all",
                                                sty.cert
                                              )}
                                            >
                                              <VectorIcon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__qf5RI
                                                )}
                                                role={"img"}
                                              />

                                              <div
                                                data-plasmic-name={"award491"}
                                                data-plasmic-override={
                                                  overrides.award491
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.award491
                                                )}
                                              >
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img___0DwkZ
                                                  )}
                                                  displayHeight={"40.25px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"40.25px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/0064a86bab071b89f97be19685d49a0b.svg",
                                                    fullWidth: 40.25,
                                                    fullHeight: 40.25
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            data-plasmic-name={"overlay"}
                                            data-plasmic-override={
                                              overrides.overlay
                                            }
                                            className={classNames(
                                              "all",
                                              sty.overlay
                                            )}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"title29"}
                                          data-plasmic-override={
                                            overrides.title29
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.title29
                                          )}
                                        >
                                          {"Certificate"}
                                        </div>
                                        <div
                                          data-plasmic-name={
                                            "mockupTextPlaceholder"
                                          }
                                          data-plasmic-override={
                                            overrides.mockupTextPlaceholder
                                          }
                                          className={classNames(
                                            "all",
                                            sty.mockupTextPlaceholder
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={
                                              "mockupTextPlaceholderParagraph"
                                            }
                                            data-plasmic-override={
                                              overrides.mockupTextPlaceholderParagraph
                                            }
                                            className={classNames(
                                              "all",
                                              sty.mockupTextPlaceholderParagraph
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent37"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent37
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent37
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder38"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder38
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder38
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine2"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine2
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent38"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent38
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent38
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder39"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder39
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder39
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine3"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine3
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine3
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent39"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent39
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent39
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder40"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder40
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder40
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine4"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine4
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine4
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent40"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent40
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent40
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder41"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder41
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder41
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine5"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine5
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine5
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent41"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent41
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent41
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder42"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder42
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder42
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                          </div>
                                          {false ? (
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderParagraph2"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderParagraph2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderParagraph2
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine6"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine6
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine6
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent42"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent42
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent42
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder43"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder43
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder43
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine7"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine7
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine7
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent43"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent43
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent43
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder44"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder44
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder44
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine8"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine8
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine8
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent44"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent44
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent44
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder45"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder45
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder45
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine9"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine9
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine9
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent45"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent45
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent45
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder46"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder46
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder46
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine10"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine10
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine10
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent46"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent46
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent46
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder47"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder47
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder47
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine11"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine11
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine11
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent47"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent47
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent47
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder48"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder48
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder48
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine12"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine12
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine12
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent48"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent48
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent48
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder49"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder49
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder49
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine13"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine13
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine13
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent49"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent49
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent49
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder50"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder50
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder50
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                          {false ? (
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderParagraph3"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderParagraph3
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderParagraph3
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine14"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine14
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine14
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent50"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent50
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent50
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder51"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder51
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder51
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine15"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine15
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine15
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent15"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent15
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent15
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder52"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder52
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder52
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine16"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine16
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine16
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent16"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent16
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent16
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder53"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder53
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder53
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine17"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine17
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine17
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent17"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent17
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent17
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder54"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder54
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder54
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine18"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine18
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine18
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent18"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent18
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent18
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder55"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder55
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder55
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                          <div
                                            data-plasmic-name={
                                              "mockupTextPlaceholderParagraph4"
                                            }
                                            data-plasmic-override={
                                              overrides.mockupTextPlaceholderParagraph4
                                            }
                                            className={classNames(
                                              "all",
                                              sty.mockupTextPlaceholderParagraph4
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine19"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine19
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine19
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent19"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent19
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent19
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder19"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder19
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder19
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine20"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine20
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine20
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent20"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent20
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent20
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder20"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder20
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder20
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine21"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine21
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine21
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent21"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent21
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent21
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder21"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder21
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder21
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine22"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine22
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine22
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent22"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent22
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent22
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder22"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder22
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder22
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine23"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine23
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine23
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent23"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent23
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent23
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder23"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder23
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder23
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine24"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine24
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine24
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent24"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent24
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent24
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder24"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder24
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder24
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            {false ? (
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderLine25"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderLine25
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderLine25
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderContent25"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderContent25
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderContent25
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "placeholder25"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.placeholder25
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.placeholder25
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            <div
                                              data-plasmic-name={
                                                "mockupTextPlaceholderLine26"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupTextPlaceholderLine26
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupTextPlaceholderLine26
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderContent26"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderContent26
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderContent26
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "placeholder26"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.placeholder26
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.placeholder26
                                                  )}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"mockupButton8"}
                                        data-plasmic-override={
                                          overrides.mockupButton8
                                        }
                                        className={classNames(
                                          "all",
                                          sty.mockupButton8
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"link11"}
                                          data-plasmic-override={
                                            overrides.link11
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.link11
                                          )}
                                        >
                                          {"Generate"}
                                        </div>
                                      </div>
                                    </div>
                                    {false ? (
                                      <div
                                        data-plasmic-name={"alert2"}
                                        data-plasmic-override={overrides.alert2}
                                        className={classNames(
                                          "all",
                                          sty.alert2
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon22"}
                                          data-plasmic-override={
                                            overrides.icon22
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon22
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"check2"}
                                            data-plasmic-override={
                                              overrides.check2
                                            }
                                            className={classNames(
                                              "all",
                                              sty.check2
                                            )}
                                          >
                                            <Group17Icon
                                              className={classNames(
                                                "all",
                                                sty.svg__eKoTq
                                              )}
                                              role={"img"}
                                            />
                                          </div>
                                        </div>
                                        <div
                                          data-plasmic-name={"content4"}
                                          data-plasmic-override={
                                            overrides.content4
                                          }
                                          className={classNames(
                                            "all",
                                            sty.content4
                                          )}
                                        >
                                          <div
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.text__fhavd
                                            )}
                                          >
                                            {"Event Created"}
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}
                                    <div
                                      data-plasmic-name={"report"}
                                      data-plasmic-override={overrides.report}
                                      className={classNames("all", sty.report)}
                                    >
                                      <div
                                        data-plasmic-name={"bill"}
                                        data-plasmic-override={overrides.bill}
                                        className={classNames("all", sty.bill)}
                                      >
                                        <div
                                          data-plasmic-name={"header21"}
                                          data-plasmic-override={
                                            overrides.header21
                                          }
                                          className={classNames(
                                            "all",
                                            sty.header21
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"subtitle9"}
                                            data-plasmic-override={
                                              overrides.subtitle9
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.subtitle9
                                            )}
                                          >
                                            {"Event"}
                                          </div>
                                          <div
                                            data-plasmic-name={"title30"}
                                            data-plasmic-override={
                                              overrides.title30
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.title30
                                            )}
                                          >
                                            {"Financial Report"}
                                          </div>
                                        </div>
                                        <div
                                          data-plasmic-name={"main7"}
                                          data-plasmic-override={
                                            overrides.main7
                                          }
                                          className={classNames(
                                            "all",
                                            sty.main7
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"placeholder27"}
                                            data-plasmic-override={
                                              overrides.placeholder27
                                            }
                                            className={classNames(
                                              "all",
                                              sty.placeholder27
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"header22"}
                                              data-plasmic-override={
                                                overrides.header22
                                              }
                                              className={classNames(
                                                "all",
                                                sty.header22
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"title31"}
                                                data-plasmic-override={
                                                  overrides.title31
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.title31
                                                )}
                                              >
                                                {
                                                  "Trends in Neurology: Bridging Research to Clinical Practice"
                                                }
                                              </div>
                                              <div
                                                data-plasmic-name={"date"}
                                                data-plasmic-override={
                                                  overrides.date
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.date
                                                )}
                                              >
                                                {"17 Mar 2024\u201319 Mar 2024"}
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"section"}
                                              data-plasmic-override={
                                                overrides.section
                                              }
                                              className={classNames(
                                                "all",
                                                sty.section
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"head"}
                                                data-plasmic-override={
                                                  overrides.head
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.head
                                                )}
                                              >
                                                {"Income"}
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderParagraph5"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderParagraph5
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderParagraph5
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderLine27"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderLine27
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderLine27
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderContent27"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderContent27
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderContent27
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "placeholder28"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.placeholder28
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.placeholder28
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderLine28"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderLine28
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderLine28
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "mockupTextPlaceholderContent28"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.mockupTextPlaceholderContent28
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.mockupTextPlaceholderContent28
                                                      )}
                                                    >
                                                      <div
                                                        data-plasmic-name={
                                                          "placeholder29"
                                                        }
                                                        data-plasmic-override={
                                                          overrides.placeholder29
                                                        }
                                                        className={classNames(
                                                          "all",
                                                          sty.placeholder29
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                ) : null}
                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderLine29"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderLine29
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderLine29
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "mockupTextPlaceholderContent29"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.mockupTextPlaceholderContent29
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.mockupTextPlaceholderContent29
                                                      )}
                                                    >
                                                      <div
                                                        data-plasmic-name={
                                                          "placeholder30"
                                                        }
                                                        data-plasmic-override={
                                                          overrides.placeholder30
                                                        }
                                                        className={classNames(
                                                          "all",
                                                          sty.placeholder30
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                ) : null}
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderLine30"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderLine30
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderLine30
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderContent30"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderContent30
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderContent30
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "placeholder31"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.placeholder31
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.placeholder31
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderLine31"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderLine31
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderLine31
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderContent31"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderContent31
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderContent31
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "placeholder32"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.placeholder32
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.placeholder32
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={"total"}
                                                data-plasmic-override={
                                                  overrides.total
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.total
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"title32"}
                                                  data-plasmic-override={
                                                    overrides.title32
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.title32
                                                  )}
                                                >
                                                  {"Total"}
                                                </div>
                                                <div
                                                  data-plasmic-name={"val6"}
                                                  data-plasmic-override={
                                                    overrides.val6
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.val6
                                                  )}
                                                >
                                                  {"$18,975"}
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"section2"}
                                              data-plasmic-override={
                                                overrides.section2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.section2
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"head2"}
                                                data-plasmic-override={
                                                  overrides.head2
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.head2
                                                )}
                                              >
                                                {"Expenses"}
                                              </div>
                                              <div
                                                data-plasmic-name={
                                                  "mockupTextPlaceholderParagraph6"
                                                }
                                                data-plasmic-override={
                                                  overrides.mockupTextPlaceholderParagraph6
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.mockupTextPlaceholderParagraph6
                                                )}
                                              >
                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderLine32"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderLine32
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderLine32
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "mockupTextPlaceholderContent32"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.mockupTextPlaceholderContent32
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.mockupTextPlaceholderContent32
                                                      )}
                                                    >
                                                      <div
                                                        data-plasmic-name={
                                                          "placeholder33"
                                                        }
                                                        data-plasmic-override={
                                                          overrides.placeholder33
                                                        }
                                                        className={classNames(
                                                          "all",
                                                          sty.placeholder33
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                ) : null}
                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderLine33"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderLine33
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderLine33
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "mockupTextPlaceholderContent33"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.mockupTextPlaceholderContent33
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.mockupTextPlaceholderContent33
                                                      )}
                                                    >
                                                      <div
                                                        data-plasmic-name={
                                                          "placeholder34"
                                                        }
                                                        data-plasmic-override={
                                                          overrides.placeholder34
                                                        }
                                                        className={classNames(
                                                          "all",
                                                          sty.placeholder34
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                ) : null}
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderLine34"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderLine34
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderLine34
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderContent34"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderContent34
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderContent34
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "placeholder35"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.placeholder35
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.placeholder35
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  data-plasmic-name={
                                                    "mockupTextPlaceholderLine35"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.mockupTextPlaceholderLine35
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.mockupTextPlaceholderLine35
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderContent35"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderContent35
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderContent35
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "placeholder36"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.placeholder36
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.placeholder36
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "mockupTextPlaceholderLine36"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.mockupTextPlaceholderLine36
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.mockupTextPlaceholderLine36
                                                    )}
                                                  >
                                                    <div
                                                      data-plasmic-name={
                                                        "mockupTextPlaceholderContent36"
                                                      }
                                                      data-plasmic-override={
                                                        overrides.mockupTextPlaceholderContent36
                                                      }
                                                      className={classNames(
                                                        "all",
                                                        sty.mockupTextPlaceholderContent36
                                                      )}
                                                    >
                                                      <div
                                                        data-plasmic-name={
                                                          "placeholder37"
                                                        }
                                                        data-plasmic-override={
                                                          overrides.placeholder37
                                                        }
                                                        className={classNames(
                                                          "all",
                                                          sty.placeholder37
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                ) : null}
                                              </div>
                                              <div
                                                data-plasmic-name={"total2"}
                                                data-plasmic-override={
                                                  overrides.total2
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.total2
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"title34"}
                                                  data-plasmic-override={
                                                    overrides.title34
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.title34
                                                  )}
                                                >
                                                  {"Total"}
                                                </div>
                                                <div
                                                  data-plasmic-name={"val7"}
                                                  data-plasmic-override={
                                                    overrides.val7
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.val7
                                                  )}
                                                >
                                                  {"$3,021"}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          data-plasmic-name={"edge"}
                                          data-plasmic-override={overrides.edge}
                                          className={classNames(
                                            "all",
                                            sty.edge
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"tri"}
                                            data-plasmic-override={
                                              overrides.tri
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect"}
                                              data-plasmic-override={
                                                overrides.rect
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri2"}
                                            data-plasmic-override={
                                              overrides.tri2
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri2
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect2"}
                                              data-plasmic-override={
                                                overrides.rect2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect2
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri3"}
                                            data-plasmic-override={
                                              overrides.tri3
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri3
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect3"}
                                              data-plasmic-override={
                                                overrides.rect3
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect3
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri4"}
                                            data-plasmic-override={
                                              overrides.tri4
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri4
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect4"}
                                              data-plasmic-override={
                                                overrides.rect4
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect4
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri5"}
                                            data-plasmic-override={
                                              overrides.tri5
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri5
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect5"}
                                              data-plasmic-override={
                                                overrides.rect5
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect5
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri6"}
                                            data-plasmic-override={
                                              overrides.tri6
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri6
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect6"}
                                              data-plasmic-override={
                                                overrides.rect6
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect6
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri7"}
                                            data-plasmic-override={
                                              overrides.tri7
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri7
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect7"}
                                              data-plasmic-override={
                                                overrides.rect7
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect7
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri8"}
                                            data-plasmic-override={
                                              overrides.tri8
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri8
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect8"}
                                              data-plasmic-override={
                                                overrides.rect8
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect8
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri9"}
                                            data-plasmic-override={
                                              overrides.tri9
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri9
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect9"}
                                              data-plasmic-override={
                                                overrides.rect9
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect9
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri10"}
                                            data-plasmic-override={
                                              overrides.tri10
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri10
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect10"}
                                              data-plasmic-override={
                                                overrides.rect10
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect10
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri11"}
                                            data-plasmic-override={
                                              overrides.tri11
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri11
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect11"}
                                              data-plasmic-override={
                                                overrides.rect11
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect11
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri12"}
                                            data-plasmic-override={
                                              overrides.tri12
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri12
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect12"}
                                              data-plasmic-override={
                                                overrides.rect12
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect12
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri13"}
                                            data-plasmic-override={
                                              overrides.tri13
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri13
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect13"}
                                              data-plasmic-override={
                                                overrides.rect13
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect13
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri14"}
                                            data-plasmic-override={
                                              overrides.tri14
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri14
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect14"}
                                              data-plasmic-override={
                                                overrides.rect14
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect14
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri15"}
                                            data-plasmic-override={
                                              overrides.tri15
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri15
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect15"}
                                              data-plasmic-override={
                                                overrides.rect15
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect15
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri16"}
                                            data-plasmic-override={
                                              overrides.tri16
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri16
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect16"}
                                              data-plasmic-override={
                                                overrides.rect16
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect16
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri17"}
                                            data-plasmic-override={
                                              overrides.tri17
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri17
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect17"}
                                              data-plasmic-override={
                                                overrides.rect17
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect17
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri18"}
                                            data-plasmic-override={
                                              overrides.tri18
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri18
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect18"}
                                              data-plasmic-override={
                                                overrides.rect18
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect18
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri19"}
                                            data-plasmic-override={
                                              overrides.tri19
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri19
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect19"}
                                              data-plasmic-override={
                                                overrides.rect19
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect19
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri20"}
                                            data-plasmic-override={
                                              overrides.tri20
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri20
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect20"}
                                              data-plasmic-override={
                                                overrides.rect20
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect20
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri21"}
                                            data-plasmic-override={
                                              overrides.tri21
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri21
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect21"}
                                              data-plasmic-override={
                                                overrides.rect21
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect21
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri22"}
                                            data-plasmic-override={
                                              overrides.tri22
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri22
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect22"}
                                              data-plasmic-override={
                                                overrides.rect22
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect22
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri23"}
                                            data-plasmic-override={
                                              overrides.tri23
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri23
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect23"}
                                              data-plasmic-override={
                                                overrides.rect23
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect23
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri24"}
                                            data-plasmic-override={
                                              overrides.tri24
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri24
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect24"}
                                              data-plasmic-override={
                                                overrides.rect24
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect24
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri25"}
                                            data-plasmic-override={
                                              overrides.tri25
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri25
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect25"}
                                              data-plasmic-override={
                                                overrides.rect25
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect25
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri26"}
                                            data-plasmic-override={
                                              overrides.tri26
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri26
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect26"}
                                              data-plasmic-override={
                                                overrides.rect26
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect26
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri27"}
                                            data-plasmic-override={
                                              overrides.tri27
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri27
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect27"}
                                              data-plasmic-override={
                                                overrides.rect27
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect27
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri28"}
                                            data-plasmic-override={
                                              overrides.tri28
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri28
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect28"}
                                              data-plasmic-override={
                                                overrides.rect28
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect28
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri29"}
                                            data-plasmic-override={
                                              overrides.tri29
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri29
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect29"}
                                              data-plasmic-override={
                                                overrides.rect29
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect29
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri30"}
                                            data-plasmic-override={
                                              overrides.tri30
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri30
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect30"}
                                              data-plasmic-override={
                                                overrides.rect30
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect30
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri31"}
                                            data-plasmic-override={
                                              overrides.tri31
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri31
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect31"}
                                              data-plasmic-override={
                                                overrides.rect31
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect31
                                              )}
                                            />
                                          </div>
                                          <div
                                            data-plasmic-name={"tri32"}
                                            data-plasmic-override={
                                              overrides.tri32
                                            }
                                            className={classNames(
                                              "all",
                                              sty.tri32
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"rect32"}
                                              data-plasmic-override={
                                                overrides.rect32
                                              }
                                              className={classNames(
                                                "all",
                                                sty.rect32
                                              )}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"shade3"}
                                        data-plasmic-override={overrides.shade3}
                                        className={classNames(
                                          "all",
                                          sty.shade3
                                        )}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-plasmic-name={"features3"}
                                  data-plasmic-override={overrides.features3}
                                  className={classNames("all", sty.features3)}
                                >
                                  <div
                                    data-plasmic-name={"title33"}
                                    data-plasmic-override={overrides.title33}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.title33
                                    )}
                                  >
                                    {"Key Capabilities"}
                                  </div>
                                  <div
                                    className={classNames(
                                      "all",
                                      sty.freeBox__g8QjH
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"figmaPaste2"}
                                      data-plasmic-override={
                                        overrides.figmaPaste2
                                      }
                                      className={classNames(
                                        "all",
                                        sty.figmaPaste2
                                      )}
                                    >
                                      <div
                                        data-plasmic-name={"contentsItem10"}
                                        data-plasmic-override={
                                          overrides.contentsItem10
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem10
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon23"}
                                          data-plasmic-override={
                                            overrides.icon23
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon23
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__wJhRs
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text61"}
                                          data-plasmic-override={
                                            overrides.text61
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text61
                                          )}
                                        >
                                          {
                                            "Live and Enduring Activity Scheduling"
                                          }
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem11"}
                                        data-plasmic-override={
                                          overrides.contentsItem11
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem11
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon24"}
                                          data-plasmic-override={
                                            overrides.icon24
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon24
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg___3OrnD
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text62"}
                                          data-plasmic-override={
                                            overrides.text62
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text62
                                          )}
                                        >
                                          {"CME Credit Tracing"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem12"}
                                        data-plasmic-override={
                                          overrides.contentsItem12
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem12
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon25"}
                                          data-plasmic-override={
                                            overrides.icon25
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon25
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg___5Qlht
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text63"}
                                          data-plasmic-override={
                                            overrides.text63
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text63
                                          )}
                                        >
                                          {"Certificate Management"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem13"}
                                        data-plasmic-override={
                                          overrides.contentsItem13
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem13
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon26"}
                                          data-plasmic-override={
                                            overrides.icon26
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon26
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__e2Mic
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text64"}
                                          data-plasmic-override={
                                            overrides.text64
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text64
                                          )}
                                        >
                                          {"ACCME PARS Connectivity"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem14"}
                                        data-plasmic-override={
                                          overrides.contentsItem14
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem14
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon27"}
                                          data-plasmic-override={
                                            overrides.icon27
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon27
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__p1VTf
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text65"}
                                          data-plasmic-override={
                                            overrides.text65
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text65
                                          )}
                                        >
                                          {
                                            "Maintenance of Certification Reporting"
                                          }
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem15"}
                                        data-plasmic-override={
                                          overrides.contentsItem15
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem15
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon28"}
                                          data-plasmic-override={
                                            overrides.icon28
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon28
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg___43YoQ
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text66"}
                                          data-plasmic-override={
                                            overrides.text66
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text66
                                          )}
                                        >
                                          {
                                            "Registration and Participation Tracking"
                                          }
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem16"}
                                        data-plasmic-override={
                                          overrides.contentsItem16
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem16
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon29"}
                                          data-plasmic-override={
                                            overrides.icon29
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon29
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__iHp7U
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text67"}
                                          data-plasmic-override={
                                            overrides.text67
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text67
                                          )}
                                        >
                                          {"Event Financial Management"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem17"}
                                        data-plasmic-override={
                                          overrides.contentsItem17
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem17
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon30"}
                                          data-plasmic-override={
                                            overrides.icon30
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon30
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__szoVf
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text68"}
                                          data-plasmic-override={
                                            overrides.text68
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text68
                                          )}
                                        >
                                          {"Cross-Departmental Reporting"}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </AntdTabItem>
                        <AntdTabItem
                          className={classNames(
                            "__wab_instance",
                            sty.tabItem__mqp4N
                          )}
                          key={"3"}
                          label={
                            <div
                              className={classNames("all", sty.freeBox__wW81B)}
                            >
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img__zdQDu)}
                                displayHeight={"45px"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"100%"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"216px"}
                                loader={"plasmic"}
                                loading={"lazy"}
                                src={{
                                  src: "https://site-assets.plasmic.app/9fd573b79cd2a308d894f39aa424fd70.svg",
                                  fullWidth: 220,
                                  fullHeight: 46,
                                  aspectRatio: 4.782609
                                }}
                              />
                            </div>
                          }
                        >
                          {(_par =>
                            !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                            (() => {
                              try {
                                return $ctx.products[2].product;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return [];
                                }
                                throw e;
                              }
                            })()
                          ).map((__plasmic_item_0, __plasmic_idx_0) => {
                            const currentItem = __plasmic_item_0;
                            const currentIndex = __plasmic_idx_0;
                            return (
                              <div
                                data-plasmic-name={"bodyWrapper5"}
                                data-plasmic-override={overrides.bodyWrapper5}
                                className={classNames("all", sty.bodyWrapper5)}
                                key={currentIndex}
                              >
                                <div
                                  data-plasmic-name={"intro3"}
                                  data-plasmic-override={overrides.intro3}
                                  className={classNames("all", sty.intro3)}
                                >
                                  <div
                                    data-plasmic-name={"col5"}
                                    data-plasmic-override={overrides.col5}
                                    className={classNames("all", sty.col5)}
                                  >
                                    <Logo
                                      data-plasmic-name={"logo8"}
                                      data-plasmic-override={overrides.logo8}
                                      className={classNames(
                                        "__wab_instance",
                                        sty.logo8
                                      )}
                                      product={"myGme"}
                                    />

                                    <div
                                      data-plasmic-name={"text"}
                                      data-plasmic-override={overrides.text}
                                      className={classNames("all", sty.text)}
                                    >
                                      <div
                                        data-plasmic-name={"title18"}
                                        data-plasmic-override={
                                          overrides.title18
                                        }
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.title18
                                        )}
                                      >
                                        {
                                          "One Platform for GME Fiscal Management"
                                        }
                                      </div>
                                      <div
                                        data-plasmic-name={"desc8"}
                                        data-plasmic-override={overrides.desc8}
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.desc8
                                        )}
                                      >
                                        {
                                          "MyGME Fiscal\u2122 connects educational, scheduling, and clinical-hour information with the financial processes required for GME reimbursement, institutional planning, invoicing, and reporting.\nThrough IRIS and STAR exports, Master Rotation Schedules, FTE and CAP analysis, gap and overlap review, and detailed fiscal reporting, institutions gain clearer oversight of reimbursable activity and Medicare submissions."
                                        }
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    data-plasmic-name={"img3"}
                                    data-plasmic-override={overrides.img3}
                                    className={classNames("all", sty.img3)}
                                  >
                                    <div
                                      data-plasmic-name={"bg2"}
                                      data-plasmic-override={overrides.bg2}
                                      className={classNames("all", sty.bg2)}
                                    >
                                      <Wave1Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__pCfE
                                        )}
                                        role={"img"}
                                      />

                                      <PlasmicImg__
                                        alt={""}
                                        className={classNames(sty.img__ud0Nf)}
                                        displayHeight={"186px"}
                                        displayMaxHeight={"none"}
                                        displayMaxWidth={"100%"}
                                        displayMinHeight={"0"}
                                        displayMinWidth={"0"}
                                        displayWidth={"715px"}
                                        loader={"plasmic"}
                                        loading={"lazy"}
                                        src={{
                                          src: "https://site-assets.plasmic.app/bf87b4d752b94e5cc36e8a6cab0a8589.svg",
                                          fullWidth: 715,
                                          fullHeight: 186
                                        }}
                                      />

                                      <Wave41Icon
                                        className={classNames(
                                          "all",
                                          sty.svg__j6PxH
                                        )}
                                        role={"img"}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"reimbursement"}
                                      data-plasmic-override={
                                        overrides.reimbursement
                                      }
                                      className={classNames(
                                        "all",
                                        sty.reimbursement
                                      )}
                                    >
                                      <div
                                        data-plasmic-name={"header11"}
                                        data-plasmic-override={
                                          overrides.header11
                                        }
                                        className={classNames(
                                          "all",
                                          sty.header11
                                        )}
                                      >
                                        {false ? (
                                          <div
                                            data-plasmic-name={"subtitle4"}
                                            data-plasmic-override={
                                              overrides.subtitle4
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.subtitle4
                                            )}
                                          >
                                            {"Subtitle"}
                                          </div>
                                        ) : null}
                                        <div
                                          data-plasmic-name={"title19"}
                                          data-plasmic-override={
                                            overrides.title19
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.title19
                                          )}
                                        >
                                          {"Reimbursement Progress"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"main4"}
                                        data-plasmic-override={overrides.main4}
                                        className={classNames("all", sty.main4)}
                                      >
                                        <div
                                          data-plasmic-name={"placeholder16"}
                                          data-plasmic-override={
                                            overrides.placeholder16
                                          }
                                          className={classNames(
                                            "all",
                                            sty.placeholder16
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"row"}
                                            data-plasmic-override={
                                              overrides.row
                                            }
                                            className={classNames(
                                              "all",
                                              sty.row
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"prop"}
                                              data-plasmic-override={
                                                overrides.prop
                                              }
                                              className={classNames(
                                                "all",
                                                sty.prop
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"label10"}
                                                data-plasmic-override={
                                                  overrides.label10
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.label10
                                                )}
                                              >
                                                {"Fiscal Year:"}
                                              </div>
                                              <div
                                                data-plasmic-name={"val"}
                                                data-plasmic-override={
                                                  overrides.val
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.val
                                                )}
                                              >
                                                {"2023\u20132024"}
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"prop2"}
                                              data-plasmic-override={
                                                overrides.prop2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.prop2
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"label11"}
                                                data-plasmic-override={
                                                  overrides.label11
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.label11
                                                )}
                                              >
                                                {"Due Date:"}
                                              </div>
                                              <div
                                                data-plasmic-name={"val2"}
                                                data-plasmic-override={
                                                  overrides.val2
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.val2
                                                )}
                                              >
                                                {"Sep 30, 2024"}
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            data-plasmic-name={
                                              "mockupProgressBarWithTitle"
                                            }
                                            data-plasmic-override={
                                              overrides.mockupProgressBarWithTitle
                                            }
                                            className={classNames(
                                              "all",
                                              sty.mockupProgressBarWithTitle
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"header12"}
                                              data-plasmic-override={
                                                overrides.header12
                                              }
                                              className={classNames(
                                                "all",
                                                sty.header12
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"title20"}
                                                data-plasmic-override={
                                                  overrides.title20
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.title20
                                                )}
                                              >
                                                {"Ready for Reimbursement"}
                                              </div>
                                              <div
                                                data-plasmic-name={"val3"}
                                                data-plasmic-override={
                                                  overrides.val3
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.val3
                                                )}
                                              >
                                                {"73%"}
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"bar"}
                                              data-plasmic-override={
                                                overrides.bar
                                              }
                                              className={classNames(
                                                "all",
                                                sty.bar
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"value"}
                                                data-plasmic-override={
                                                  overrides.value
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.value
                                                )}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      data-plasmic-name={"demographics"}
                                      data-plasmic-override={
                                        overrides.demographics
                                      }
                                      className={classNames(
                                        "all",
                                        sty.demographics
                                      )}
                                    >
                                      <div
                                        data-plasmic-name={"demographics2"}
                                        data-plasmic-override={
                                          overrides.demographics2
                                        }
                                        className={classNames(
                                          "all",
                                          sty.demographics2
                                        )}
                                      >
                                        {false ? (
                                          <div
                                            data-plasmic-name={"header13"}
                                            data-plasmic-override={
                                              overrides.header13
                                            }
                                            className={classNames(
                                              "all",
                                              sty.header13
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"subtitle7"}
                                              data-plasmic-override={
                                                overrides.subtitle7
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.subtitle7
                                              )}
                                            >
                                              {"Subtitle"}
                                            </div>
                                            <div
                                              data-plasmic-name={"title4"}
                                              data-plasmic-override={
                                                overrides.title4
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.title4
                                              )}
                                            >
                                              {"Title"}
                                            </div>
                                          </div>
                                        ) : null}
                                        <div
                                          data-plasmic-name={"main5"}
                                          data-plasmic-override={
                                            overrides.main5
                                          }
                                          className={classNames(
                                            "all",
                                            sty.main5
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"placeholder17"}
                                            data-plasmic-override={
                                              overrides.placeholder17
                                            }
                                            className={classNames(
                                              "all",
                                              sty.placeholder17
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"row2"}
                                              data-plasmic-override={
                                                overrides.row2
                                              }
                                              className={classNames(
                                                "all",
                                                sty.row2
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"header14"}
                                                data-plasmic-override={
                                                  overrides.header14
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.header14
                                                )}
                                              >
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img__scAZz
                                                  )}
                                                  displayHeight={"24px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"24px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/c5e582f2b73bf9c41a1927c0d7d67fd7.svg",
                                                    fullWidth: 24,
                                                    fullHeight: 24
                                                  }}
                                                />

                                                <div
                                                  data-plasmic-name={"name6"}
                                                  data-plasmic-override={
                                                    overrides.name6
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.name6
                                                  )}
                                                >
                                                  {"Megan Wil"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={"error"}
                                                data-plasmic-override={
                                                  overrides.error
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.error
                                                )}
                                              >
                                                <div
                                                  className={classNames(
                                                    "all",
                                                    sty.freeBox___3N2TS
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"tip"}
                                                    data-plasmic-override={
                                                      overrides.tip
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.tip
                                                    )}
                                                  />
                                                </div>
                                                <div
                                                  data-plasmic-name={"label3"}
                                                  data-plasmic-override={
                                                    overrides.label3
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.label3
                                                  )}
                                                >
                                                  {"No SSN Code"}
                                                </div>
                                                <div
                                                  data-plasmic-name={"link6"}
                                                  data-plasmic-override={
                                                    overrides.link6
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.link6
                                                  )}
                                                >
                                                  {"Add"}
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"row6"}
                                              data-plasmic-override={
                                                overrides.row6
                                              }
                                              className={classNames(
                                                "all",
                                                sty.row6
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"header15"}
                                                data-plasmic-override={
                                                  overrides.header15
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.header15
                                                )}
                                              >
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img__i2PsE
                                                  )}
                                                  displayHeight={"24px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"24px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/4ed22927224c5bb8fc14aaebd926842e.svg",
                                                    fullWidth: 24,
                                                    fullHeight: 24
                                                  }}
                                                />

                                                <div
                                                  data-plasmic-name={"name7"}
                                                  data-plasmic-override={
                                                    overrides.name7
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.name7
                                                  )}
                                                >
                                                  {"Bobby Huel"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={"error2"}
                                                data-plasmic-override={
                                                  overrides.error2
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.error2
                                                )}
                                              >
                                                <div
                                                  className={classNames(
                                                    "all",
                                                    sty.freeBox__vqpW9
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"tip2"}
                                                    data-plasmic-override={
                                                      overrides.tip2
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.tip2
                                                    )}
                                                  />
                                                </div>
                                                <div
                                                  data-plasmic-name={"label4"}
                                                  data-plasmic-override={
                                                    overrides.label4
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.label4
                                                  )}
                                                >
                                                  {"No Graduation Date"}
                                                </div>
                                                <div
                                                  data-plasmic-name={"link7"}
                                                  data-plasmic-override={
                                                    overrides.link7
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.link7
                                                  )}
                                                >
                                                  {"Add"}
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"row7"}
                                              data-plasmic-override={
                                                overrides.row7
                                              }
                                              className={classNames(
                                                "all",
                                                sty.row7
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"header16"}
                                                data-plasmic-override={
                                                  overrides.header16
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.header16
                                                )}
                                              >
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img___15HTu
                                                  )}
                                                  displayHeight={"24px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"24px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/dd070641b260e03c8b60d2c70e463190.svg",
                                                    fullWidth: 24,
                                                    fullHeight: 24
                                                  }}
                                                />

                                                <div
                                                  data-plasmic-name={"name8"}
                                                  data-plasmic-override={
                                                    overrides.name8
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.name8
                                                  )}
                                                >
                                                  {"Tanya Cole"}
                                                </div>
                                              </div>
                                              <div
                                                data-plasmic-name={"error3"}
                                                data-plasmic-override={
                                                  overrides.error3
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.error3
                                                )}
                                              >
                                                <div
                                                  className={classNames(
                                                    "all",
                                                    sty.freeBox__fSMiz
                                                  )}
                                                >
                                                  <div
                                                    data-plasmic-name={"tip3"}
                                                    data-plasmic-override={
                                                      overrides.tip3
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.tip3
                                                    )}
                                                  />
                                                </div>
                                                <div
                                                  data-plasmic-name={"label5"}
                                                  data-plasmic-override={
                                                    overrides.label5
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.label5
                                                  )}
                                                >
                                                  {"No SSN Code"}
                                                </div>
                                                <div
                                                  data-plasmic-name={"link8"}
                                                  data-plasmic-override={
                                                    overrides.link8
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.link8
                                                  )}
                                                >
                                                  {"Add"}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"shade2"}
                                        data-plasmic-override={overrides.shade2}
                                        className={classNames(
                                          "all",
                                          sty.shade2
                                        )}
                                      />
                                    </div>
                                    <div
                                      data-plasmic-name={"cap"}
                                      data-plasmic-override={overrides.cap}
                                      className={classNames("all", sty.cap)}
                                    >
                                      <div
                                        data-plasmic-name={"header17"}
                                        data-plasmic-override={
                                          overrides.header17
                                        }
                                        className={classNames(
                                          "all",
                                          sty.header17
                                        )}
                                      >
                                        {false ? (
                                          <div
                                            data-plasmic-name={"subtitle8"}
                                            data-plasmic-override={
                                              overrides.subtitle8
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.subtitle8
                                            )}
                                          >
                                            {"Subtitle"}
                                          </div>
                                        ) : null}
                                        <div
                                          data-plasmic-name={"title21"}
                                          data-plasmic-override={
                                            overrides.title21
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.title21
                                          )}
                                        >
                                          {"Cap Analysis"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"main3"}
                                        data-plasmic-override={overrides.main3}
                                        className={classNames("all", sty.main3)}
                                      >
                                        <div
                                          data-plasmic-name={"placeholder18"}
                                          data-plasmic-override={
                                            overrides.placeholder18
                                          }
                                          className={classNames(
                                            "all",
                                            sty.placeholder18
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"field"}
                                            data-plasmic-override={
                                              overrides.field
                                            }
                                            className={classNames(
                                              "all",
                                              sty.field
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"label6"}
                                              data-plasmic-override={
                                                overrides.label6
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.label6
                                              )}
                                            >
                                              {"Institution"}
                                            </div>
                                            <div
                                              data-plasmic-name={"select"}
                                              data-plasmic-override={
                                                overrides.select
                                              }
                                              className={classNames(
                                                "all",
                                                sty.select
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"input"}
                                                data-plasmic-override={
                                                  overrides.input
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.input
                                                )}
                                              >
                                                {false ? (
                                                  <div
                                                    data-plasmic-name={
                                                      "leftIcon"
                                                    }
                                                    data-plasmic-override={
                                                      overrides.leftIcon
                                                    }
                                                    className={classNames(
                                                      "all",
                                                      sty.leftIcon
                                                    )}
                                                  >
                                                    <Icon91Icon
                                                      className={classNames(
                                                        "all",
                                                        sty.svg__tEzPf
                                                      )}
                                                      role={"img"}
                                                    />
                                                  </div>
                                                ) : null}
                                                <div
                                                  data-plasmic-name={"text25"}
                                                  data-plasmic-override={
                                                    overrides.text25
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.text25
                                                  )}
                                                >
                                                  {"Integrated Health One"}
                                                </div>
                                                <div
                                                  data-plasmic-name={
                                                    "rightIcon"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.rightIcon
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    sty.rightIcon
                                                  )}
                                                >
                                                  <PlasmicImg__
                                                    alt={""}
                                                    className={classNames(
                                                      sty.img__ctYbA
                                                    )}
                                                    displayHeight={"12px"}
                                                    displayMaxHeight={"none"}
                                                    displayMaxWidth={"100%"}
                                                    displayMinHeight={"0"}
                                                    displayMinWidth={"0"}
                                                    displayWidth={"12px"}
                                                    loader={"plasmic"}
                                                    loading={"lazy"}
                                                    src={{
                                                      src: "https://site-assets.plasmic.app/111ce4d1a6d72b3b2b7de10e9e93afd6.svg",
                                                      fullWidth: 12,
                                                      fullHeight: 12
                                                    }}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            data-plasmic-name={"row5"}
                                            data-plasmic-override={
                                              overrides.row5
                                            }
                                            className={classNames(
                                              "all",
                                              sty.row5
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"prop3"}
                                              data-plasmic-override={
                                                overrides.prop3
                                              }
                                              className={classNames(
                                                "all",
                                                sty.prop3
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"label7"}
                                                data-plasmic-override={
                                                  overrides.label7
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.label7
                                                )}
                                              >
                                                {"DME/Cap"}
                                              </div>
                                              <div
                                                data-plasmic-name={"val4"}
                                                data-plasmic-override={
                                                  overrides.val4
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.val4
                                                )}
                                              >
                                                {"12.11/10"}
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"prop4"}
                                              data-plasmic-override={
                                                overrides.prop4
                                              }
                                              className={classNames(
                                                "all",
                                                sty.prop4
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"label8"}
                                                data-plasmic-override={
                                                  overrides.label8
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.label8
                                                )}
                                              >
                                                {"DME/Cap Variance"}
                                              </div>
                                              <div
                                                data-plasmic-name={"val5"}
                                                data-plasmic-override={
                                                  overrides.val5
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.val5
                                                )}
                                              >
                                                {"2.11"}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {false ? (
                                      <div
                                        data-plasmic-name={"profile3"}
                                        data-plasmic-override={
                                          overrides.profile3
                                        }
                                        className={classNames(
                                          "all",
                                          sty.profile3
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"av3"}
                                          data-plasmic-override={overrides.av3}
                                          className={classNames("all", sty.av3)}
                                        />

                                        <div
                                          data-plasmic-name={"col6"}
                                          data-plasmic-override={overrides.col6}
                                          className={classNames(
                                            "all",
                                            sty.col6
                                          )}
                                        >
                                          <div
                                            data-plasmic-name={"top4"}
                                            data-plasmic-override={
                                              overrides.top4
                                            }
                                            className={classNames(
                                              "all",
                                              sty.top4
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={"header18"}
                                              data-plasmic-override={
                                                overrides.header18
                                              }
                                              className={classNames(
                                                "all",
                                                sty.header18
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"name9"}
                                                data-plasmic-override={
                                                  overrides.name9
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.name9
                                                )}
                                              >
                                                {"Jody Gleason"}
                                              </div>
                                              <div
                                                data-plasmic-name={"status3"}
                                                data-plasmic-override={
                                                  overrides.status3
                                                }
                                                className={classNames(
                                                  "all",
                                                  sty.status3
                                                )}
                                              >
                                                <div
                                                  data-plasmic-name={"label9"}
                                                  data-plasmic-override={
                                                    overrides.label9
                                                  }
                                                  className={classNames(
                                                    "all",
                                                    "__wab_text",
                                                    sty.label9
                                                  )}
                                                >
                                                  {"Status"}
                                                </div>
                                                <PlasmicImg__
                                                  alt={""}
                                                  className={classNames(
                                                    sty.img___4JBgl
                                                  )}
                                                  displayHeight={"12px"}
                                                  displayMaxHeight={"none"}
                                                  displayMaxWidth={"100%"}
                                                  displayMinHeight={"0"}
                                                  displayMinWidth={"0"}
                                                  displayWidth={"12px"}
                                                  loader={"plasmic"}
                                                  loading={"lazy"}
                                                  src={{
                                                    src: "https://site-assets.plasmic.app/fd8444da63470a9c723007422a038ef7.svg",
                                                    fullWidth: 12,
                                                    fullHeight: 12
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={"body8"}
                                              data-plasmic-override={
                                                overrides.body8
                                              }
                                              className={classNames(
                                                "all",
                                                sty.body8
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"year3"}
                                                data-plasmic-override={
                                                  overrides.year3
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.year3
                                                )}
                                              >
                                                {"PGY-3"}
                                              </div>
                                              <div
                                                data-plasmic-name={"name5"}
                                                data-plasmic-override={
                                                  overrides.name5
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.name5
                                                )}
                                              >
                                                {"05/01/2022-10/31/2022"}
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            data-plasmic-name={"actions3"}
                                            data-plasmic-override={
                                              overrides.actions3
                                            }
                                            className={classNames(
                                              "all",
                                              sty.actions3
                                            )}
                                          >
                                            <div
                                              data-plasmic-name={
                                                "mockupButton5"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupButton5
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupButton5
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"link9"}
                                                data-plasmic-override={
                                                  overrides.link9
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.link9
                                                )}
                                              >
                                                {"Save & Submit"}
                                              </div>
                                            </div>
                                            <div
                                              data-plasmic-name={
                                                "mockupButton6"
                                              }
                                              data-plasmic-override={
                                                overrides.mockupButton6
                                              }
                                              className={classNames(
                                                "all",
                                                sty.mockupButton6
                                              )}
                                            >
                                              <div
                                                data-plasmic-name={"link5"}
                                                data-plasmic-override={
                                                  overrides.link5
                                                }
                                                className={classNames(
                                                  "all",
                                                  "__wab_text",
                                                  sty.link5
                                                )}
                                              >
                                                {"Print"}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}
                                    <div
                                      data-plasmic-name={"menu2"}
                                      data-plasmic-override={overrides.menu2}
                                      className={classNames("all", sty.menu2)}
                                    >
                                      <div
                                        data-plasmic-name={"header19"}
                                        data-plasmic-override={
                                          overrides.header19
                                        }
                                        className={classNames(
                                          "all",
                                          sty.header19
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"title22"}
                                          data-plasmic-override={
                                            overrides.title22
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.title22
                                          )}
                                        >
                                          {"Fiscal Reports"}
                                        </div>
                                        <div
                                          data-plasmic-name={"icon8"}
                                          data-plasmic-override={
                                            overrides.icon8
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon8
                                          )}
                                        >
                                          <Icon83Icon
                                            className={classNames(
                                              "all",
                                              sty.svg___3VIZo
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"list"}
                                        data-plasmic-override={overrides.list}
                                        className={classNames("all", sty.list)}
                                      >
                                        <div
                                          data-plasmic-name={"item23"}
                                          data-plasmic-override={
                                            overrides.item23
                                          }
                                          className={classNames(
                                            "all",
                                            sty.item23
                                          )}
                                        >
                                          {false ? (
                                            <Icon84Icon
                                              className={classNames(
                                                "all",
                                                sty.svg__acjsR
                                              )}
                                              role={"img"}
                                            />
                                          ) : null}
                                          <div
                                            data-plasmic-name={"text26"}
                                            data-plasmic-override={
                                              overrides.text26
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.text26
                                            )}
                                          >
                                            {"FTE Report"}
                                          </div>
                                        </div>
                                        <div
                                          data-plasmic-name={"item24"}
                                          data-plasmic-override={
                                            overrides.item24
                                          }
                                          className={classNames(
                                            "all",
                                            sty.item24
                                          )}
                                        >
                                          {false ? (
                                            <Icon84Icon
                                              className={classNames(
                                                "all",
                                                sty.svg__ikBv
                                              )}
                                              role={"img"}
                                            />
                                          ) : null}
                                          <div
                                            data-plasmic-name={"text4"}
                                            data-plasmic-override={
                                              overrides.text4
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.text4
                                            )}
                                          >
                                            {"IRIS Report"}
                                          </div>
                                        </div>
                                        <div
                                          data-plasmic-name={"item25"}
                                          data-plasmic-override={
                                            overrides.item25
                                          }
                                          className={classNames(
                                            "all",
                                            sty.item25
                                          )}
                                        >
                                          {false ? (
                                            <Icon84Icon
                                              className={classNames(
                                                "all",
                                                sty.svg__shIrW
                                              )}
                                              role={"img"}
                                            />
                                          ) : null}
                                          <div
                                            data-plasmic-name={"text27"}
                                            data-plasmic-override={
                                              overrides.text27
                                            }
                                            className={classNames(
                                              "all",
                                              "__wab_text",
                                              sty.text27
                                            )}
                                          >
                                            {"Medicate Audit Report"}
                                          </div>
                                        </div>
                                        {false ? (
                                          <div
                                            data-plasmic-name={"item26"}
                                            data-plasmic-override={
                                              overrides.item26
                                            }
                                            className={classNames(
                                              "all",
                                              sty.item26
                                            )}
                                          >
                                            {false ? (
                                              <Icon84Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__affCk
                                                )}
                                                role={"img"}
                                              />
                                            ) : null}
                                            <div
                                              data-plasmic-name={"text28"}
                                              data-plasmic-override={
                                                overrides.text28
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text28
                                              )}
                                            >
                                              {"Settings"}
                                            </div>
                                          </div>
                                        ) : null}
                                        {false ? (
                                          <div
                                            data-plasmic-name={"item27"}
                                            data-plasmic-override={
                                              overrides.item27
                                            }
                                            className={classNames(
                                              "all",
                                              sty.item27
                                            )}
                                          >
                                            {false ? (
                                              <Icon84Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__uVdJz
                                                )}
                                                role={"img"}
                                              />
                                            ) : null}
                                            <div
                                              data-plasmic-name={"text29"}
                                              data-plasmic-override={
                                                overrides.text29
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text29
                                              )}
                                            >
                                              {"Label"}
                                            </div>
                                          </div>
                                        ) : null}
                                        {false ? (
                                          <div
                                            data-plasmic-name={"item28"}
                                            data-plasmic-override={
                                              overrides.item28
                                            }
                                            className={classNames(
                                              "all",
                                              sty.item28
                                            )}
                                          >
                                            {false ? (
                                              <Icon84Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__oSyes
                                                )}
                                                role={"img"}
                                              />
                                            ) : null}
                                            <div
                                              data-plasmic-name={"text30"}
                                              data-plasmic-override={
                                                overrides.text30
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text30
                                              )}
                                            >
                                              {"Label"}
                                            </div>
                                          </div>
                                        ) : null}
                                        {false ? (
                                          <div
                                            data-plasmic-name={"item29"}
                                            data-plasmic-override={
                                              overrides.item29
                                            }
                                            className={classNames(
                                              "all",
                                              sty.item29
                                            )}
                                          >
                                            {false ? (
                                              <Icon84Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg___8B0Co
                                                )}
                                                role={"img"}
                                              />
                                            ) : null}
                                            <div
                                              data-plasmic-name={"text31"}
                                              data-plasmic-override={
                                                overrides.text31
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text31
                                              )}
                                            >
                                              {"Label"}
                                            </div>
                                          </div>
                                        ) : null}
                                        {false ? (
                                          <div
                                            data-plasmic-name={"item30"}
                                            data-plasmic-override={
                                              overrides.item30
                                            }
                                            className={classNames(
                                              "all",
                                              sty.item30
                                            )}
                                          >
                                            {false ? (
                                              <Icon84Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__yhccO
                                                )}
                                                role={"img"}
                                              />
                                            ) : null}
                                            <div
                                              data-plasmic-name={"text32"}
                                              data-plasmic-override={
                                                overrides.text32
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text32
                                              )}
                                            >
                                              {"Label"}
                                            </div>
                                          </div>
                                        ) : null}
                                        {false ? (
                                          <div
                                            data-plasmic-name={"item31"}
                                            data-plasmic-override={
                                              overrides.item31
                                            }
                                            className={classNames(
                                              "all",
                                              sty.item31
                                            )}
                                          >
                                            {false ? (
                                              <Icon84Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg__htw0Z
                                                )}
                                                role={"img"}
                                              />
                                            ) : null}
                                            <div
                                              data-plasmic-name={"text33"}
                                              data-plasmic-override={
                                                overrides.text33
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text33
                                              )}
                                            >
                                              {"Label"}
                                            </div>
                                          </div>
                                        ) : null}
                                        {false ? (
                                          <div
                                            data-plasmic-name={"item32"}
                                            data-plasmic-override={
                                              overrides.item32
                                            }
                                            className={classNames(
                                              "all",
                                              sty.item32
                                            )}
                                          >
                                            {false ? (
                                              <Icon84Icon
                                                className={classNames(
                                                  "all",
                                                  sty.svg___03E13
                                                )}
                                                role={"img"}
                                              />
                                            ) : null}
                                            <div
                                              data-plasmic-name={"text34"}
                                              data-plasmic-override={
                                                overrides.text34
                                              }
                                              className={classNames(
                                                "all",
                                                "__wab_text",
                                                sty.text34
                                              )}
                                            >
                                              {"Label"}
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                    <div
                                      data-plasmic-name={"alert"}
                                      data-plasmic-override={overrides.alert}
                                      className={classNames("all", sty.alert)}
                                    >
                                      <div
                                        data-plasmic-name={"icon9"}
                                        data-plasmic-override={overrides.icon9}
                                        className={classNames("all", sty.icon9)}
                                      >
                                        <Icon91Icon
                                          className={classNames(
                                            "all",
                                            sty.svg__lv7Bw
                                          )}
                                          role={"img"}
                                        />
                                      </div>
                                      <div
                                        data-plasmic-name={"content2"}
                                        data-plasmic-override={
                                          overrides.content2
                                        }
                                        className={classNames(
                                          "all",
                                          sty.content2
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"text35"}
                                          data-plasmic-override={
                                            overrides.text35
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text35
                                          )}
                                        >
                                          {"Audit Report Generated"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"icon10"}
                                        data-plasmic-override={overrides.icon10}
                                        className={classNames(
                                          "all",
                                          sty.icon10
                                        )}
                                      >
                                        <Icon84Icon
                                          className={classNames(
                                            "all",
                                            sty.svg___1KV
                                          )}
                                          role={"img"}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-plasmic-name={"features"}
                                  data-plasmic-override={overrides.features}
                                  className={classNames("all", sty.features)}
                                >
                                  <div
                                    data-plasmic-name={"title5"}
                                    data-plasmic-override={overrides.title5}
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.title5
                                    )}
                                  >
                                    {"Key Capabilities"}
                                  </div>
                                  <div
                                    className={classNames(
                                      "all",
                                      sty.freeBox__nczQa
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"figmaPaste"}
                                      data-plasmic-override={
                                        overrides.figmaPaste
                                      }
                                      className={classNames(
                                        "all",
                                        sty.figmaPaste
                                      )}
                                    >
                                      <div
                                        data-plasmic-name={"contentsItem"}
                                        data-plasmic-override={
                                          overrides.contentsItem
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon11"}
                                          data-plasmic-override={
                                            overrides.icon11
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon11
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__voOIh
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text36"}
                                          data-plasmic-override={
                                            overrides.text36
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text36
                                          )}
                                        >
                                          {
                                            "Medicare Reimbursement & Cost Reporting"
                                          }
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem2"}
                                        data-plasmic-override={
                                          overrides.contentsItem2
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem2
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon12"}
                                          data-plasmic-override={
                                            overrides.icon12
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon12
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__ybj7C
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text37"}
                                          data-plasmic-override={
                                            overrides.text37
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text37
                                          )}
                                        >
                                          {"IRIS & STAR Export"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem3"}
                                        data-plasmic-override={
                                          overrides.contentsItem3
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem3
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon13"}
                                          data-plasmic-override={
                                            overrides.icon13
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon13
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__olCJ
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text38"}
                                          data-plasmic-override={
                                            overrides.text38
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text38
                                          )}
                                        >
                                          {"Billing & Invoicing"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem4"}
                                        data-plasmic-override={
                                          overrides.contentsItem4
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem4
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon14"}
                                          data-plasmic-override={
                                            overrides.icon14
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon14
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__rpqZc
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text39"}
                                          data-plasmic-override={
                                            overrides.text39
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text39
                                          )}
                                        >
                                          {"FTE Reporting & CAP Analysis"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem5"}
                                        data-plasmic-override={
                                          overrides.contentsItem5
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem5
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon15"}
                                          data-plasmic-override={
                                            overrides.icon15
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon15
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg___77Ns1
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text5"}
                                          data-plasmic-override={
                                            overrides.text5
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text5
                                          )}
                                        >
                                          {
                                            "Master Rotation Schedule Management"
                                          }
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem6"}
                                        data-plasmic-override={
                                          overrides.contentsItem6
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem6
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon16"}
                                          data-plasmic-override={
                                            overrides.icon16
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon16
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__dhWel
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text40"}
                                          data-plasmic-override={
                                            overrides.text40
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text40
                                          )}
                                        >
                                          {"Gap & Overlap Analysis"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem7"}
                                        data-plasmic-override={
                                          overrides.contentsItem7
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem7
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon17"}
                                          data-plasmic-override={
                                            overrides.icon17
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon17
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__oy0JC
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text41"}
                                          data-plasmic-override={
                                            overrides.text41
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text41
                                          )}
                                        >
                                          {"Audit Management"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem8"}
                                        data-plasmic-override={
                                          overrides.contentsItem8
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem8
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon18"}
                                          data-plasmic-override={
                                            overrides.icon18
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon18
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__gk3Af
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text42"}
                                          data-plasmic-override={
                                            overrides.text42
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text42
                                          )}
                                        >
                                          {"Errors & Omissions Analysis"}
                                        </div>
                                      </div>
                                      <div
                                        data-plasmic-name={"contentsItem9"}
                                        data-plasmic-override={
                                          overrides.contentsItem9
                                        }
                                        className={classNames(
                                          "all",
                                          sty.contentsItem9
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"icon19"}
                                          data-plasmic-override={
                                            overrides.icon19
                                          }
                                          className={classNames(
                                            "all",
                                            sty.icon19
                                          )}
                                        >
                                          <Icon87Icon
                                            className={classNames(
                                              "all",
                                              sty.svg__sttom
                                            )}
                                            role={"img"}
                                          />
                                        </div>
                                        <div
                                          data-plasmic-name={"text43"}
                                          data-plasmic-override={
                                            overrides.text43
                                          }
                                          className={classNames(
                                            "all",
                                            "__wab_text",
                                            sty.text43
                                          )}
                                        >
                                          {"MyQuickPass\u2122 Integration"}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </AntdTabItem>
                      </React.Fragment>
                    }
                    onChange={async (...eventArgs: any) => {
                      generateStateOnChangeProp($state, [
                        "productTabs",
                        "activeKey"
                      ]).apply(null, eventArgs);
                    }}
                    size={"middle"}
                    sticky={false}
                    tabBarBackground={"#FFF"}
                    tabBarClassName={classNames({
                      [sty["pcls_rD0wo-WDIPys"]]: hasVariant(
                        globalVariants,
                        "mobile",
                        "tabletLandscape"
                      ),
                      [sty["pcls_xdVRZnowjy_L"]]: true
                    })}
                    tabPosition={"top"}
                    tabsDropdownClassName={classNames({
                      [sty["pcls_cosBQM60nlAy"]]: hasVariant(
                        globalVariants,
                        "mobile",
                        "tabletLandscape"
                      ),
                      [sty["pcls_rPwEUHX6XxjP"]]: true
                    })}
                    tabsDropdownScopeClassName={
                      sty["productTabs__tabsDropdown"]
                    }
                    tabsScopeClassName={sty["productTabs__tabs"]}
                    type={"card"}
                  />
                </div>
              ) : null}
              {(
                hasVariant(globalVariants, "mobile", "mobile")
                  ? true
                  : hasVariant(globalVariants, "mobile", "tabletPortrait")
                    ? true
                    : false
              ) ? (
                <div
                  data-plasmic-name={"mobileWrapper"}
                  data-plasmic-override={overrides.mobileWrapper}
                  className={classNames("all", sty.mobileWrapper)}
                >
                  <div
                    data-plasmic-name={"header"}
                    data-plasmic-override={overrides.header}
                    className={classNames("all", sty.header)}
                  >
                    <div
                      data-plasmic-name={"top"}
                      data-plasmic-override={overrides.top}
                      className={classNames("all", sty.top)}
                    >
                      <div
                        data-plasmic-name={"subtitle2"}
                        data-plasmic-override={overrides.subtitle2}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.subtitle2
                        )}
                      >
                        {"One Integrated Platform"}
                      </div>
                      <div
                        data-plasmic-name={"title2"}
                        data-plasmic-override={overrides.title2}
                        className={classNames("all", "__wab_text", sty.title2)}
                      >
                        {
                          "Technology That Strengthens Educational Conversations"
                        }
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"body"}
                      data-plasmic-override={overrides.body}
                      className={classNames("all", "__wab_text", sty.body)}
                    >
                      {
                        "MyEvaluations brings educational management, continuing medical education, and GME fiscal management together within one connected platform.\nThrough MyEvaluations, MyCME\u2122, and MyGME Fiscal\u2122, institutions can strengthen assessment quality, simplify educational operations, gain actionable insight, and support Continuous Educational Improvement\u00a0across the organization."
                      }
                    </div>
                  </div>
                </div>
              ) : null}
            </React.Fragment>
          )}
        </DataCtxReader__>
      </DataProvider>
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  productsSection: [
    "productsSection",
    "productsProvider",
    "desktopWrapper",
    "intro2",
    "header9",
    "top3",
    "subtitle",
    "title",
    "body6",
    "col4",
    "nav",
    "img2",
    "logoIcon",
    "logo7",
    "logo2",
    "logo3",
    "productTabs",
    "content",
    "placeholder",
    "intro",
    "col",
    "logo",
    "text53",
    "title23",
    "desc",
    "img",
    "img6",
    "areas",
    "header10",
    "title11",
    "body7",
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6",
    "footnote",
    "bodyWrapper6",
    "intro4",
    "col7",
    "logo9",
    "text44",
    "title27",
    "desc9",
    "img4",
    "bg3",
    "xmlid7457",
    "xmlid6776",
    "xmlid7433",
    "xmlid7339",
    "alert3",
    "icon20",
    "content3",
    "text45",
    "icon21",
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10",
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11",
    "alert2",
    "icon22",
    "check2",
    "content4",
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3",
    "features3",
    "title33",
    "figmaPaste2",
    "contentsItem10",
    "icon23",
    "text61",
    "contentsItem11",
    "icon24",
    "text62",
    "contentsItem12",
    "icon25",
    "text63",
    "contentsItem13",
    "icon26",
    "text64",
    "contentsItem14",
    "icon27",
    "text65",
    "contentsItem15",
    "icon28",
    "text66",
    "contentsItem16",
    "icon29",
    "text67",
    "contentsItem17",
    "icon30",
    "text68",
    "bodyWrapper5",
    "intro3",
    "col5",
    "logo8",
    "text",
    "title18",
    "desc8",
    "img3",
    "bg2",
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value",
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2",
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5",
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5",
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34",
    "alert",
    "icon9",
    "content2",
    "text35",
    "icon10",
    "features",
    "title5",
    "figmaPaste",
    "contentsItem",
    "icon11",
    "text36",
    "contentsItem2",
    "icon12",
    "text37",
    "contentsItem3",
    "icon13",
    "text38",
    "contentsItem4",
    "icon14",
    "text39",
    "contentsItem5",
    "icon15",
    "text5",
    "contentsItem6",
    "icon16",
    "text40",
    "contentsItem7",
    "icon17",
    "text41",
    "contentsItem8",
    "icon18",
    "text42",
    "contentsItem9",
    "icon19",
    "text43",
    "mobileWrapper",
    "header",
    "top",
    "subtitle2",
    "title2",
    "body"
  ],
  productsProvider: [
    "productsProvider",
    "desktopWrapper",
    "intro2",
    "header9",
    "top3",
    "subtitle",
    "title",
    "body6",
    "col4",
    "nav",
    "img2",
    "logoIcon",
    "logo7",
    "logo2",
    "logo3",
    "productTabs",
    "content",
    "placeholder",
    "intro",
    "col",
    "logo",
    "text53",
    "title23",
    "desc",
    "img",
    "img6",
    "areas",
    "header10",
    "title11",
    "body7",
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6",
    "footnote",
    "bodyWrapper6",
    "intro4",
    "col7",
    "logo9",
    "text44",
    "title27",
    "desc9",
    "img4",
    "bg3",
    "xmlid7457",
    "xmlid6776",
    "xmlid7433",
    "xmlid7339",
    "alert3",
    "icon20",
    "content3",
    "text45",
    "icon21",
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10",
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11",
    "alert2",
    "icon22",
    "check2",
    "content4",
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3",
    "features3",
    "title33",
    "figmaPaste2",
    "contentsItem10",
    "icon23",
    "text61",
    "contentsItem11",
    "icon24",
    "text62",
    "contentsItem12",
    "icon25",
    "text63",
    "contentsItem13",
    "icon26",
    "text64",
    "contentsItem14",
    "icon27",
    "text65",
    "contentsItem15",
    "icon28",
    "text66",
    "contentsItem16",
    "icon29",
    "text67",
    "contentsItem17",
    "icon30",
    "text68",
    "bodyWrapper5",
    "intro3",
    "col5",
    "logo8",
    "text",
    "title18",
    "desc8",
    "img3",
    "bg2",
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value",
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2",
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5",
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5",
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34",
    "alert",
    "icon9",
    "content2",
    "text35",
    "icon10",
    "features",
    "title5",
    "figmaPaste",
    "contentsItem",
    "icon11",
    "text36",
    "contentsItem2",
    "icon12",
    "text37",
    "contentsItem3",
    "icon13",
    "text38",
    "contentsItem4",
    "icon14",
    "text39",
    "contentsItem5",
    "icon15",
    "text5",
    "contentsItem6",
    "icon16",
    "text40",
    "contentsItem7",
    "icon17",
    "text41",
    "contentsItem8",
    "icon18",
    "text42",
    "contentsItem9",
    "icon19",
    "text43",
    "mobileWrapper",
    "header",
    "top",
    "subtitle2",
    "title2",
    "body"
  ],
  desktopWrapper: [
    "desktopWrapper",
    "intro2",
    "header9",
    "top3",
    "subtitle",
    "title",
    "body6",
    "col4",
    "nav",
    "img2",
    "logoIcon",
    "logo7",
    "logo2",
    "logo3",
    "productTabs",
    "content",
    "placeholder",
    "intro",
    "col",
    "logo",
    "text53",
    "title23",
    "desc",
    "img",
    "img6",
    "areas",
    "header10",
    "title11",
    "body7",
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6",
    "footnote",
    "bodyWrapper6",
    "intro4",
    "col7",
    "logo9",
    "text44",
    "title27",
    "desc9",
    "img4",
    "bg3",
    "xmlid7457",
    "xmlid6776",
    "xmlid7433",
    "xmlid7339",
    "alert3",
    "icon20",
    "content3",
    "text45",
    "icon21",
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10",
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11",
    "alert2",
    "icon22",
    "check2",
    "content4",
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3",
    "features3",
    "title33",
    "figmaPaste2",
    "contentsItem10",
    "icon23",
    "text61",
    "contentsItem11",
    "icon24",
    "text62",
    "contentsItem12",
    "icon25",
    "text63",
    "contentsItem13",
    "icon26",
    "text64",
    "contentsItem14",
    "icon27",
    "text65",
    "contentsItem15",
    "icon28",
    "text66",
    "contentsItem16",
    "icon29",
    "text67",
    "contentsItem17",
    "icon30",
    "text68",
    "bodyWrapper5",
    "intro3",
    "col5",
    "logo8",
    "text",
    "title18",
    "desc8",
    "img3",
    "bg2",
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value",
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2",
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5",
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5",
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34",
    "alert",
    "icon9",
    "content2",
    "text35",
    "icon10",
    "features",
    "title5",
    "figmaPaste",
    "contentsItem",
    "icon11",
    "text36",
    "contentsItem2",
    "icon12",
    "text37",
    "contentsItem3",
    "icon13",
    "text38",
    "contentsItem4",
    "icon14",
    "text39",
    "contentsItem5",
    "icon15",
    "text5",
    "contentsItem6",
    "icon16",
    "text40",
    "contentsItem7",
    "icon17",
    "text41",
    "contentsItem8",
    "icon18",
    "text42",
    "contentsItem9",
    "icon19",
    "text43"
  ],
  intro2: [
    "intro2",
    "header9",
    "top3",
    "subtitle",
    "title",
    "body6",
    "col4",
    "nav",
    "img2",
    "logoIcon",
    "logo7",
    "logo2",
    "logo3"
  ],
  header9: ["header9", "top3", "subtitle", "title", "body6"],
  top3: ["top3", "subtitle", "title"],
  subtitle: ["subtitle"],
  title: ["title"],
  body6: ["body6"],
  col4: ["col4", "nav", "img2", "logoIcon", "logo7", "logo2", "logo3"],
  nav: ["nav", "img2", "logoIcon", "logo7", "logo2", "logo3"],
  img2: ["img2", "logoIcon", "logo7", "logo2", "logo3"],
  logoIcon: ["logoIcon"],
  logo7: ["logo7"],
  logo2: ["logo2"],
  logo3: ["logo3"],
  productTabs: [
    "productTabs",
    "content",
    "placeholder",
    "intro",
    "col",
    "logo",
    "text53",
    "title23",
    "desc",
    "img",
    "img6",
    "areas",
    "header10",
    "title11",
    "body7",
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6",
    "footnote",
    "bodyWrapper6",
    "intro4",
    "col7",
    "logo9",
    "text44",
    "title27",
    "desc9",
    "img4",
    "bg3",
    "xmlid7457",
    "xmlid6776",
    "xmlid7433",
    "xmlid7339",
    "alert3",
    "icon20",
    "content3",
    "text45",
    "icon21",
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10",
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11",
    "alert2",
    "icon22",
    "check2",
    "content4",
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3",
    "features3",
    "title33",
    "figmaPaste2",
    "contentsItem10",
    "icon23",
    "text61",
    "contentsItem11",
    "icon24",
    "text62",
    "contentsItem12",
    "icon25",
    "text63",
    "contentsItem13",
    "icon26",
    "text64",
    "contentsItem14",
    "icon27",
    "text65",
    "contentsItem15",
    "icon28",
    "text66",
    "contentsItem16",
    "icon29",
    "text67",
    "contentsItem17",
    "icon30",
    "text68",
    "bodyWrapper5",
    "intro3",
    "col5",
    "logo8",
    "text",
    "title18",
    "desc8",
    "img3",
    "bg2",
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value",
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2",
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5",
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5",
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34",
    "alert",
    "icon9",
    "content2",
    "text35",
    "icon10",
    "features",
    "title5",
    "figmaPaste",
    "contentsItem",
    "icon11",
    "text36",
    "contentsItem2",
    "icon12",
    "text37",
    "contentsItem3",
    "icon13",
    "text38",
    "contentsItem4",
    "icon14",
    "text39",
    "contentsItem5",
    "icon15",
    "text5",
    "contentsItem6",
    "icon16",
    "text40",
    "contentsItem7",
    "icon17",
    "text41",
    "contentsItem8",
    "icon18",
    "text42",
    "contentsItem9",
    "icon19",
    "text43"
  ],
  content: [
    "content",
    "placeholder",
    "intro",
    "col",
    "logo",
    "text53",
    "title23",
    "desc",
    "img",
    "img6",
    "areas",
    "header10",
    "title11",
    "body7",
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6",
    "footnote"
  ],
  placeholder: [
    "placeholder",
    "intro",
    "col",
    "logo",
    "text53",
    "title23",
    "desc",
    "img",
    "img6",
    "areas",
    "header10",
    "title11",
    "body7",
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6",
    "footnote"
  ],
  intro: ["intro", "col", "logo", "text53", "title23", "desc", "img"],
  col: ["col", "logo", "text53", "title23", "desc"],
  logo: ["logo"],
  text53: ["text53", "title23", "desc"],
  title23: ["title23"],
  desc: ["desc"],
  img: ["img"],
  img6: ["img6"],
  areas: [
    "areas",
    "header10",
    "title11",
    "body7",
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6",
    "footnote"
  ],
  header10: ["header10", "title11", "body7"],
  title11: ["title11"],
  body7: ["body7"],
  frame22: [
    "frame22",
    "item17",
    "title12",
    "desc7",
    "item18",
    "title13",
    "desc2",
    "item19",
    "title14",
    "desc3",
    "item20",
    "title15",
    "desc4",
    "item21",
    "title16",
    "desc5",
    "item22",
    "title17",
    "desc6"
  ],
  item17: ["item17", "title12", "desc7"],
  title12: ["title12"],
  desc7: ["desc7"],
  item18: ["item18", "title13", "desc2"],
  title13: ["title13"],
  desc2: ["desc2"],
  item19: ["item19", "title14", "desc3"],
  title14: ["title14"],
  desc3: ["desc3"],
  item20: ["item20", "title15", "desc4"],
  title15: ["title15"],
  desc4: ["desc4"],
  item21: ["item21", "title16", "desc5"],
  title16: ["title16"],
  desc5: ["desc5"],
  item22: ["item22", "title17", "desc6"],
  title17: ["title17"],
  desc6: ["desc6"],
  footnote: ["footnote"],
  bodyWrapper6: [
    "bodyWrapper6",
    "intro4",
    "col7",
    "logo9",
    "text44",
    "title27",
    "desc9",
    "img4",
    "bg3",
    "xmlid7457",
    "xmlid6776",
    "xmlid7433",
    "xmlid7339",
    "alert3",
    "icon20",
    "content3",
    "text45",
    "icon21",
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10",
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11",
    "alert2",
    "icon22",
    "check2",
    "content4",
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3",
    "features3",
    "title33",
    "figmaPaste2",
    "contentsItem10",
    "icon23",
    "text61",
    "contentsItem11",
    "icon24",
    "text62",
    "contentsItem12",
    "icon25",
    "text63",
    "contentsItem13",
    "icon26",
    "text64",
    "contentsItem14",
    "icon27",
    "text65",
    "contentsItem15",
    "icon28",
    "text66",
    "contentsItem16",
    "icon29",
    "text67",
    "contentsItem17",
    "icon30",
    "text68"
  ],
  intro4: [
    "intro4",
    "col7",
    "logo9",
    "text44",
    "title27",
    "desc9",
    "img4",
    "bg3",
    "xmlid7457",
    "xmlid6776",
    "xmlid7433",
    "xmlid7339",
    "alert3",
    "icon20",
    "content3",
    "text45",
    "icon21",
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10",
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11",
    "alert2",
    "icon22",
    "check2",
    "content4",
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3"
  ],
  col7: ["col7", "logo9", "text44", "title27", "desc9"],
  logo9: ["logo9"],
  text44: ["text44", "title27", "desc9"],
  title27: ["title27"],
  desc9: ["desc9"],
  img4: [
    "img4",
    "bg3",
    "xmlid7457",
    "xmlid6776",
    "xmlid7433",
    "xmlid7339",
    "alert3",
    "icon20",
    "content3",
    "text45",
    "icon21",
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10",
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11",
    "alert2",
    "icon22",
    "check2",
    "content4",
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3"
  ],
  bg3: ["bg3", "xmlid7457", "xmlid6776", "xmlid7433", "xmlid7339"],
  xmlid7457: ["xmlid7457", "xmlid6776", "xmlid7433", "xmlid7339"],
  xmlid6776: ["xmlid6776"],
  xmlid7433: ["xmlid7433"],
  xmlid7339: ["xmlid7339"],
  alert3: ["alert3", "icon20", "content3", "text45", "icon21"],
  icon20: ["icon20"],
  content3: ["content3", "text45"],
  text45: ["text45"],
  icon21: ["icon21"],
  credits: [
    "credits",
    "header20",
    "subtitle5",
    "title28",
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10"
  ],
  header20: ["header20", "subtitle5", "title28"],
  subtitle5: ["subtitle5"],
  title28: ["title28"],
  main6: [
    "main6",
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10"
  ],
  mockupCmeCredits: [
    "mockupCmeCredits",
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71",
    "mockupButton7",
    "link10"
  ],
  table: [
    "table",
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3",
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50",
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58",
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71"
  ],
  col8: [
    "col8",
    "mockupTableCellText",
    "text46",
    "mockupTableCellAvatar",
    "mockupTableCellAvatar2",
    "mockupTableCellAvatar3"
  ],
  mockupTableCellText: ["mockupTableCellText", "text46"],
  text46: ["text46"],
  mockupTableCellAvatar: ["mockupTableCellAvatar"],
  mockupTableCellAvatar2: ["mockupTableCellAvatar2"],
  mockupTableCellAvatar3: ["mockupTableCellAvatar3"],
  col9: [
    "col9",
    "mockupTableCellText2",
    "text47",
    "mockupTableCellText3",
    "text48",
    "mockupTableCellText4",
    "text49",
    "mockupTableCellText5",
    "text50"
  ],
  mockupTableCellText2: ["mockupTableCellText2", "text47"],
  text47: ["text47"],
  mockupTableCellText3: ["mockupTableCellText3", "text48"],
  text48: ["text48"],
  mockupTableCellText4: ["mockupTableCellText4", "text49"],
  text49: ["text49"],
  mockupTableCellText5: ["mockupTableCellText5", "text50"],
  text50: ["text50"],
  col10: [
    "col10",
    "mockupTableCellText6",
    "text51",
    "mockupTableCellText7",
    "text52",
    "mockupTableCellText8",
    "text57",
    "mockupTableCellText9",
    "text58"
  ],
  mockupTableCellText6: ["mockupTableCellText6", "text51"],
  text51: ["text51"],
  mockupTableCellText7: ["mockupTableCellText7", "text52"],
  text52: ["text52"],
  mockupTableCellText8: ["mockupTableCellText8", "text57"],
  text57: ["text57"],
  mockupTableCellText9: ["mockupTableCellText9", "text58"],
  text58: ["text58"],
  col11: [
    "col11",
    "mockupTableCellText10",
    "text59",
    "mockupTableCellText11",
    "text60",
    "mockupTableCellText12",
    "text70",
    "mockupTableCellText13",
    "text71"
  ],
  mockupTableCellText10: ["mockupTableCellText10", "text59"],
  text59: ["text59"],
  mockupTableCellText11: ["mockupTableCellText11", "text60"],
  text60: ["text60"],
  mockupTableCellText12: ["mockupTableCellText12", "text70"],
  text70: ["text70"],
  mockupTableCellText13: ["mockupTableCellText13", "text71"],
  text71: ["text71"],
  mockupButton7: ["mockupButton7", "link10"],
  link10: ["link10"],
  certificate: [
    "certificate",
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26",
    "mockupButton8",
    "link11"
  ],
  top5: [
    "top5",
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay",
    "title29",
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26"
  ],
  mockupCertificateIcon: [
    "mockupCertificateIcon",
    "bg4",
    "group1",
    "paper1",
    "paper2",
    "cert",
    "award491",
    "overlay"
  ],
  bg4: ["bg4"],
  group1: ["group1", "paper1", "paper2", "cert", "award491"],
  paper1: ["paper1"],
  paper2: ["paper2"],
  cert: ["cert", "award491"],
  award491: ["award491"],
  overlay: ["overlay"],
  title29: ["title29"],
  mockupTextPlaceholder: [
    "mockupTextPlaceholder",
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42",
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50",
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55",
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26"
  ],
  mockupTextPlaceholderParagraph: [
    "mockupTextPlaceholderParagraph",
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38",
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39",
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40",
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41",
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42"
  ],
  mockupTextPlaceholderLine: [
    "mockupTextPlaceholderLine",
    "mockupTextPlaceholderContent37",
    "placeholder38"
  ],
  mockupTextPlaceholderContent37: [
    "mockupTextPlaceholderContent37",
    "placeholder38"
  ],
  placeholder38: ["placeholder38"],
  mockupTextPlaceholderLine2: [
    "mockupTextPlaceholderLine2",
    "mockupTextPlaceholderContent38",
    "placeholder39"
  ],
  mockupTextPlaceholderContent38: [
    "mockupTextPlaceholderContent38",
    "placeholder39"
  ],
  placeholder39: ["placeholder39"],
  mockupTextPlaceholderLine3: [
    "mockupTextPlaceholderLine3",
    "mockupTextPlaceholderContent39",
    "placeholder40"
  ],
  mockupTextPlaceholderContent39: [
    "mockupTextPlaceholderContent39",
    "placeholder40"
  ],
  placeholder40: ["placeholder40"],
  mockupTextPlaceholderLine4: [
    "mockupTextPlaceholderLine4",
    "mockupTextPlaceholderContent40",
    "placeholder41"
  ],
  mockupTextPlaceholderContent40: [
    "mockupTextPlaceholderContent40",
    "placeholder41"
  ],
  placeholder41: ["placeholder41"],
  mockupTextPlaceholderLine5: [
    "mockupTextPlaceholderLine5",
    "mockupTextPlaceholderContent41",
    "placeholder42"
  ],
  mockupTextPlaceholderContent41: [
    "mockupTextPlaceholderContent41",
    "placeholder42"
  ],
  placeholder42: ["placeholder42"],
  mockupTextPlaceholderParagraph2: [
    "mockupTextPlaceholderParagraph2",
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43",
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44",
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45",
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46",
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47",
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48",
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49",
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50"
  ],
  mockupTextPlaceholderLine6: [
    "mockupTextPlaceholderLine6",
    "mockupTextPlaceholderContent42",
    "placeholder43"
  ],
  mockupTextPlaceholderContent42: [
    "mockupTextPlaceholderContent42",
    "placeholder43"
  ],
  placeholder43: ["placeholder43"],
  mockupTextPlaceholderLine7: [
    "mockupTextPlaceholderLine7",
    "mockupTextPlaceholderContent43",
    "placeholder44"
  ],
  mockupTextPlaceholderContent43: [
    "mockupTextPlaceholderContent43",
    "placeholder44"
  ],
  placeholder44: ["placeholder44"],
  mockupTextPlaceholderLine8: [
    "mockupTextPlaceholderLine8",
    "mockupTextPlaceholderContent44",
    "placeholder45"
  ],
  mockupTextPlaceholderContent44: [
    "mockupTextPlaceholderContent44",
    "placeholder45"
  ],
  placeholder45: ["placeholder45"],
  mockupTextPlaceholderLine9: [
    "mockupTextPlaceholderLine9",
    "mockupTextPlaceholderContent45",
    "placeholder46"
  ],
  mockupTextPlaceholderContent45: [
    "mockupTextPlaceholderContent45",
    "placeholder46"
  ],
  placeholder46: ["placeholder46"],
  mockupTextPlaceholderLine10: [
    "mockupTextPlaceholderLine10",
    "mockupTextPlaceholderContent46",
    "placeholder47"
  ],
  mockupTextPlaceholderContent46: [
    "mockupTextPlaceholderContent46",
    "placeholder47"
  ],
  placeholder47: ["placeholder47"],
  mockupTextPlaceholderLine11: [
    "mockupTextPlaceholderLine11",
    "mockupTextPlaceholderContent47",
    "placeholder48"
  ],
  mockupTextPlaceholderContent47: [
    "mockupTextPlaceholderContent47",
    "placeholder48"
  ],
  placeholder48: ["placeholder48"],
  mockupTextPlaceholderLine12: [
    "mockupTextPlaceholderLine12",
    "mockupTextPlaceholderContent48",
    "placeholder49"
  ],
  mockupTextPlaceholderContent48: [
    "mockupTextPlaceholderContent48",
    "placeholder49"
  ],
  placeholder49: ["placeholder49"],
  mockupTextPlaceholderLine13: [
    "mockupTextPlaceholderLine13",
    "mockupTextPlaceholderContent49",
    "placeholder50"
  ],
  mockupTextPlaceholderContent49: [
    "mockupTextPlaceholderContent49",
    "placeholder50"
  ],
  placeholder50: ["placeholder50"],
  mockupTextPlaceholderParagraph3: [
    "mockupTextPlaceholderParagraph3",
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51",
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52",
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53",
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54",
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55"
  ],
  mockupTextPlaceholderLine14: [
    "mockupTextPlaceholderLine14",
    "mockupTextPlaceholderContent50",
    "placeholder51"
  ],
  mockupTextPlaceholderContent50: [
    "mockupTextPlaceholderContent50",
    "placeholder51"
  ],
  placeholder51: ["placeholder51"],
  mockupTextPlaceholderLine15: [
    "mockupTextPlaceholderLine15",
    "mockupTextPlaceholderContent15",
    "placeholder52"
  ],
  mockupTextPlaceholderContent15: [
    "mockupTextPlaceholderContent15",
    "placeholder52"
  ],
  placeholder52: ["placeholder52"],
  mockupTextPlaceholderLine16: [
    "mockupTextPlaceholderLine16",
    "mockupTextPlaceholderContent16",
    "placeholder53"
  ],
  mockupTextPlaceholderContent16: [
    "mockupTextPlaceholderContent16",
    "placeholder53"
  ],
  placeholder53: ["placeholder53"],
  mockupTextPlaceholderLine17: [
    "mockupTextPlaceholderLine17",
    "mockupTextPlaceholderContent17",
    "placeholder54"
  ],
  mockupTextPlaceholderContent17: [
    "mockupTextPlaceholderContent17",
    "placeholder54"
  ],
  placeholder54: ["placeholder54"],
  mockupTextPlaceholderLine18: [
    "mockupTextPlaceholderLine18",
    "mockupTextPlaceholderContent18",
    "placeholder55"
  ],
  mockupTextPlaceholderContent18: [
    "mockupTextPlaceholderContent18",
    "placeholder55"
  ],
  placeholder55: ["placeholder55"],
  mockupTextPlaceholderParagraph4: [
    "mockupTextPlaceholderParagraph4",
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19",
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20",
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21",
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22",
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23",
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24",
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25",
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26"
  ],
  mockupTextPlaceholderLine19: [
    "mockupTextPlaceholderLine19",
    "mockupTextPlaceholderContent19",
    "placeholder19"
  ],
  mockupTextPlaceholderContent19: [
    "mockupTextPlaceholderContent19",
    "placeholder19"
  ],
  placeholder19: ["placeholder19"],
  mockupTextPlaceholderLine20: [
    "mockupTextPlaceholderLine20",
    "mockupTextPlaceholderContent20",
    "placeholder20"
  ],
  mockupTextPlaceholderContent20: [
    "mockupTextPlaceholderContent20",
    "placeholder20"
  ],
  placeholder20: ["placeholder20"],
  mockupTextPlaceholderLine21: [
    "mockupTextPlaceholderLine21",
    "mockupTextPlaceholderContent21",
    "placeholder21"
  ],
  mockupTextPlaceholderContent21: [
    "mockupTextPlaceholderContent21",
    "placeholder21"
  ],
  placeholder21: ["placeholder21"],
  mockupTextPlaceholderLine22: [
    "mockupTextPlaceholderLine22",
    "mockupTextPlaceholderContent22",
    "placeholder22"
  ],
  mockupTextPlaceholderContent22: [
    "mockupTextPlaceholderContent22",
    "placeholder22"
  ],
  placeholder22: ["placeholder22"],
  mockupTextPlaceholderLine23: [
    "mockupTextPlaceholderLine23",
    "mockupTextPlaceholderContent23",
    "placeholder23"
  ],
  mockupTextPlaceholderContent23: [
    "mockupTextPlaceholderContent23",
    "placeholder23"
  ],
  placeholder23: ["placeholder23"],
  mockupTextPlaceholderLine24: [
    "mockupTextPlaceholderLine24",
    "mockupTextPlaceholderContent24",
    "placeholder24"
  ],
  mockupTextPlaceholderContent24: [
    "mockupTextPlaceholderContent24",
    "placeholder24"
  ],
  placeholder24: ["placeholder24"],
  mockupTextPlaceholderLine25: [
    "mockupTextPlaceholderLine25",
    "mockupTextPlaceholderContent25",
    "placeholder25"
  ],
  mockupTextPlaceholderContent25: [
    "mockupTextPlaceholderContent25",
    "placeholder25"
  ],
  placeholder25: ["placeholder25"],
  mockupTextPlaceholderLine26: [
    "mockupTextPlaceholderLine26",
    "mockupTextPlaceholderContent26",
    "placeholder26"
  ],
  mockupTextPlaceholderContent26: [
    "mockupTextPlaceholderContent26",
    "placeholder26"
  ],
  placeholder26: ["placeholder26"],
  mockupButton8: ["mockupButton8", "link11"],
  link11: ["link11"],
  alert2: ["alert2", "icon22", "check2", "content4"],
  icon22: ["icon22", "check2"],
  check2: ["check2"],
  content4: ["content4"],
  report: [
    "report",
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32",
    "shade3"
  ],
  bill: [
    "bill",
    "header21",
    "subtitle9",
    "title30",
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7",
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32"
  ],
  header21: ["header21", "subtitle9", "title30"],
  subtitle9: ["subtitle9"],
  title30: ["title30"],
  main7: [
    "main7",
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7"
  ],
  placeholder27: [
    "placeholder27",
    "header22",
    "title31",
    "date",
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6",
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7"
  ],
  header22: ["header22", "title31", "date"],
  title31: ["title31"],
  date: ["date"],
  section: [
    "section",
    "head",
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32",
    "total",
    "title32",
    "val6"
  ],
  head: ["head"],
  mockupTextPlaceholderParagraph5: [
    "mockupTextPlaceholderParagraph5",
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28",
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29",
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30",
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31",
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32"
  ],
  mockupTextPlaceholderLine27: [
    "mockupTextPlaceholderLine27",
    "mockupTextPlaceholderContent27",
    "placeholder28"
  ],
  mockupTextPlaceholderContent27: [
    "mockupTextPlaceholderContent27",
    "placeholder28"
  ],
  placeholder28: ["placeholder28"],
  mockupTextPlaceholderLine28: [
    "mockupTextPlaceholderLine28",
    "mockupTextPlaceholderContent28",
    "placeholder29"
  ],
  mockupTextPlaceholderContent28: [
    "mockupTextPlaceholderContent28",
    "placeholder29"
  ],
  placeholder29: ["placeholder29"],
  mockupTextPlaceholderLine29: [
    "mockupTextPlaceholderLine29",
    "mockupTextPlaceholderContent29",
    "placeholder30"
  ],
  mockupTextPlaceholderContent29: [
    "mockupTextPlaceholderContent29",
    "placeholder30"
  ],
  placeholder30: ["placeholder30"],
  mockupTextPlaceholderLine30: [
    "mockupTextPlaceholderLine30",
    "mockupTextPlaceholderContent30",
    "placeholder31"
  ],
  mockupTextPlaceholderContent30: [
    "mockupTextPlaceholderContent30",
    "placeholder31"
  ],
  placeholder31: ["placeholder31"],
  mockupTextPlaceholderLine31: [
    "mockupTextPlaceholderLine31",
    "mockupTextPlaceholderContent31",
    "placeholder32"
  ],
  mockupTextPlaceholderContent31: [
    "mockupTextPlaceholderContent31",
    "placeholder32"
  ],
  placeholder32: ["placeholder32"],
  total: ["total", "title32", "val6"],
  title32: ["title32"],
  val6: ["val6"],
  section2: [
    "section2",
    "head2",
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37",
    "total2",
    "title34",
    "val7"
  ],
  head2: ["head2"],
  mockupTextPlaceholderParagraph6: [
    "mockupTextPlaceholderParagraph6",
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33",
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34",
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35",
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36",
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37"
  ],
  mockupTextPlaceholderLine32: [
    "mockupTextPlaceholderLine32",
    "mockupTextPlaceholderContent32",
    "placeholder33"
  ],
  mockupTextPlaceholderContent32: [
    "mockupTextPlaceholderContent32",
    "placeholder33"
  ],
  placeholder33: ["placeholder33"],
  mockupTextPlaceholderLine33: [
    "mockupTextPlaceholderLine33",
    "mockupTextPlaceholderContent33",
    "placeholder34"
  ],
  mockupTextPlaceholderContent33: [
    "mockupTextPlaceholderContent33",
    "placeholder34"
  ],
  placeholder34: ["placeholder34"],
  mockupTextPlaceholderLine34: [
    "mockupTextPlaceholderLine34",
    "mockupTextPlaceholderContent34",
    "placeholder35"
  ],
  mockupTextPlaceholderContent34: [
    "mockupTextPlaceholderContent34",
    "placeholder35"
  ],
  placeholder35: ["placeholder35"],
  mockupTextPlaceholderLine35: [
    "mockupTextPlaceholderLine35",
    "mockupTextPlaceholderContent35",
    "placeholder36"
  ],
  mockupTextPlaceholderContent35: [
    "mockupTextPlaceholderContent35",
    "placeholder36"
  ],
  placeholder36: ["placeholder36"],
  mockupTextPlaceholderLine36: [
    "mockupTextPlaceholderLine36",
    "mockupTextPlaceholderContent36",
    "placeholder37"
  ],
  mockupTextPlaceholderContent36: [
    "mockupTextPlaceholderContent36",
    "placeholder37"
  ],
  placeholder37: ["placeholder37"],
  total2: ["total2", "title34", "val7"],
  title34: ["title34"],
  val7: ["val7"],
  edge: [
    "edge",
    "tri",
    "rect",
    "tri2",
    "rect2",
    "tri3",
    "rect3",
    "tri4",
    "rect4",
    "tri5",
    "rect5",
    "tri6",
    "rect6",
    "tri7",
    "rect7",
    "tri8",
    "rect8",
    "tri9",
    "rect9",
    "tri10",
    "rect10",
    "tri11",
    "rect11",
    "tri12",
    "rect12",
    "tri13",
    "rect13",
    "tri14",
    "rect14",
    "tri15",
    "rect15",
    "tri16",
    "rect16",
    "tri17",
    "rect17",
    "tri18",
    "rect18",
    "tri19",
    "rect19",
    "tri20",
    "rect20",
    "tri21",
    "rect21",
    "tri22",
    "rect22",
    "tri23",
    "rect23",
    "tri24",
    "rect24",
    "tri25",
    "rect25",
    "tri26",
    "rect26",
    "tri27",
    "rect27",
    "tri28",
    "rect28",
    "tri29",
    "rect29",
    "tri30",
    "rect30",
    "tri31",
    "rect31",
    "tri32",
    "rect32"
  ],
  tri: ["tri", "rect"],
  rect: ["rect"],
  tri2: ["tri2", "rect2"],
  rect2: ["rect2"],
  tri3: ["tri3", "rect3"],
  rect3: ["rect3"],
  tri4: ["tri4", "rect4"],
  rect4: ["rect4"],
  tri5: ["tri5", "rect5"],
  rect5: ["rect5"],
  tri6: ["tri6", "rect6"],
  rect6: ["rect6"],
  tri7: ["tri7", "rect7"],
  rect7: ["rect7"],
  tri8: ["tri8", "rect8"],
  rect8: ["rect8"],
  tri9: ["tri9", "rect9"],
  rect9: ["rect9"],
  tri10: ["tri10", "rect10"],
  rect10: ["rect10"],
  tri11: ["tri11", "rect11"],
  rect11: ["rect11"],
  tri12: ["tri12", "rect12"],
  rect12: ["rect12"],
  tri13: ["tri13", "rect13"],
  rect13: ["rect13"],
  tri14: ["tri14", "rect14"],
  rect14: ["rect14"],
  tri15: ["tri15", "rect15"],
  rect15: ["rect15"],
  tri16: ["tri16", "rect16"],
  rect16: ["rect16"],
  tri17: ["tri17", "rect17"],
  rect17: ["rect17"],
  tri18: ["tri18", "rect18"],
  rect18: ["rect18"],
  tri19: ["tri19", "rect19"],
  rect19: ["rect19"],
  tri20: ["tri20", "rect20"],
  rect20: ["rect20"],
  tri21: ["tri21", "rect21"],
  rect21: ["rect21"],
  tri22: ["tri22", "rect22"],
  rect22: ["rect22"],
  tri23: ["tri23", "rect23"],
  rect23: ["rect23"],
  tri24: ["tri24", "rect24"],
  rect24: ["rect24"],
  tri25: ["tri25", "rect25"],
  rect25: ["rect25"],
  tri26: ["tri26", "rect26"],
  rect26: ["rect26"],
  tri27: ["tri27", "rect27"],
  rect27: ["rect27"],
  tri28: ["tri28", "rect28"],
  rect28: ["rect28"],
  tri29: ["tri29", "rect29"],
  rect29: ["rect29"],
  tri30: ["tri30", "rect30"],
  rect30: ["rect30"],
  tri31: ["tri31", "rect31"],
  rect31: ["rect31"],
  tri32: ["tri32", "rect32"],
  rect32: ["rect32"],
  shade3: ["shade3"],
  features3: [
    "features3",
    "title33",
    "figmaPaste2",
    "contentsItem10",
    "icon23",
    "text61",
    "contentsItem11",
    "icon24",
    "text62",
    "contentsItem12",
    "icon25",
    "text63",
    "contentsItem13",
    "icon26",
    "text64",
    "contentsItem14",
    "icon27",
    "text65",
    "contentsItem15",
    "icon28",
    "text66",
    "contentsItem16",
    "icon29",
    "text67",
    "contentsItem17",
    "icon30",
    "text68"
  ],
  title33: ["title33"],
  figmaPaste2: [
    "figmaPaste2",
    "contentsItem10",
    "icon23",
    "text61",
    "contentsItem11",
    "icon24",
    "text62",
    "contentsItem12",
    "icon25",
    "text63",
    "contentsItem13",
    "icon26",
    "text64",
    "contentsItem14",
    "icon27",
    "text65",
    "contentsItem15",
    "icon28",
    "text66",
    "contentsItem16",
    "icon29",
    "text67",
    "contentsItem17",
    "icon30",
    "text68"
  ],
  contentsItem10: ["contentsItem10", "icon23", "text61"],
  icon23: ["icon23"],
  text61: ["text61"],
  contentsItem11: ["contentsItem11", "icon24", "text62"],
  icon24: ["icon24"],
  text62: ["text62"],
  contentsItem12: ["contentsItem12", "icon25", "text63"],
  icon25: ["icon25"],
  text63: ["text63"],
  contentsItem13: ["contentsItem13", "icon26", "text64"],
  icon26: ["icon26"],
  text64: ["text64"],
  contentsItem14: ["contentsItem14", "icon27", "text65"],
  icon27: ["icon27"],
  text65: ["text65"],
  contentsItem15: ["contentsItem15", "icon28", "text66"],
  icon28: ["icon28"],
  text66: ["text66"],
  contentsItem16: ["contentsItem16", "icon29", "text67"],
  icon29: ["icon29"],
  text67: ["text67"],
  contentsItem17: ["contentsItem17", "icon30", "text68"],
  icon30: ["icon30"],
  text68: ["text68"],
  bodyWrapper5: [
    "bodyWrapper5",
    "intro3",
    "col5",
    "logo8",
    "text",
    "title18",
    "desc8",
    "img3",
    "bg2",
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value",
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2",
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5",
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5",
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34",
    "alert",
    "icon9",
    "content2",
    "text35",
    "icon10",
    "features",
    "title5",
    "figmaPaste",
    "contentsItem",
    "icon11",
    "text36",
    "contentsItem2",
    "icon12",
    "text37",
    "contentsItem3",
    "icon13",
    "text38",
    "contentsItem4",
    "icon14",
    "text39",
    "contentsItem5",
    "icon15",
    "text5",
    "contentsItem6",
    "icon16",
    "text40",
    "contentsItem7",
    "icon17",
    "text41",
    "contentsItem8",
    "icon18",
    "text42",
    "contentsItem9",
    "icon19",
    "text43"
  ],
  intro3: [
    "intro3",
    "col5",
    "logo8",
    "text",
    "title18",
    "desc8",
    "img3",
    "bg2",
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value",
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2",
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5",
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5",
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34",
    "alert",
    "icon9",
    "content2",
    "text35",
    "icon10"
  ],
  col5: ["col5", "logo8", "text", "title18", "desc8"],
  logo8: ["logo8"],
  text: ["text", "title18", "desc8"],
  title18: ["title18"],
  desc8: ["desc8"],
  img3: [
    "img3",
    "bg2",
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value",
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2",
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5",
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5",
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34",
    "alert",
    "icon9",
    "content2",
    "text35",
    "icon10"
  ],
  bg2: ["bg2"],
  reimbursement: [
    "reimbursement",
    "header11",
    "subtitle4",
    "title19",
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value"
  ],
  header11: ["header11", "subtitle4", "title19"],
  subtitle4: ["subtitle4"],
  title19: ["title19"],
  main4: [
    "main4",
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value"
  ],
  placeholder16: [
    "placeholder16",
    "row",
    "prop",
    "label10",
    "val",
    "prop2",
    "label11",
    "val2",
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value"
  ],
  row: ["row", "prop", "label10", "val", "prop2", "label11", "val2"],
  prop: ["prop", "label10", "val"],
  label10: ["label10"],
  val: ["val"],
  prop2: ["prop2", "label11", "val2"],
  label11: ["label11"],
  val2: ["val2"],
  mockupProgressBarWithTitle: [
    "mockupProgressBarWithTitle",
    "header12",
    "title20",
    "val3",
    "bar",
    "value"
  ],
  header12: ["header12", "title20", "val3"],
  title20: ["title20"],
  val3: ["val3"],
  bar: ["bar", "value"],
  value: ["value"],
  demographics: [
    "demographics",
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8",
    "shade2"
  ],
  demographics2: [
    "demographics2",
    "header13",
    "subtitle7",
    "title4",
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8"
  ],
  header13: ["header13", "subtitle7", "title4"],
  subtitle7: ["subtitle7"],
  title4: ["title4"],
  main5: [
    "main5",
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8"
  ],
  placeholder17: [
    "placeholder17",
    "row2",
    "header14",
    "name6",
    "error",
    "tip",
    "label3",
    "link6",
    "row6",
    "header15",
    "name7",
    "error2",
    "tip2",
    "label4",
    "link7",
    "row7",
    "header16",
    "name8",
    "error3",
    "tip3",
    "label5",
    "link8"
  ],
  row2: ["row2", "header14", "name6", "error", "tip", "label3", "link6"],
  header14: ["header14", "name6"],
  name6: ["name6"],
  error: ["error", "tip", "label3", "link6"],
  tip: ["tip"],
  label3: ["label3"],
  link6: ["link6"],
  row6: ["row6", "header15", "name7", "error2", "tip2", "label4", "link7"],
  header15: ["header15", "name7"],
  name7: ["name7"],
  error2: ["error2", "tip2", "label4", "link7"],
  tip2: ["tip2"],
  label4: ["label4"],
  link7: ["link7"],
  row7: ["row7", "header16", "name8", "error3", "tip3", "label5", "link8"],
  header16: ["header16", "name8"],
  name8: ["name8"],
  error3: ["error3", "tip3", "label5", "link8"],
  tip3: ["tip3"],
  label5: ["label5"],
  link8: ["link8"],
  shade2: ["shade2"],
  cap: [
    "cap",
    "header17",
    "subtitle8",
    "title21",
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5"
  ],
  header17: ["header17", "subtitle8", "title21"],
  subtitle8: ["subtitle8"],
  title21: ["title21"],
  main3: [
    "main3",
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5"
  ],
  placeholder18: [
    "placeholder18",
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon",
    "row5",
    "prop3",
    "label7",
    "val4",
    "prop4",
    "label8",
    "val5"
  ],
  field: [
    "field",
    "label6",
    "select",
    "input",
    "leftIcon",
    "text25",
    "rightIcon"
  ],
  label6: ["label6"],
  select: ["select", "input", "leftIcon", "text25", "rightIcon"],
  input: ["input", "leftIcon", "text25", "rightIcon"],
  leftIcon: ["leftIcon"],
  text25: ["text25"],
  rightIcon: ["rightIcon"],
  row5: ["row5", "prop3", "label7", "val4", "prop4", "label8", "val5"],
  prop3: ["prop3", "label7", "val4"],
  label7: ["label7"],
  val4: ["val4"],
  prop4: ["prop4", "label8", "val5"],
  label8: ["label8"],
  val5: ["val5"],
  profile3: [
    "profile3",
    "av3",
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5"
  ],
  av3: ["av3"],
  col6: [
    "col6",
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5",
    "actions3",
    "mockupButton5",
    "link9",
    "mockupButton6",
    "link5"
  ],
  top4: [
    "top4",
    "header18",
    "name9",
    "status3",
    "label9",
    "body8",
    "year3",
    "name5"
  ],
  header18: ["header18", "name9", "status3", "label9"],
  name9: ["name9"],
  status3: ["status3", "label9"],
  label9: ["label9"],
  body8: ["body8", "year3", "name5"],
  year3: ["year3"],
  name5: ["name5"],
  actions3: ["actions3", "mockupButton5", "link9", "mockupButton6", "link5"],
  mockupButton5: ["mockupButton5", "link9"],
  link9: ["link9"],
  mockupButton6: ["mockupButton6", "link5"],
  link5: ["link5"],
  menu2: [
    "menu2",
    "header19",
    "title22",
    "icon8",
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34"
  ],
  header19: ["header19", "title22", "icon8"],
  title22: ["title22"],
  icon8: ["icon8"],
  list: [
    "list",
    "item23",
    "text26",
    "item24",
    "text4",
    "item25",
    "text27",
    "item26",
    "text28",
    "item27",
    "text29",
    "item28",
    "text30",
    "item29",
    "text31",
    "item30",
    "text32",
    "item31",
    "text33",
    "item32",
    "text34"
  ],
  item23: ["item23", "text26"],
  text26: ["text26"],
  item24: ["item24", "text4"],
  text4: ["text4"],
  item25: ["item25", "text27"],
  text27: ["text27"],
  item26: ["item26", "text28"],
  text28: ["text28"],
  item27: ["item27", "text29"],
  text29: ["text29"],
  item28: ["item28", "text30"],
  text30: ["text30"],
  item29: ["item29", "text31"],
  text31: ["text31"],
  item30: ["item30", "text32"],
  text32: ["text32"],
  item31: ["item31", "text33"],
  text33: ["text33"],
  item32: ["item32", "text34"],
  text34: ["text34"],
  alert: ["alert", "icon9", "content2", "text35", "icon10"],
  icon9: ["icon9"],
  content2: ["content2", "text35"],
  text35: ["text35"],
  icon10: ["icon10"],
  features: [
    "features",
    "title5",
    "figmaPaste",
    "contentsItem",
    "icon11",
    "text36",
    "contentsItem2",
    "icon12",
    "text37",
    "contentsItem3",
    "icon13",
    "text38",
    "contentsItem4",
    "icon14",
    "text39",
    "contentsItem5",
    "icon15",
    "text5",
    "contentsItem6",
    "icon16",
    "text40",
    "contentsItem7",
    "icon17",
    "text41",
    "contentsItem8",
    "icon18",
    "text42",
    "contentsItem9",
    "icon19",
    "text43"
  ],
  title5: ["title5"],
  figmaPaste: [
    "figmaPaste",
    "contentsItem",
    "icon11",
    "text36",
    "contentsItem2",
    "icon12",
    "text37",
    "contentsItem3",
    "icon13",
    "text38",
    "contentsItem4",
    "icon14",
    "text39",
    "contentsItem5",
    "icon15",
    "text5",
    "contentsItem6",
    "icon16",
    "text40",
    "contentsItem7",
    "icon17",
    "text41",
    "contentsItem8",
    "icon18",
    "text42",
    "contentsItem9",
    "icon19",
    "text43"
  ],
  contentsItem: ["contentsItem", "icon11", "text36"],
  icon11: ["icon11"],
  text36: ["text36"],
  contentsItem2: ["contentsItem2", "icon12", "text37"],
  icon12: ["icon12"],
  text37: ["text37"],
  contentsItem3: ["contentsItem3", "icon13", "text38"],
  icon13: ["icon13"],
  text38: ["text38"],
  contentsItem4: ["contentsItem4", "icon14", "text39"],
  icon14: ["icon14"],
  text39: ["text39"],
  contentsItem5: ["contentsItem5", "icon15", "text5"],
  icon15: ["icon15"],
  text5: ["text5"],
  contentsItem6: ["contentsItem6", "icon16", "text40"],
  icon16: ["icon16"],
  text40: ["text40"],
  contentsItem7: ["contentsItem7", "icon17", "text41"],
  icon17: ["icon17"],
  text41: ["text41"],
  contentsItem8: ["contentsItem8", "icon18", "text42"],
  icon18: ["icon18"],
  text42: ["text42"],
  contentsItem9: ["contentsItem9", "icon19", "text43"],
  icon19: ["icon19"],
  text43: ["text43"],
  mobileWrapper: [
    "mobileWrapper",
    "header",
    "top",
    "subtitle2",
    "title2",
    "body"
  ],
  header: ["header", "top", "subtitle2", "title2", "body"],
  top: ["top", "subtitle2", "title2"],
  subtitle2: ["subtitle2"],
  title2: ["title2"],
  body: ["body"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  productsSection: "section";
  productsProvider: typeof DataProvider;
  desktopWrapper: "div";
  intro2: "div";
  header9: "div";
  top3: "div";
  subtitle: "div";
  title: "div";
  body6: "div";
  col4: "div";
  nav: "div";
  img2: "div";
  logoIcon: "div";
  logo7: typeof Logo;
  logo2: typeof Logo;
  logo3: typeof Logo;
  productTabs: typeof AntdTabs;
  content: "div";
  placeholder: "div";
  intro: "div";
  col: "div";
  logo: typeof Logo;
  text53: "div";
  title23: "div";
  desc: "div";
  img: "div";
  img6: "div";
  areas: "div";
  header10: "div";
  title11: "div";
  body7: "div";
  frame22: "div";
  item17: "div";
  title12: "div";
  desc7: "div";
  item18: "div";
  title13: "div";
  desc2: "div";
  item19: "div";
  title14: "div";
  desc3: "div";
  item20: "div";
  title15: "div";
  desc4: "div";
  item21: "div";
  title16: "div";
  desc5: "div";
  item22: "div";
  title17: "div";
  desc6: "div";
  footnote: "div";
  bodyWrapper6: "div";
  intro4: "div";
  col7: "div";
  logo9: typeof Logo;
  text44: "div";
  title27: "div";
  desc9: "div";
  img4: "div";
  bg3: "div";
  xmlid7457: "div";
  xmlid6776: "div";
  xmlid7433: "div";
  xmlid7339: "div";
  alert3: "div";
  icon20: "div";
  content3: "div";
  text45: "div";
  icon21: "div";
  credits: "div";
  header20: "div";
  subtitle5: "div";
  title28: "div";
  main6: "div";
  mockupCmeCredits: "div";
  table: "div";
  col8: "div";
  mockupTableCellText: "div";
  text46: "div";
  mockupTableCellAvatar: "div";
  mockupTableCellAvatar2: "div";
  mockupTableCellAvatar3: "div";
  col9: "div";
  mockupTableCellText2: "div";
  text47: "div";
  mockupTableCellText3: "div";
  text48: "div";
  mockupTableCellText4: "div";
  text49: "div";
  mockupTableCellText5: "div";
  text50: "div";
  col10: "div";
  mockupTableCellText6: "div";
  text51: "div";
  mockupTableCellText7: "div";
  text52: "div";
  mockupTableCellText8: "div";
  text57: "div";
  mockupTableCellText9: "div";
  text58: "div";
  col11: "div";
  mockupTableCellText10: "div";
  text59: "div";
  mockupTableCellText11: "div";
  text60: "div";
  mockupTableCellText12: "div";
  text70: "div";
  mockupTableCellText13: "div";
  text71: "div";
  mockupButton7: "div";
  link10: "div";
  certificate: "div";
  top5: "div";
  mockupCertificateIcon: "div";
  bg4: "div";
  group1: "div";
  paper1: "div";
  paper2: "div";
  cert: "div";
  award491: "div";
  overlay: "div";
  title29: "div";
  mockupTextPlaceholder: "div";
  mockupTextPlaceholderParagraph: "div";
  mockupTextPlaceholderLine: "div";
  mockupTextPlaceholderContent37: "div";
  placeholder38: "div";
  mockupTextPlaceholderLine2: "div";
  mockupTextPlaceholderContent38: "div";
  placeholder39: "div";
  mockupTextPlaceholderLine3: "div";
  mockupTextPlaceholderContent39: "div";
  placeholder40: "div";
  mockupTextPlaceholderLine4: "div";
  mockupTextPlaceholderContent40: "div";
  placeholder41: "div";
  mockupTextPlaceholderLine5: "div";
  mockupTextPlaceholderContent41: "div";
  placeholder42: "div";
  mockupTextPlaceholderParagraph2: "div";
  mockupTextPlaceholderLine6: "div";
  mockupTextPlaceholderContent42: "div";
  placeholder43: "div";
  mockupTextPlaceholderLine7: "div";
  mockupTextPlaceholderContent43: "div";
  placeholder44: "div";
  mockupTextPlaceholderLine8: "div";
  mockupTextPlaceholderContent44: "div";
  placeholder45: "div";
  mockupTextPlaceholderLine9: "div";
  mockupTextPlaceholderContent45: "div";
  placeholder46: "div";
  mockupTextPlaceholderLine10: "div";
  mockupTextPlaceholderContent46: "div";
  placeholder47: "div";
  mockupTextPlaceholderLine11: "div";
  mockupTextPlaceholderContent47: "div";
  placeholder48: "div";
  mockupTextPlaceholderLine12: "div";
  mockupTextPlaceholderContent48: "div";
  placeholder49: "div";
  mockupTextPlaceholderLine13: "div";
  mockupTextPlaceholderContent49: "div";
  placeholder50: "div";
  mockupTextPlaceholderParagraph3: "div";
  mockupTextPlaceholderLine14: "div";
  mockupTextPlaceholderContent50: "div";
  placeholder51: "div";
  mockupTextPlaceholderLine15: "div";
  mockupTextPlaceholderContent15: "div";
  placeholder52: "div";
  mockupTextPlaceholderLine16: "div";
  mockupTextPlaceholderContent16: "div";
  placeholder53: "div";
  mockupTextPlaceholderLine17: "div";
  mockupTextPlaceholderContent17: "div";
  placeholder54: "div";
  mockupTextPlaceholderLine18: "div";
  mockupTextPlaceholderContent18: "div";
  placeholder55: "div";
  mockupTextPlaceholderParagraph4: "div";
  mockupTextPlaceholderLine19: "div";
  mockupTextPlaceholderContent19: "div";
  placeholder19: "div";
  mockupTextPlaceholderLine20: "div";
  mockupTextPlaceholderContent20: "div";
  placeholder20: "div";
  mockupTextPlaceholderLine21: "div";
  mockupTextPlaceholderContent21: "div";
  placeholder21: "div";
  mockupTextPlaceholderLine22: "div";
  mockupTextPlaceholderContent22: "div";
  placeholder22: "div";
  mockupTextPlaceholderLine23: "div";
  mockupTextPlaceholderContent23: "div";
  placeholder23: "div";
  mockupTextPlaceholderLine24: "div";
  mockupTextPlaceholderContent24: "div";
  placeholder24: "div";
  mockupTextPlaceholderLine25: "div";
  mockupTextPlaceholderContent25: "div";
  placeholder25: "div";
  mockupTextPlaceholderLine26: "div";
  mockupTextPlaceholderContent26: "div";
  placeholder26: "div";
  mockupButton8: "div";
  link11: "div";
  alert2: "div";
  icon22: "div";
  check2: "div";
  content4: "div";
  report: "div";
  bill: "div";
  header21: "div";
  subtitle9: "div";
  title30: "div";
  main7: "div";
  placeholder27: "div";
  header22: "div";
  title31: "div";
  date: "div";
  section: "div";
  head: "div";
  mockupTextPlaceholderParagraph5: "div";
  mockupTextPlaceholderLine27: "div";
  mockupTextPlaceholderContent27: "div";
  placeholder28: "div";
  mockupTextPlaceholderLine28: "div";
  mockupTextPlaceholderContent28: "div";
  placeholder29: "div";
  mockupTextPlaceholderLine29: "div";
  mockupTextPlaceholderContent29: "div";
  placeholder30: "div";
  mockupTextPlaceholderLine30: "div";
  mockupTextPlaceholderContent30: "div";
  placeholder31: "div";
  mockupTextPlaceholderLine31: "div";
  mockupTextPlaceholderContent31: "div";
  placeholder32: "div";
  total: "div";
  title32: "div";
  val6: "div";
  section2: "div";
  head2: "div";
  mockupTextPlaceholderParagraph6: "div";
  mockupTextPlaceholderLine32: "div";
  mockupTextPlaceholderContent32: "div";
  placeholder33: "div";
  mockupTextPlaceholderLine33: "div";
  mockupTextPlaceholderContent33: "div";
  placeholder34: "div";
  mockupTextPlaceholderLine34: "div";
  mockupTextPlaceholderContent34: "div";
  placeholder35: "div";
  mockupTextPlaceholderLine35: "div";
  mockupTextPlaceholderContent35: "div";
  placeholder36: "div";
  mockupTextPlaceholderLine36: "div";
  mockupTextPlaceholderContent36: "div";
  placeholder37: "div";
  total2: "div";
  title34: "div";
  val7: "div";
  edge: "div";
  tri: "div";
  rect: "div";
  tri2: "div";
  rect2: "div";
  tri3: "div";
  rect3: "div";
  tri4: "div";
  rect4: "div";
  tri5: "div";
  rect5: "div";
  tri6: "div";
  rect6: "div";
  tri7: "div";
  rect7: "div";
  tri8: "div";
  rect8: "div";
  tri9: "div";
  rect9: "div";
  tri10: "div";
  rect10: "div";
  tri11: "div";
  rect11: "div";
  tri12: "div";
  rect12: "div";
  tri13: "div";
  rect13: "div";
  tri14: "div";
  rect14: "div";
  tri15: "div";
  rect15: "div";
  tri16: "div";
  rect16: "div";
  tri17: "div";
  rect17: "div";
  tri18: "div";
  rect18: "div";
  tri19: "div";
  rect19: "div";
  tri20: "div";
  rect20: "div";
  tri21: "div";
  rect21: "div";
  tri22: "div";
  rect22: "div";
  tri23: "div";
  rect23: "div";
  tri24: "div";
  rect24: "div";
  tri25: "div";
  rect25: "div";
  tri26: "div";
  rect26: "div";
  tri27: "div";
  rect27: "div";
  tri28: "div";
  rect28: "div";
  tri29: "div";
  rect29: "div";
  tri30: "div";
  rect30: "div";
  tri31: "div";
  rect31: "div";
  tri32: "div";
  rect32: "div";
  shade3: "div";
  features3: "div";
  title33: "div";
  figmaPaste2: "div";
  contentsItem10: "div";
  icon23: "div";
  text61: "div";
  contentsItem11: "div";
  icon24: "div";
  text62: "div";
  contentsItem12: "div";
  icon25: "div";
  text63: "div";
  contentsItem13: "div";
  icon26: "div";
  text64: "div";
  contentsItem14: "div";
  icon27: "div";
  text65: "div";
  contentsItem15: "div";
  icon28: "div";
  text66: "div";
  contentsItem16: "div";
  icon29: "div";
  text67: "div";
  contentsItem17: "div";
  icon30: "div";
  text68: "div";
  bodyWrapper5: "div";
  intro3: "div";
  col5: "div";
  logo8: typeof Logo;
  text: "div";
  title18: "div";
  desc8: "div";
  img3: "div";
  bg2: "div";
  reimbursement: "div";
  header11: "div";
  subtitle4: "div";
  title19: "div";
  main4: "div";
  placeholder16: "div";
  row: "div";
  prop: "div";
  label10: "div";
  val: "div";
  prop2: "div";
  label11: "div";
  val2: "div";
  mockupProgressBarWithTitle: "div";
  header12: "div";
  title20: "div";
  val3: "div";
  bar: "div";
  value: "div";
  demographics: "div";
  demographics2: "div";
  header13: "div";
  subtitle7: "div";
  title4: "div";
  main5: "div";
  placeholder17: "div";
  row2: "div";
  header14: "div";
  name6: "div";
  error: "div";
  tip: "div";
  label3: "div";
  link6: "div";
  row6: "div";
  header15: "div";
  name7: "div";
  error2: "div";
  tip2: "div";
  label4: "div";
  link7: "div";
  row7: "div";
  header16: "div";
  name8: "div";
  error3: "div";
  tip3: "div";
  label5: "div";
  link8: "div";
  shade2: "div";
  cap: "div";
  header17: "div";
  subtitle8: "div";
  title21: "div";
  main3: "div";
  placeholder18: "div";
  field: "div";
  label6: "div";
  select: "div";
  input: "div";
  leftIcon: "div";
  text25: "div";
  rightIcon: "div";
  row5: "div";
  prop3: "div";
  label7: "div";
  val4: "div";
  prop4: "div";
  label8: "div";
  val5: "div";
  profile3: "div";
  av3: "div";
  col6: "div";
  top4: "div";
  header18: "div";
  name9: "div";
  status3: "div";
  label9: "div";
  body8: "div";
  year3: "div";
  name5: "div";
  actions3: "div";
  mockupButton5: "div";
  link9: "div";
  mockupButton6: "div";
  link5: "div";
  menu2: "div";
  header19: "div";
  title22: "div";
  icon8: "div";
  list: "div";
  item23: "div";
  text26: "div";
  item24: "div";
  text4: "div";
  item25: "div";
  text27: "div";
  item26: "div";
  text28: "div";
  item27: "div";
  text29: "div";
  item28: "div";
  text30: "div";
  item29: "div";
  text31: "div";
  item30: "div";
  text32: "div";
  item31: "div";
  text33: "div";
  item32: "div";
  text34: "div";
  alert: "div";
  icon9: "div";
  content2: "div";
  text35: "div";
  icon10: "div";
  features: "div";
  title5: "div";
  figmaPaste: "div";
  contentsItem: "div";
  icon11: "div";
  text36: "div";
  contentsItem2: "div";
  icon12: "div";
  text37: "div";
  contentsItem3: "div";
  icon13: "div";
  text38: "div";
  contentsItem4: "div";
  icon14: "div";
  text39: "div";
  contentsItem5: "div";
  icon15: "div";
  text5: "div";
  contentsItem6: "div";
  icon16: "div";
  text40: "div";
  contentsItem7: "div";
  icon17: "div";
  text41: "div";
  contentsItem8: "div";
  icon18: "div";
  text42: "div";
  contentsItem9: "div";
  icon19: "div";
  text43: "div";
  mobileWrapper: "div";
  header: "div";
  top: "div";
  subtitle2: "div";
  title2: "div";
  body: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomeProductsSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomeProductsSection__VariantsArgs;
    args?: PlasmicHomeProductsSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomeProductsSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomeProductsSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomeProductsSection__ArgProps,
          internalVariantPropNames: PlasmicHomeProductsSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomeProductsSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "productsSection") {
    func.displayName = "PlasmicHomeProductsSection";
  } else {
    func.displayName = `PlasmicHomeProductsSection.${nodeName}`;
  }
  return func;
}

export const PlasmicHomeProductsSection = Object.assign(
  // Top-level PlasmicHomeProductsSection renders the root element
  makeNodeComponent("productsSection"),
  {
    // Helper components rendering sub-elements
    productsProvider: makeNodeComponent("productsProvider"),
    desktopWrapper: makeNodeComponent("desktopWrapper"),
    intro2: makeNodeComponent("intro2"),
    header9: makeNodeComponent("header9"),
    top3: makeNodeComponent("top3"),
    subtitle: makeNodeComponent("subtitle"),
    title: makeNodeComponent("title"),
    body6: makeNodeComponent("body6"),
    col4: makeNodeComponent("col4"),
    nav: makeNodeComponent("nav"),
    img2: makeNodeComponent("img2"),
    logoIcon: makeNodeComponent("logoIcon"),
    logo7: makeNodeComponent("logo7"),
    logo2: makeNodeComponent("logo2"),
    logo3: makeNodeComponent("logo3"),
    productTabs: makeNodeComponent("productTabs"),
    content: makeNodeComponent("content"),
    placeholder: makeNodeComponent("placeholder"),
    intro: makeNodeComponent("intro"),
    col: makeNodeComponent("col"),
    logo: makeNodeComponent("logo"),
    text53: makeNodeComponent("text53"),
    title23: makeNodeComponent("title23"),
    desc: makeNodeComponent("desc"),
    img: makeNodeComponent("img"),
    img6: makeNodeComponent("img6"),
    areas: makeNodeComponent("areas"),
    header10: makeNodeComponent("header10"),
    title11: makeNodeComponent("title11"),
    body7: makeNodeComponent("body7"),
    frame22: makeNodeComponent("frame22"),
    item17: makeNodeComponent("item17"),
    title12: makeNodeComponent("title12"),
    desc7: makeNodeComponent("desc7"),
    item18: makeNodeComponent("item18"),
    title13: makeNodeComponent("title13"),
    desc2: makeNodeComponent("desc2"),
    item19: makeNodeComponent("item19"),
    title14: makeNodeComponent("title14"),
    desc3: makeNodeComponent("desc3"),
    item20: makeNodeComponent("item20"),
    title15: makeNodeComponent("title15"),
    desc4: makeNodeComponent("desc4"),
    item21: makeNodeComponent("item21"),
    title16: makeNodeComponent("title16"),
    desc5: makeNodeComponent("desc5"),
    item22: makeNodeComponent("item22"),
    title17: makeNodeComponent("title17"),
    desc6: makeNodeComponent("desc6"),
    footnote: makeNodeComponent("footnote"),
    bodyWrapper6: makeNodeComponent("bodyWrapper6"),
    intro4: makeNodeComponent("intro4"),
    col7: makeNodeComponent("col7"),
    logo9: makeNodeComponent("logo9"),
    text44: makeNodeComponent("text44"),
    title27: makeNodeComponent("title27"),
    desc9: makeNodeComponent("desc9"),
    img4: makeNodeComponent("img4"),
    bg3: makeNodeComponent("bg3"),
    xmlid7457: makeNodeComponent("xmlid7457"),
    xmlid6776: makeNodeComponent("xmlid6776"),
    xmlid7433: makeNodeComponent("xmlid7433"),
    xmlid7339: makeNodeComponent("xmlid7339"),
    alert3: makeNodeComponent("alert3"),
    icon20: makeNodeComponent("icon20"),
    content3: makeNodeComponent("content3"),
    text45: makeNodeComponent("text45"),
    icon21: makeNodeComponent("icon21"),
    credits: makeNodeComponent("credits"),
    header20: makeNodeComponent("header20"),
    subtitle5: makeNodeComponent("subtitle5"),
    title28: makeNodeComponent("title28"),
    main6: makeNodeComponent("main6"),
    mockupCmeCredits: makeNodeComponent("mockupCmeCredits"),
    table: makeNodeComponent("table"),
    col8: makeNodeComponent("col8"),
    mockupTableCellText: makeNodeComponent("mockupTableCellText"),
    text46: makeNodeComponent("text46"),
    mockupTableCellAvatar: makeNodeComponent("mockupTableCellAvatar"),
    mockupTableCellAvatar2: makeNodeComponent("mockupTableCellAvatar2"),
    mockupTableCellAvatar3: makeNodeComponent("mockupTableCellAvatar3"),
    col9: makeNodeComponent("col9"),
    mockupTableCellText2: makeNodeComponent("mockupTableCellText2"),
    text47: makeNodeComponent("text47"),
    mockupTableCellText3: makeNodeComponent("mockupTableCellText3"),
    text48: makeNodeComponent("text48"),
    mockupTableCellText4: makeNodeComponent("mockupTableCellText4"),
    text49: makeNodeComponent("text49"),
    mockupTableCellText5: makeNodeComponent("mockupTableCellText5"),
    text50: makeNodeComponent("text50"),
    col10: makeNodeComponent("col10"),
    mockupTableCellText6: makeNodeComponent("mockupTableCellText6"),
    text51: makeNodeComponent("text51"),
    mockupTableCellText7: makeNodeComponent("mockupTableCellText7"),
    text52: makeNodeComponent("text52"),
    mockupTableCellText8: makeNodeComponent("mockupTableCellText8"),
    text57: makeNodeComponent("text57"),
    mockupTableCellText9: makeNodeComponent("mockupTableCellText9"),
    text58: makeNodeComponent("text58"),
    col11: makeNodeComponent("col11"),
    mockupTableCellText10: makeNodeComponent("mockupTableCellText10"),
    text59: makeNodeComponent("text59"),
    mockupTableCellText11: makeNodeComponent("mockupTableCellText11"),
    text60: makeNodeComponent("text60"),
    mockupTableCellText12: makeNodeComponent("mockupTableCellText12"),
    text70: makeNodeComponent("text70"),
    mockupTableCellText13: makeNodeComponent("mockupTableCellText13"),
    text71: makeNodeComponent("text71"),
    mockupButton7: makeNodeComponent("mockupButton7"),
    link10: makeNodeComponent("link10"),
    certificate: makeNodeComponent("certificate"),
    top5: makeNodeComponent("top5"),
    mockupCertificateIcon: makeNodeComponent("mockupCertificateIcon"),
    bg4: makeNodeComponent("bg4"),
    group1: makeNodeComponent("group1"),
    paper1: makeNodeComponent("paper1"),
    paper2: makeNodeComponent("paper2"),
    cert: makeNodeComponent("cert"),
    award491: makeNodeComponent("award491"),
    overlay: makeNodeComponent("overlay"),
    title29: makeNodeComponent("title29"),
    mockupTextPlaceholder: makeNodeComponent("mockupTextPlaceholder"),
    mockupTextPlaceholderParagraph: makeNodeComponent(
      "mockupTextPlaceholderParagraph"
    ),
    mockupTextPlaceholderLine: makeNodeComponent("mockupTextPlaceholderLine"),
    mockupTextPlaceholderContent37: makeNodeComponent(
      "mockupTextPlaceholderContent37"
    ),
    placeholder38: makeNodeComponent("placeholder38"),
    mockupTextPlaceholderLine2: makeNodeComponent("mockupTextPlaceholderLine2"),
    mockupTextPlaceholderContent38: makeNodeComponent(
      "mockupTextPlaceholderContent38"
    ),
    placeholder39: makeNodeComponent("placeholder39"),
    mockupTextPlaceholderLine3: makeNodeComponent("mockupTextPlaceholderLine3"),
    mockupTextPlaceholderContent39: makeNodeComponent(
      "mockupTextPlaceholderContent39"
    ),
    placeholder40: makeNodeComponent("placeholder40"),
    mockupTextPlaceholderLine4: makeNodeComponent("mockupTextPlaceholderLine4"),
    mockupTextPlaceholderContent40: makeNodeComponent(
      "mockupTextPlaceholderContent40"
    ),
    placeholder41: makeNodeComponent("placeholder41"),
    mockupTextPlaceholderLine5: makeNodeComponent("mockupTextPlaceholderLine5"),
    mockupTextPlaceholderContent41: makeNodeComponent(
      "mockupTextPlaceholderContent41"
    ),
    placeholder42: makeNodeComponent("placeholder42"),
    mockupTextPlaceholderParagraph2: makeNodeComponent(
      "mockupTextPlaceholderParagraph2"
    ),
    mockupTextPlaceholderLine6: makeNodeComponent("mockupTextPlaceholderLine6"),
    mockupTextPlaceholderContent42: makeNodeComponent(
      "mockupTextPlaceholderContent42"
    ),
    placeholder43: makeNodeComponent("placeholder43"),
    mockupTextPlaceholderLine7: makeNodeComponent("mockupTextPlaceholderLine7"),
    mockupTextPlaceholderContent43: makeNodeComponent(
      "mockupTextPlaceholderContent43"
    ),
    placeholder44: makeNodeComponent("placeholder44"),
    mockupTextPlaceholderLine8: makeNodeComponent("mockupTextPlaceholderLine8"),
    mockupTextPlaceholderContent44: makeNodeComponent(
      "mockupTextPlaceholderContent44"
    ),
    placeholder45: makeNodeComponent("placeholder45"),
    mockupTextPlaceholderLine9: makeNodeComponent("mockupTextPlaceholderLine9"),
    mockupTextPlaceholderContent45: makeNodeComponent(
      "mockupTextPlaceholderContent45"
    ),
    placeholder46: makeNodeComponent("placeholder46"),
    mockupTextPlaceholderLine10: makeNodeComponent(
      "mockupTextPlaceholderLine10"
    ),
    mockupTextPlaceholderContent46: makeNodeComponent(
      "mockupTextPlaceholderContent46"
    ),
    placeholder47: makeNodeComponent("placeholder47"),
    mockupTextPlaceholderLine11: makeNodeComponent(
      "mockupTextPlaceholderLine11"
    ),
    mockupTextPlaceholderContent47: makeNodeComponent(
      "mockupTextPlaceholderContent47"
    ),
    placeholder48: makeNodeComponent("placeholder48"),
    mockupTextPlaceholderLine12: makeNodeComponent(
      "mockupTextPlaceholderLine12"
    ),
    mockupTextPlaceholderContent48: makeNodeComponent(
      "mockupTextPlaceholderContent48"
    ),
    placeholder49: makeNodeComponent("placeholder49"),
    mockupTextPlaceholderLine13: makeNodeComponent(
      "mockupTextPlaceholderLine13"
    ),
    mockupTextPlaceholderContent49: makeNodeComponent(
      "mockupTextPlaceholderContent49"
    ),
    placeholder50: makeNodeComponent("placeholder50"),
    mockupTextPlaceholderParagraph3: makeNodeComponent(
      "mockupTextPlaceholderParagraph3"
    ),
    mockupTextPlaceholderLine14: makeNodeComponent(
      "mockupTextPlaceholderLine14"
    ),
    mockupTextPlaceholderContent50: makeNodeComponent(
      "mockupTextPlaceholderContent50"
    ),
    placeholder51: makeNodeComponent("placeholder51"),
    mockupTextPlaceholderLine15: makeNodeComponent(
      "mockupTextPlaceholderLine15"
    ),
    mockupTextPlaceholderContent15: makeNodeComponent(
      "mockupTextPlaceholderContent15"
    ),
    placeholder52: makeNodeComponent("placeholder52"),
    mockupTextPlaceholderLine16: makeNodeComponent(
      "mockupTextPlaceholderLine16"
    ),
    mockupTextPlaceholderContent16: makeNodeComponent(
      "mockupTextPlaceholderContent16"
    ),
    placeholder53: makeNodeComponent("placeholder53"),
    mockupTextPlaceholderLine17: makeNodeComponent(
      "mockupTextPlaceholderLine17"
    ),
    mockupTextPlaceholderContent17: makeNodeComponent(
      "mockupTextPlaceholderContent17"
    ),
    placeholder54: makeNodeComponent("placeholder54"),
    mockupTextPlaceholderLine18: makeNodeComponent(
      "mockupTextPlaceholderLine18"
    ),
    mockupTextPlaceholderContent18: makeNodeComponent(
      "mockupTextPlaceholderContent18"
    ),
    placeholder55: makeNodeComponent("placeholder55"),
    mockupTextPlaceholderParagraph4: makeNodeComponent(
      "mockupTextPlaceholderParagraph4"
    ),
    mockupTextPlaceholderLine19: makeNodeComponent(
      "mockupTextPlaceholderLine19"
    ),
    mockupTextPlaceholderContent19: makeNodeComponent(
      "mockupTextPlaceholderContent19"
    ),
    placeholder19: makeNodeComponent("placeholder19"),
    mockupTextPlaceholderLine20: makeNodeComponent(
      "mockupTextPlaceholderLine20"
    ),
    mockupTextPlaceholderContent20: makeNodeComponent(
      "mockupTextPlaceholderContent20"
    ),
    placeholder20: makeNodeComponent("placeholder20"),
    mockupTextPlaceholderLine21: makeNodeComponent(
      "mockupTextPlaceholderLine21"
    ),
    mockupTextPlaceholderContent21: makeNodeComponent(
      "mockupTextPlaceholderContent21"
    ),
    placeholder21: makeNodeComponent("placeholder21"),
    mockupTextPlaceholderLine22: makeNodeComponent(
      "mockupTextPlaceholderLine22"
    ),
    mockupTextPlaceholderContent22: makeNodeComponent(
      "mockupTextPlaceholderContent22"
    ),
    placeholder22: makeNodeComponent("placeholder22"),
    mockupTextPlaceholderLine23: makeNodeComponent(
      "mockupTextPlaceholderLine23"
    ),
    mockupTextPlaceholderContent23: makeNodeComponent(
      "mockupTextPlaceholderContent23"
    ),
    placeholder23: makeNodeComponent("placeholder23"),
    mockupTextPlaceholderLine24: makeNodeComponent(
      "mockupTextPlaceholderLine24"
    ),
    mockupTextPlaceholderContent24: makeNodeComponent(
      "mockupTextPlaceholderContent24"
    ),
    placeholder24: makeNodeComponent("placeholder24"),
    mockupTextPlaceholderLine25: makeNodeComponent(
      "mockupTextPlaceholderLine25"
    ),
    mockupTextPlaceholderContent25: makeNodeComponent(
      "mockupTextPlaceholderContent25"
    ),
    placeholder25: makeNodeComponent("placeholder25"),
    mockupTextPlaceholderLine26: makeNodeComponent(
      "mockupTextPlaceholderLine26"
    ),
    mockupTextPlaceholderContent26: makeNodeComponent(
      "mockupTextPlaceholderContent26"
    ),
    placeholder26: makeNodeComponent("placeholder26"),
    mockupButton8: makeNodeComponent("mockupButton8"),
    link11: makeNodeComponent("link11"),
    alert2: makeNodeComponent("alert2"),
    icon22: makeNodeComponent("icon22"),
    check2: makeNodeComponent("check2"),
    content4: makeNodeComponent("content4"),
    report: makeNodeComponent("report"),
    bill: makeNodeComponent("bill"),
    header21: makeNodeComponent("header21"),
    subtitle9: makeNodeComponent("subtitle9"),
    title30: makeNodeComponent("title30"),
    main7: makeNodeComponent("main7"),
    placeholder27: makeNodeComponent("placeholder27"),
    header22: makeNodeComponent("header22"),
    title31: makeNodeComponent("title31"),
    date: makeNodeComponent("date"),
    section: makeNodeComponent("section"),
    head: makeNodeComponent("head"),
    mockupTextPlaceholderParagraph5: makeNodeComponent(
      "mockupTextPlaceholderParagraph5"
    ),
    mockupTextPlaceholderLine27: makeNodeComponent(
      "mockupTextPlaceholderLine27"
    ),
    mockupTextPlaceholderContent27: makeNodeComponent(
      "mockupTextPlaceholderContent27"
    ),
    placeholder28: makeNodeComponent("placeholder28"),
    mockupTextPlaceholderLine28: makeNodeComponent(
      "mockupTextPlaceholderLine28"
    ),
    mockupTextPlaceholderContent28: makeNodeComponent(
      "mockupTextPlaceholderContent28"
    ),
    placeholder29: makeNodeComponent("placeholder29"),
    mockupTextPlaceholderLine29: makeNodeComponent(
      "mockupTextPlaceholderLine29"
    ),
    mockupTextPlaceholderContent29: makeNodeComponent(
      "mockupTextPlaceholderContent29"
    ),
    placeholder30: makeNodeComponent("placeholder30"),
    mockupTextPlaceholderLine30: makeNodeComponent(
      "mockupTextPlaceholderLine30"
    ),
    mockupTextPlaceholderContent30: makeNodeComponent(
      "mockupTextPlaceholderContent30"
    ),
    placeholder31: makeNodeComponent("placeholder31"),
    mockupTextPlaceholderLine31: makeNodeComponent(
      "mockupTextPlaceholderLine31"
    ),
    mockupTextPlaceholderContent31: makeNodeComponent(
      "mockupTextPlaceholderContent31"
    ),
    placeholder32: makeNodeComponent("placeholder32"),
    total: makeNodeComponent("total"),
    title32: makeNodeComponent("title32"),
    val6: makeNodeComponent("val6"),
    section2: makeNodeComponent("section2"),
    head2: makeNodeComponent("head2"),
    mockupTextPlaceholderParagraph6: makeNodeComponent(
      "mockupTextPlaceholderParagraph6"
    ),
    mockupTextPlaceholderLine32: makeNodeComponent(
      "mockupTextPlaceholderLine32"
    ),
    mockupTextPlaceholderContent32: makeNodeComponent(
      "mockupTextPlaceholderContent32"
    ),
    placeholder33: makeNodeComponent("placeholder33"),
    mockupTextPlaceholderLine33: makeNodeComponent(
      "mockupTextPlaceholderLine33"
    ),
    mockupTextPlaceholderContent33: makeNodeComponent(
      "mockupTextPlaceholderContent33"
    ),
    placeholder34: makeNodeComponent("placeholder34"),
    mockupTextPlaceholderLine34: makeNodeComponent(
      "mockupTextPlaceholderLine34"
    ),
    mockupTextPlaceholderContent34: makeNodeComponent(
      "mockupTextPlaceholderContent34"
    ),
    placeholder35: makeNodeComponent("placeholder35"),
    mockupTextPlaceholderLine35: makeNodeComponent(
      "mockupTextPlaceholderLine35"
    ),
    mockupTextPlaceholderContent35: makeNodeComponent(
      "mockupTextPlaceholderContent35"
    ),
    placeholder36: makeNodeComponent("placeholder36"),
    mockupTextPlaceholderLine36: makeNodeComponent(
      "mockupTextPlaceholderLine36"
    ),
    mockupTextPlaceholderContent36: makeNodeComponent(
      "mockupTextPlaceholderContent36"
    ),
    placeholder37: makeNodeComponent("placeholder37"),
    total2: makeNodeComponent("total2"),
    title34: makeNodeComponent("title34"),
    val7: makeNodeComponent("val7"),
    edge: makeNodeComponent("edge"),
    tri: makeNodeComponent("tri"),
    rect: makeNodeComponent("rect"),
    tri2: makeNodeComponent("tri2"),
    rect2: makeNodeComponent("rect2"),
    tri3: makeNodeComponent("tri3"),
    rect3: makeNodeComponent("rect3"),
    tri4: makeNodeComponent("tri4"),
    rect4: makeNodeComponent("rect4"),
    tri5: makeNodeComponent("tri5"),
    rect5: makeNodeComponent("rect5"),
    tri6: makeNodeComponent("tri6"),
    rect6: makeNodeComponent("rect6"),
    tri7: makeNodeComponent("tri7"),
    rect7: makeNodeComponent("rect7"),
    tri8: makeNodeComponent("tri8"),
    rect8: makeNodeComponent("rect8"),
    tri9: makeNodeComponent("tri9"),
    rect9: makeNodeComponent("rect9"),
    tri10: makeNodeComponent("tri10"),
    rect10: makeNodeComponent("rect10"),
    tri11: makeNodeComponent("tri11"),
    rect11: makeNodeComponent("rect11"),
    tri12: makeNodeComponent("tri12"),
    rect12: makeNodeComponent("rect12"),
    tri13: makeNodeComponent("tri13"),
    rect13: makeNodeComponent("rect13"),
    tri14: makeNodeComponent("tri14"),
    rect14: makeNodeComponent("rect14"),
    tri15: makeNodeComponent("tri15"),
    rect15: makeNodeComponent("rect15"),
    tri16: makeNodeComponent("tri16"),
    rect16: makeNodeComponent("rect16"),
    tri17: makeNodeComponent("tri17"),
    rect17: makeNodeComponent("rect17"),
    tri18: makeNodeComponent("tri18"),
    rect18: makeNodeComponent("rect18"),
    tri19: makeNodeComponent("tri19"),
    rect19: makeNodeComponent("rect19"),
    tri20: makeNodeComponent("tri20"),
    rect20: makeNodeComponent("rect20"),
    tri21: makeNodeComponent("tri21"),
    rect21: makeNodeComponent("rect21"),
    tri22: makeNodeComponent("tri22"),
    rect22: makeNodeComponent("rect22"),
    tri23: makeNodeComponent("tri23"),
    rect23: makeNodeComponent("rect23"),
    tri24: makeNodeComponent("tri24"),
    rect24: makeNodeComponent("rect24"),
    tri25: makeNodeComponent("tri25"),
    rect25: makeNodeComponent("rect25"),
    tri26: makeNodeComponent("tri26"),
    rect26: makeNodeComponent("rect26"),
    tri27: makeNodeComponent("tri27"),
    rect27: makeNodeComponent("rect27"),
    tri28: makeNodeComponent("tri28"),
    rect28: makeNodeComponent("rect28"),
    tri29: makeNodeComponent("tri29"),
    rect29: makeNodeComponent("rect29"),
    tri30: makeNodeComponent("tri30"),
    rect30: makeNodeComponent("rect30"),
    tri31: makeNodeComponent("tri31"),
    rect31: makeNodeComponent("rect31"),
    tri32: makeNodeComponent("tri32"),
    rect32: makeNodeComponent("rect32"),
    shade3: makeNodeComponent("shade3"),
    features3: makeNodeComponent("features3"),
    title33: makeNodeComponent("title33"),
    figmaPaste2: makeNodeComponent("figmaPaste2"),
    contentsItem10: makeNodeComponent("contentsItem10"),
    icon23: makeNodeComponent("icon23"),
    text61: makeNodeComponent("text61"),
    contentsItem11: makeNodeComponent("contentsItem11"),
    icon24: makeNodeComponent("icon24"),
    text62: makeNodeComponent("text62"),
    contentsItem12: makeNodeComponent("contentsItem12"),
    icon25: makeNodeComponent("icon25"),
    text63: makeNodeComponent("text63"),
    contentsItem13: makeNodeComponent("contentsItem13"),
    icon26: makeNodeComponent("icon26"),
    text64: makeNodeComponent("text64"),
    contentsItem14: makeNodeComponent("contentsItem14"),
    icon27: makeNodeComponent("icon27"),
    text65: makeNodeComponent("text65"),
    contentsItem15: makeNodeComponent("contentsItem15"),
    icon28: makeNodeComponent("icon28"),
    text66: makeNodeComponent("text66"),
    contentsItem16: makeNodeComponent("contentsItem16"),
    icon29: makeNodeComponent("icon29"),
    text67: makeNodeComponent("text67"),
    contentsItem17: makeNodeComponent("contentsItem17"),
    icon30: makeNodeComponent("icon30"),
    text68: makeNodeComponent("text68"),
    bodyWrapper5: makeNodeComponent("bodyWrapper5"),
    intro3: makeNodeComponent("intro3"),
    col5: makeNodeComponent("col5"),
    logo8: makeNodeComponent("logo8"),
    text: makeNodeComponent("text"),
    title18: makeNodeComponent("title18"),
    desc8: makeNodeComponent("desc8"),
    img3: makeNodeComponent("img3"),
    bg2: makeNodeComponent("bg2"),
    reimbursement: makeNodeComponent("reimbursement"),
    header11: makeNodeComponent("header11"),
    subtitle4: makeNodeComponent("subtitle4"),
    title19: makeNodeComponent("title19"),
    main4: makeNodeComponent("main4"),
    placeholder16: makeNodeComponent("placeholder16"),
    row: makeNodeComponent("row"),
    prop: makeNodeComponent("prop"),
    label10: makeNodeComponent("label10"),
    val: makeNodeComponent("val"),
    prop2: makeNodeComponent("prop2"),
    label11: makeNodeComponent("label11"),
    val2: makeNodeComponent("val2"),
    mockupProgressBarWithTitle: makeNodeComponent("mockupProgressBarWithTitle"),
    header12: makeNodeComponent("header12"),
    title20: makeNodeComponent("title20"),
    val3: makeNodeComponent("val3"),
    bar: makeNodeComponent("bar"),
    value: makeNodeComponent("value"),
    demographics: makeNodeComponent("demographics"),
    demographics2: makeNodeComponent("demographics2"),
    header13: makeNodeComponent("header13"),
    subtitle7: makeNodeComponent("subtitle7"),
    title4: makeNodeComponent("title4"),
    main5: makeNodeComponent("main5"),
    placeholder17: makeNodeComponent("placeholder17"),
    row2: makeNodeComponent("row2"),
    header14: makeNodeComponent("header14"),
    name6: makeNodeComponent("name6"),
    error: makeNodeComponent("error"),
    tip: makeNodeComponent("tip"),
    label3: makeNodeComponent("label3"),
    link6: makeNodeComponent("link6"),
    row6: makeNodeComponent("row6"),
    header15: makeNodeComponent("header15"),
    name7: makeNodeComponent("name7"),
    error2: makeNodeComponent("error2"),
    tip2: makeNodeComponent("tip2"),
    label4: makeNodeComponent("label4"),
    link7: makeNodeComponent("link7"),
    row7: makeNodeComponent("row7"),
    header16: makeNodeComponent("header16"),
    name8: makeNodeComponent("name8"),
    error3: makeNodeComponent("error3"),
    tip3: makeNodeComponent("tip3"),
    label5: makeNodeComponent("label5"),
    link8: makeNodeComponent("link8"),
    shade2: makeNodeComponent("shade2"),
    cap: makeNodeComponent("cap"),
    header17: makeNodeComponent("header17"),
    subtitle8: makeNodeComponent("subtitle8"),
    title21: makeNodeComponent("title21"),
    main3: makeNodeComponent("main3"),
    placeholder18: makeNodeComponent("placeholder18"),
    field: makeNodeComponent("field"),
    label6: makeNodeComponent("label6"),
    select: makeNodeComponent("select"),
    input: makeNodeComponent("input"),
    leftIcon: makeNodeComponent("leftIcon"),
    text25: makeNodeComponent("text25"),
    rightIcon: makeNodeComponent("rightIcon"),
    row5: makeNodeComponent("row5"),
    prop3: makeNodeComponent("prop3"),
    label7: makeNodeComponent("label7"),
    val4: makeNodeComponent("val4"),
    prop4: makeNodeComponent("prop4"),
    label8: makeNodeComponent("label8"),
    val5: makeNodeComponent("val5"),
    profile3: makeNodeComponent("profile3"),
    av3: makeNodeComponent("av3"),
    col6: makeNodeComponent("col6"),
    top4: makeNodeComponent("top4"),
    header18: makeNodeComponent("header18"),
    name9: makeNodeComponent("name9"),
    status3: makeNodeComponent("status3"),
    label9: makeNodeComponent("label9"),
    body8: makeNodeComponent("body8"),
    year3: makeNodeComponent("year3"),
    name5: makeNodeComponent("name5"),
    actions3: makeNodeComponent("actions3"),
    mockupButton5: makeNodeComponent("mockupButton5"),
    link9: makeNodeComponent("link9"),
    mockupButton6: makeNodeComponent("mockupButton6"),
    link5: makeNodeComponent("link5"),
    menu2: makeNodeComponent("menu2"),
    header19: makeNodeComponent("header19"),
    title22: makeNodeComponent("title22"),
    icon8: makeNodeComponent("icon8"),
    list: makeNodeComponent("list"),
    item23: makeNodeComponent("item23"),
    text26: makeNodeComponent("text26"),
    item24: makeNodeComponent("item24"),
    text4: makeNodeComponent("text4"),
    item25: makeNodeComponent("item25"),
    text27: makeNodeComponent("text27"),
    item26: makeNodeComponent("item26"),
    text28: makeNodeComponent("text28"),
    item27: makeNodeComponent("item27"),
    text29: makeNodeComponent("text29"),
    item28: makeNodeComponent("item28"),
    text30: makeNodeComponent("text30"),
    item29: makeNodeComponent("item29"),
    text31: makeNodeComponent("text31"),
    item30: makeNodeComponent("item30"),
    text32: makeNodeComponent("text32"),
    item31: makeNodeComponent("item31"),
    text33: makeNodeComponent("text33"),
    item32: makeNodeComponent("item32"),
    text34: makeNodeComponent("text34"),
    alert: makeNodeComponent("alert"),
    icon9: makeNodeComponent("icon9"),
    content2: makeNodeComponent("content2"),
    text35: makeNodeComponent("text35"),
    icon10: makeNodeComponent("icon10"),
    features: makeNodeComponent("features"),
    title5: makeNodeComponent("title5"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    contentsItem: makeNodeComponent("contentsItem"),
    icon11: makeNodeComponent("icon11"),
    text36: makeNodeComponent("text36"),
    contentsItem2: makeNodeComponent("contentsItem2"),
    icon12: makeNodeComponent("icon12"),
    text37: makeNodeComponent("text37"),
    contentsItem3: makeNodeComponent("contentsItem3"),
    icon13: makeNodeComponent("icon13"),
    text38: makeNodeComponent("text38"),
    contentsItem4: makeNodeComponent("contentsItem4"),
    icon14: makeNodeComponent("icon14"),
    text39: makeNodeComponent("text39"),
    contentsItem5: makeNodeComponent("contentsItem5"),
    icon15: makeNodeComponent("icon15"),
    text5: makeNodeComponent("text5"),
    contentsItem6: makeNodeComponent("contentsItem6"),
    icon16: makeNodeComponent("icon16"),
    text40: makeNodeComponent("text40"),
    contentsItem7: makeNodeComponent("contentsItem7"),
    icon17: makeNodeComponent("icon17"),
    text41: makeNodeComponent("text41"),
    contentsItem8: makeNodeComponent("contentsItem8"),
    icon18: makeNodeComponent("icon18"),
    text42: makeNodeComponent("text42"),
    contentsItem9: makeNodeComponent("contentsItem9"),
    icon19: makeNodeComponent("icon19"),
    text43: makeNodeComponent("text43"),
    mobileWrapper: makeNodeComponent("mobileWrapper"),
    header: makeNodeComponent("header"),
    top: makeNodeComponent("top"),
    subtitle2: makeNodeComponent("subtitle2"),
    title2: makeNodeComponent("title2"),
    body: makeNodeComponent("body"),

    // Metadata about props expected for PlasmicHomeProductsSection
    internalVariantProps: PlasmicHomeProductsSection__VariantProps,
    internalArgProps: PlasmicHomeProductsSection__ArgProps
  }
);

export default PlasmicHomeProductsSection;
/* prettier-ignore-end */
